/*
 *  ___                  __                __  _ _
 *   | |_  _     _ |_ |_|_    _  _ _ _ _  /  \(_(_|. _  _
 *   | | )(_)|_|(_)| )|_|__)(|_)| (-_)_)  \__/| | ||| )(-
 *              _/           |
 */
import dayjs from 'dayjs'
import {
  createItem,
  createButton,
  slugify,
} from '../../../../src/core/dataitems'

const thisYear = dayjs().year()
export const pages = {
  'confirm-cancel': {
    modal: true,
    text: [],
    buttons: [
      { label: 'Yes', id: 'yes', uid: '0baa62eba1b1a7d7', control: true },
      { label: 'No', id: 'no', uid: '6c0e0e2956ec3933', control: true },
    ],
    item: {
      id: 'message',
      type: 'text',
      readonly: true,
      label: 'Message',
      uid: '9bc15702a2e49228',
      content: ['Are you sure you want to cancel this application?'],
    },
    title: 'Public Access \n Welcome to Elac',
  },
  'quotation-screen': {
    text: [],
    buttons: [
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'quote-screen',
      type: 'list',
      readonly: false,
      label: 'Quote Screen',
      uid: '6fee8049c5c94877',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '552d19e7a2f676a3',
          content: '<h2>Choose your cover</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'a1fcd090d9138ba4',
          content:
            '<p>To be able to provide you with a quick quotation we will need the following information from you.</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '56dfc210727e82c4',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='clickable'><a href='#details'>Details</a></li>\n<li class='clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'quote-details',
          type: 'list',
          readonly: false,
          label: 'Quote Details',
          uid: '4d9cd7a325b6f840',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'f2702e01f97244c4',
              content: '<p>Who will be the owner of this policy?</p>\n',
            },
            {
              id: 'owner-radio-group',
              type: 'list',
              readonly: false,
              label: 'Owner Radio Group',
              uid: '614c3de768a6def5',
              content: [
                {
                  id: 'policy-for-myself',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'I am taking out this policy for myself',
                  uid: '508eef1d6e0e551b',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'policy-for-wife',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'I am taking out this policy for my wife',
                  uid: 'faac53826d4f66a3',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
              ],
            },
            {
              id: 'system-list',
              type: 'list',
              readonly: false,
              label: 'System List',
              uid: 'e148ae77f2c6adeb',
              content: [
                {
                  id: 'life-assured-details',
                  type: 'list',
                  readonly: false,
                  label: 'Life Assured Details',
                  uid: '21a3110f0d1a90af',
                  content: [
                    {
                      id: 'system-field-outcome',
                      type: 'html',
                      readonly: true,
                      label: '',
                      uid: 'd91428d1aac8027a',
                      content: '<p>When were you born?</p>\n',
                    },
                    {
                      id: 'date-of-birth',
                      type: 'component',
                      elementType: 'input',
                      readonly: false,
                      label: 'Date Of Birth',
                      uid: '9fdf0fd5a0b498de',
                      content: '',
                      publishChange: true,
                      errors: ['*'],
                      inputType: 'date',
                      component: 'DateSelector',
                      maxYear: thisYear,
                    },
                    {
                      id: 'system-list',
                      type: 'list',
                      readonly: false,
                      label: 'System List',
                      uid: 'bb1b10fbc7c779d2',
                      content: [
                        {
                          id: 'system-constant',
                          type: 'html',
                          readonly: true,
                          label: '',
                          uid: '70680e144e48a519',
                          content: '<p>What is your marital status?</p>\n',
                        },
                        {
                          id: 'marital-status',
                          type: 'field',
                          elementType: 'select',
                          readonly: false,
                          label: 'Marital Status',
                          uid: 'b072d11b8e5308c1',
                          content: 'Married',
                          publishChange: true,
                          tooltip: 'Marital Status',
                          options: [
                            '',
                            'Divorced',
                            'Married',
                            'Single',
                            'Widow',
                            'Widower',
                          ],
                        },
                      ],
                    },
                    {
                      id: 'system-constant',
                      type: 'html',
                      readonly: true,
                      label: '',
                      uid: 'd805d08512586468',
                      content:
                        '<p>Gender (Only females can be the life assured on this policy)</p>\n',
                    },
                    {
                      id: 'gender',
                      type: 'field',
                      elementType: 'input',
                      readonly: true,
                      label: 'Gender',
                      uid: 'cf02efe854ee2b1a',
                      content: 'Female',
                      inputType: 'text',
                    },
                  ],
                },
                {
                  content: [
                    {
                      content: '<p>When was your wife born?</p>\n',
                      id: 'system-field-outcome',
                      label: '',
                      readonly: true,
                      type: 'html',
                      uid: 'b0403d825e7b7376',
                    },
                    {
                      component: 'DateSelector',
                      content: '',
                      elementType: 'input',
                      errors: ['*'],
                      id: 'date-of-birth',
                      inputType: 'date',
                      label: 'Date Of Birth',
                      maxYear: thisYear,
                      publishChange: true,
                      readonly: false,
                      type: 'component',
                      uid: '9fdf0fd5a0b498de',
                    },
                    {
                      content:
                        '<p>Gender (Only females can be the life assured on this policy)</p>\n',
                      id: 'system-constant',
                      label: '',
                      readonly: true,
                      type: 'html',
                      uid: 'd805d08512586468',
                    },
                    {
                      content: 'Female',
                      elementType: 'input',
                      id: 'gender',
                      inputType: 'text',
                      label: 'Gender',
                      readonly: true,
                      type: 'field',
                      uid: 'cf02efe854ee2b1a',
                    },
                  ],
                  id: 'wife-details',
                  label: 'Life Assured Details',
                  readonly: false,
                  type: 'list',
                  uid: 'af7bfb3d63b46b1c',
                },
                {
                  id: 'risk-benefit',
                  type: 'list',
                  readonly: false,
                  label: 'Risk Benefit',
                  uid: '9a38c81a0adaf64f',
                  content: [
                    {
                      id: 'accelerated-cover-sum-assured',
                      type: 'amount',
                      elementType: 'input',
                      readonly: false,
                      label: 'Accelerated Cover Sum Assured',
                      uid: '461aaa5e3938ffb3',
                      content: '',
                      publishChange: true,
                      inputType: 'number',
                    },
                  ],
                },
                {
                  id: 'policy-term-option',
                  type: 'list',
                  readonly: false,
                  label: 'Policy Term Option',
                  uid: 'e6bb28151c8b7745',
                  content: [
                    {
                      id: 'system-constant',
                      type: 'html',
                      readonly: true,
                      label: '',
                      uid: '9401b4785ddc9bbb',
                      content: '<p>Please select a policy term.</p>\n',
                    },
                    {
                      id: 'term-in-years',
                      type: 'integer',
                      elementType: 'select',
                      readonly: false,
                      label: 'Term In Years',
                      uid: '863e9d8e2d59be12',
                      content: '',
                      publishChange: true,
                      errors: ['*'],
                      options: [
                        '',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                        '10',
                        '11',
                        '12',
                        '13',
                        '14',
                        '15',
                        '16',
                        '17',
                        '18',
                        '19',
                        '20',
                        '21',
                        '22',
                        '23',
                        '24',
                        '25',
                        '26',
                        '27',
                        '28',
                        '29',
                        '30',
                        '31',
                        '32',
                        '33',
                        '34',
                        '35',
                        '36',
                        '37',
                        '38',
                        '39',
                        '40',
                        '41',
                        '42',
                      ],
                    },
                  ],
                },
                {
                  id: 'premium-update',
                  type: 'list',
                  readonly: false,
                  label: 'Premium Update',
                  uid: '4ee80d9a0d4cf49e',
                  content: [
                    {
                      id: 'system-constant',
                      type: 'html',
                      readonly: true,
                      label: '',
                      uid: '4187b70810bf417d',
                      content:
                        '<p>Do you want to add automatic annual payment and benefit increases. If so - please select the level of payment rate increase you want to apply</p>\n',
                    },
                    {
                      id: 'update-option',
                      type: 'field',
                      elementType: 'select',
                      readonly: false,
                      label: 'Update Option',
                      uid: '4875405899c27566',
                      content: '',
                      publishChange: true,
                      errors: ['*'],
                      options: ['', '0', '5', '10', '15', '20', '25', '30'],
                    },
                  ],
                },
                {
                  id: 'embedded-benefits',
                  type: 'list',
                  readonly: true,
                  label: 'Embedded Benefits',
                  uid: 'ada127db5fd94251',
                  content: [
                    {
                      id: 'system-constant',
                      type: 'html',
                      readonly: true,
                      label: '',
                      uid: 'd329ce7b09ddfacc',
                      content:
                        '<p>This policy include the following embedded benefits:</p>\n',
                    },
                    {
                      id: 'system-constant',
                      type: 'html',
                      readonly: true,
                      label: '',
                      uid: '7082ffa79bf92d95',
                      content: '<p>I. Female Related Illness</p>\n',
                    },
                    {
                      id: 'system-constant',
                      type: 'html',
                      readonly: true,
                      label: '',
                      uid: '09c32d2aa558b7ec',
                      content: '<p>II. Ultimate Lady</p>\n',
                    },
                    {
                      id: 'system-constant',
                      type: 'html',
                      readonly: true,
                      label: '',
                      uid: 'c487aa9acf3acb28',
                      content: '<p>III. Free Child Benefit</p>\n',
                    },
                    {
                      id: 'system-constant',
                      type: 'html',
                      readonly: true,
                      label: '',
                      uid: 'b78f35218a465b8d',
                      content: '<p>IV. Medical Reimbursement</p>\n',
                    },
                  ],
                },
              ],
            },
            {
              id: 'quotation-panel',
              type: 'list',
              readonly: true,
              label: 'Quotation Panel',
              uid: 'c5411bee656edebe',
              content: [
                {
                  id: 'quotation-information',
                  type: 'list',
                  readonly: true,
                  label: 'Quotation Information',
                  uid: 'dc5e0f5384562716',
                  content: [
                    {
                      id: 'system-constant',
                      type: 'html',
                      readonly: true,
                      label: '',
                      uid: 'd56f1e879adce2a7',
                      content: '<p>Bloom</p>\n',
                    },
                    {
                      id: 'benefit-rate',
                      type: 'amount',
                      elementType: 'input',
                      readonly: true,
                      label: 'Benefit Rate',
                      uid: '3d338d89cad1e990',
                      content: '0.00',
                      inputType: 'number',
                    },
                    {
                      id: 'premium',
                      type: 'amount',
                      elementType: 'input',
                      readonly: true,
                      label: 'Premium',
                      uid: '6fbcefe3019f5efb',
                      content: '0.00',
                      inputType: 'number',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Ladycare Enhanced Quotation Details',
    uri: 'ladycare-plus/quote',
    class: 'ladycare-enhanced-quotation-details',
  },
  'additional-benefits': {
    text: [],
    buttons: [
      {
        label: 'Add child',
        id: 'add-child',
        uid: '217e315ad5d7f204',
        control: false,
      },
      {
        label: 'Remove child',
        id: 'remove-child',
        uid: 'eaabf8e6af070446',
        control: false,
      },
      {
        label: 'Edit child',
        id: 'edit-child',
        uid: '95c37b3fbdb23161',
        control: false,
      },
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'benefits',
      type: 'list',
      readonly: false,
      label: 'Benefits',
      uid: '911dadb065eb7dba',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'f0a65bd313a06372',
          content: '<h2>Choose your additional benefits</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '369a3e7b4c3ae508',
          content:
            '<p>Please indicate which additional benefits you would like to add to your plan:</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: 'c0c5c3fbd28aebe3',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='clickable'><a href='#details'>Details</a></li>\n<li class='clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'hospitalisation-benefit',
          type: 'list',
          readonly: false,
          label: 'Hospitalisation Benefit',
          uid: 'ee9fb49be1a56212',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'e08b58515d91e296',
              content:
                '<p>This benefit option provides the Policyholder with daily fixed benefits for when the policyholder is hospitilized for more than 3 days.</p>\n',
            },
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '366b3007a0a514a2',
              content:
                '<p>Please select a option (unit) below based on the fixed daily benefit you require.</p>\n',
            },
            {
              id: 'hospitalisation-units',
              type: 'amount',
              elementType: 'select',
              readonly: false,
              label: 'Hospitalisation Units',
              uid: '6ce87204e0039062',
              content: '',
              publishChange: true,
              options: ['', '50', '80', '100', '120', '150', '200'],
            },
          ],
        },
        {
          id: 'educational-support-benefit',
          type: 'list',
          readonly: false,
          label: 'Educational Support Benefit',
          uid: '9ed3c728f56fac6b',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '06ecd7aad8126d3f',
              content:
                '<p>This benefit is designed to support the educational needs of the Policyholder’s beneficiary (ies).</p>\n',
            },
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'e50b7cdb02088aea',
              content: '<p>The term must be between 5 - 18 years.</p>\n',
            },
            {
              id: 'educational-support-premium',
              type: 'amount',
              elementType: 'input',
              readonly: false,
              label: 'Educational Support Benefit',
              uid: 'f6d5df54dd11243c',
              content: '',
              publishChange: true,
              inputType: 'number',
            },
            {
              id: 'educational-support-term',
              type: 'integer',
              elementType: 'select',
              readonly: false,
              label: 'Educational Support Term',
              uid: '5fe74e216bff3189',
              content: '',
              publishChange: true,
              options: [
                '',
                '5',
                '6',
                '7',
                '8',
                '9',
                '10',
                '11',
                '12',
                '13',
                '14',
                '15',
                '16',
                '17',
                '18',
              ],
            },
          ],
        },
        {
          id: 'retirement-benefit',
          type: 'list',
          readonly: false,
          label: 'Retirement Benefit',
          uid: 'deacda7e8380977b',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'e902a3e337a27b44',
              content:
                '<p>This benefit provides the policyholder with the option to save for retirement.</p>\n',
            },
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'd03dc470893f5204',
              content:
                '<p>The minimum premium is GHS200.00 and the maximum premium is GHS5000.00</p>\n',
            },
            {
              id: 'retirement-premium',
              type: 'amount',
              elementType: 'input',
              readonly: false,
              label: 'Retirement Premium',
              uid: 'f7d782412da539dc',
              content: '',
              publishChange: true,
              inputType: 'number',
            },
          ],
        },
        {
          id: 'maternity-complication-benefit',
          type: 'list',
          readonly: false,
          label: 'Maternity Complication Benefit',
          uid: '3a74fdadb012206e',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '47b18cc5e73584c0',
              content:
                '<p>This option will cover the following: Ectopic pregnancy, Miscarriage due to accident, Pre-Eclampsia and Disseminated intravascular coagulation, Placenta Abruptio, Placenta Previa, Post-Partum Hemorrhage,</p>\n',
            },
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'bd0bb9015bc9c200',
              content:
                '<p>Cervical Incompetent, Gestational Diabetes, Molar Pregnancy Intrauterine FetalDeath.</p>\n',
            },
            {
              id: 'maternity-complications',
              type: 'field',
              elementType: 'checkbox',
              readonly: false,
              label: 'Maternity Complications',
              uid: 'a7af2b9f529b6236',
              content: '',
              publishChange: true,
              options: ['Y', 'N'],
            },
          ],
        },
        {
          id: 'spouse-risk-benefit',
          type: 'list',
          readonly: false,
          label: 'Spouse Risk Benefit',
          uid: '2af8934c7df5b4e5',
          content: [
            {
              id: 'system-field-outcome',
              type: 'html',
              readonly: true,
              label: '',
              uid: '5f36ba22ce739d00',
              content:
                '<p>This cover can be selected to cover your life (as the husband of the Life assured) with Death or Total Permanent Disability cover.</p>\n',
            },
            {
              id: 'system-field-outcome',
              type: 'html',
              readonly: true,
              label: '',
              uid: '5484d75e04e20d51',
              content:
                '<p>This cover can be selected to cover the life of your spouse (your husband) with Death or Total Permanent Disability cover.</p>\n',
            },
            {
              id: 'spouse-cover',
              type: 'field',
              elementType: 'checkbox',
              readonly: false,
              label: 'Spouse Cover',
              uid: '9995466d3b2a7060',
              content: '',
              publishChange: true,
              options: ['Y', 'N'],
            },
            {
              id: 'spouse-details',
              type: 'list',
              readonly: false,
              label: 'Spouse Details',
              uid: '9c466b21863c0957',
              content: [
                {
                  id: 'system-field-outcome',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '44f8c3d1bf29507d',
                  content:
                    '<p>Please specify <em>your</em> date of birth:</p>\n',
                },
                {
                  id: 'system-field-outcome',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'd22e6ef8d3161fd4',
                  content: '<p>Please specify spouse date of birth:</p>\n',
                },
                {
                  id: 'date-of-birth',
                  type: 'component',
                  elementType: 'input',
                  readonly: false,
                  label: 'Date Of Birth',
                  uid: '049aeb66ba8cd4f2',
                  content: '',
                  publishChange: true,
                  errors: ['*', '*'],
                  inputType: 'date',
                  component: 'DateSelector',
                  maxYear: thisYear,
                },
              ],
            },
          ],
        },
        {
          id: 'cash-bonus',
          type: 'list',
          readonly: false,
          label: 'Cash Bonus',
          uid: '18b2f895c17a36b8',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '49419ed6beb3b1b1',
              content:
                '<p>It is purely investment, a structured, disciplined way to save, at a good return.</p>\n',
            },
            {
              id: 'cash-bonus-premium',
              type: 'amount',
              elementType: 'input',
              readonly: false,
              label: 'Cash Bonus Premium',
              uid: '11b42ab7df218f48',
              content: '0.00',
              publishChange: true,
              inputType: 'number',
            },
          ],
        },
        {
          id: 'child-cover',
          type: 'list',
          readonly: true,
          label: 'Child Cover',
          uid: '67a41f11e72aab5a',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '768608dfdce3b9f9',
              content:
                '<p>Please add any children you would like to cover for Babycare or include in the free death benefit.</p>\n',
            },
            {
              id: 'ladycare-child-added-basic',
              type: 'table',
              readonly: true,
              label: 'Ladycare Child Added Basic',
              uid: '2ce7daf3cd7fd585',
              content: [],
            },
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '58c7a749feeb5cdb',
              content: "<p><a href='#add-child'>Add Child</a></p>\n",
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '5f18cfab5c38444a',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: '4101267085c73a76',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '2e40b6ad0d847b7a',
                  content: '<p>Bloom</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '512f56bfa719edab',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'c7c71551c4ee3fc8',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Ladycare Additional Benefits',
    uri: 'ladycare/policyholder-additional-benefits',
    template: 'ladycare-app-template',
    class: 'ladycare-additional-benefits',
  },
  'premium-validate': {
    modal: true,
    text: [],
    buttons: [
      {
        label: 'Done',
        id: 'done',
        uid: '4e5f7031a7643ff6',
        control: true,
      },
    ],
    item: {
      id: 'message',
      type: 'text',
      readonly: true,
      label: 'Message',
      uid: '9df131e41b9ed52f',
      content: [
        ' The minimum premium is 100. Please select additional cover in order to meet this requirement.',
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Ladycare Additional Benefits',
    uri: 'ladycare/policyholder-additional-benefits',
    template: 'ladycare-app-template',
    class: 'ladycare-additional-benefits',
  },
  'add-child': {
    modal: true,
    text: [],
    buttons: [],
    item: {
      id: 'message',
      type: 'text',
      readonly: true,
      label: 'Message',
      uid: '09799f5f9f5ddc09',
      content: ["Please specify your child's role"],
    },
    title: 'Public Access \n Welcome to Elac',
  },
  'child-cover': {
    modal: true,
    text: [],
    buttons: [
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
    ],
    item: {
      id: 'additional-child-details',
      type: 'list',
      readonly: false,
      label: 'Additional Child Details',
      uid: '1aa0a6c13aa5fc2a',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '3c79746d2b9dd7fb',
          content:
            '<p>Please select an age between 0 and 21 for your child</p>\n',
        },
        {
          id: 'age-of-child',
          type: 'integer',
          elementType: 'select',
          readonly: false,
          label: 'Age Of Child',
          uid: 'a17e4d819a5341d1',
          content: '',
          publishChange: true,
          tooltip: 'Age Of Child',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '03b0ae2a5a868c6b',
          content:
            '<p>Please select the benefit/s you would like to add for this child</p>\n',
        },
        {
          id: 'system-list',
          type: 'list',
          readonly: false,
          label: 'System List',
          uid: '12585a9631c78b2e',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'c58e74c1705e7961',
              content:
                '<p>Add the free child death benefit (max 4 children)</p>\n',
            },
            {
              id: 'free-child-cover',
              type: 'field',
              elementType: 'checkbox',
              readonly: false,
              label: 'Free Child Cover',
              uid: 'ecd96aef0bc35037',
              content: '',
              publishChange: true,
              options: ['Y', 'N'],
            },
          ],
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '732f97d0b07b66a7',
          content: '<p>Add BABYCARE for this child</p>\n',
        },
        {
          id: 'babycare-benefit',
          type: 'field',
          elementType: 'checkbox',
          readonly: false,
          label: 'Babycare',
          uid: '8a6188b2861a4fc8',
          content: '',
          publishChange: true,
          options: ['Y', 'N'],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
  },
  'remove-children': {
    modal: true,
    text: [],
    buttons: [
      {
        label: '',
        id: '',
        uid: 'bfb0a1ef332e5a00',
        control: false,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'message',
      type: 'text',
      readonly: true,
      label: 'Message',
      uid: '4981e8376bfbfbd8',
      content: [
        'Please select the person you would like to remove from the policy',
      ],
    },
    title: 'Public Access \n Welcome to Elac',
  },
  'edit-child': {
    modal: true,
    text: [],
    buttons: [],
    item: {
      id: 'message',
      type: 'text',
      readonly: true,
      label: 'Message',
      uid: '4981e8376bfbfbd8',
      content: [
        'Please select the person whose details you would like to edit',
      ],
    },
    title: 'Public Access \n Welcome to Elac',
  },
  'life-assured-identification': {
    text: [],
    buttons: [
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'life-assured-personal-details',
      type: 'list',
      readonly: false,
      label: 'Life Assured Personal Details',
      uid: '200b42bbbef3691b',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '3f77a7ce65bed955',
          content: '<h2>Life assured details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '106705cae52da51a',
          content:
            '<p>For us to complete the purchase, we require the following information</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: 'fc9b3639e47d8bdf',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'life-assured-details',
          type: 'list',
          readonly: false,
          label: 'Life Assured Details',
          uid: 'dcf45b4822aa38b4',
          content: [
            {
              id: 'first-names',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'First Names',
              uid: '71e91c6c4884ea0a',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'surname',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Surname',
              uid: 'e3664bfbd3d7ffc2',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'idpassport-number',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'ID/Passport Number',
              uid: '1aeb844cc52883bf',
              content: '',
              publishChange: true,
              inputType: 'text',
            },
            {
              id: 'id-type-radio-group',
              type: 'list',
              readonly: false,
              label: 'ID Type Radio Group',
              uid: '7211222c0ea73609',
              content: [
                {
                  id: 'dvla',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Dvla',
                  uid: 'f5f52bda274220fd',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'passport',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Passport',
                  uid: 'eaca79433b9af064',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'voter-id',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Voter ID',
                  uid: 'fe23a43e17b769b1',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'nhis',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Nhis',
                  uid: '22eb0bdae4c279a8',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'ssnit',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Ssnit',
                  uid: '5f5475b9d231e312',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'nia-ghana-card',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Nia Ghana Card',
                  uid: '7b1a43ee345d3430',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
              ],
            },
            {
              id: 'title',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Title',
              uid: '629c7e3110b14ddf',
              content: '',
              publishChange: true,
              errors: ['*'],
              tooltip: 'Title',
              options: [
                '',
                'Adv',
                'Dr',
                'Miss',
                'Mr',
                'Mrs',
                'Ms',
                'Prof',
                'Rev',
              ],
            },
            {
              id: 'gender',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Gender',
              uid: '06b31b9b294376ee',
              content: '',
              inputType: 'text',
            },
            {
              id: 'date-of-birth',
              type: 'integer',
              elementType: 'input',
              readonly: true,
              label: 'Date Of Birth',
              uid: 'c5485a065c245854',
              content: '',
              inputType: 'number',
            },
            {
              id: 'birth-place',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Birth Place',
              uid: 'ebf403ee0e0f1711',
              content: '',
              publishChange: true,
              inputType: 'text',
            },
            {
              id: 'marital-status',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Marital Status',
              uid: '475651361563a409',
              content: '',
              tooltip: 'Marital Status',
              inputType: 'text',
            },
            {
              id: 'tin-number',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Tin Number',
              uid: 'f871e270d0653cc8',
              content: '',
              publishChange: true,
              inputType: 'text',
            },
            {
              id: 'ghanaian',
              type: 'field',
              elementType: 'checkbox',
              readonly: false,
              label: 'Ghanaian',
              uid: 'eeba4a5ef5170d29',
              content: '',
              publishChange: true,
              options: ['Y', 'N'],
            },
            {
              id: 'other-nationality',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Other Nationality',
              uid: '4265b3030f240341',
              content: '',
              publishChange: true,
              tooltip: 'Other Nationality',
              options: [
                '',
                'Afghan',
                'Albanian',
                'Algerian',
                'American',
                'Andorran',
                'Angolan',
                'Argentine',
                'Armenian',
                'Aromanian',
                'Aruban',
                'Australian',
                'Austrian',
                'Azerbaijani',
                'Bahamian',
                'Bahraini',
                'Baltic German',
                'Baltic Russian',
                'Bangladeshi',
                'Barbadian',
                'Belarusian',
                'Belgian',
                'Belizean',
                'Bermudian',
                'Boer',
                'Bosniak',
                'Brazilian',
                'Breton',
                'British',
                'British Virgin Islander',
                'Bruneian',
                'Bulgarian',
                'Burkinabè',
                'Burundian',
                'Cambodian',
                'Cameroonian',
                'Canadian',
                'Cape Verdean',
                'Catalan',
                'Chadian',
                'Chilean',
                'Chinese',
                'Colombian',
                'Comorian',
                'Congolese',
                'Croatian',
                'Cuban',
                'Cypriot',
                'Czech',
                'Dane',
                'Dominican (Commonwealth)',
                'Dominican (Republic)',
                'Dutch',
                'East Timorese',
                'Ecuadorian',
                'Egyptian',
                'Emirati',
                'English',
                'Eritrean',
                'Estonian',
                'Ethiopian',
                'Falkland Islander',
                'Faroese',
                'Fijian',
                'Filipino',
                'Finn',
                'Finnish Swedish',
                'French Citizen',
                'Georgian',
                'German',
                'Ghanaian',
                'Gibraltar',
                'Greek',
                'Greek Macedonian',
                'Grenadian',
                'Guatemalan',
                'Guianese (French)',
                'Guinea Bissau National',
                'Guinean',
                'Guyanese',
                'Haitian',
                'Honduran',
                'Hong Kong',
                'Hungarian',
                'I Kiribati',
                'Icelander',
                'Indian',
                'Indonesian',
                'Iranian',
                'Iraqi',
                'Irish',
                'Israeli',
                'Italian',
                'Ivoirian',
                'Jamaican',
                'Japanese',
                'Jordanian',
                'Kazakh',
                'Kenyan',
                'Korean',
                'Kosovar',
                'Kurd',
                'Kuwaiti',
                'Kyrgyz',
                'Lao',
                'Latvian',
                'Lebanese',
                'Liberian',
                'Libyan',
                'Liechtensteiner',
                'Lithuanian',
                'Luxembourger',
                'Macedonian',
                'Macedonian Bulgarian',
                'Malagasy',
                'Malawian',
                'Malaysian',
                'Maldivian',
                'Malian',
                'Maltese',
                'Manx',
                'Mauritian',
                'Mexican',
                'Moldovan',
                'Mongolian',
                'Montenegrin',
                'Moroccan',
                'Namibian',
                'Nepalese',
                'New Zealander',
                'Nicaraguan',
                'Nigerian',
                'Nigerien',
                'Norwegian',
                'Other',
                'Pakistani',
                'Palauan',
                'Palestinian',
                'Panamanian',
                'Papua New Guinean',
                'Paraguayan',
                'Peruvian',
                'Pole',
                'Portuguese',
                'Puerto Rican',
                'Qatari',
                'Romanian',
                'Russian',
                'Rwandan',
                'Salvadoran',
                'Saudi',
                'Scot',
                'Senegalese',
                'Serb',
                'Sierra Leonean',
                'Sindhian',
                'Singaporean',
                'Slovak',
                'Slovene',
                'Somali',
                'Somalilander',
                'South African',
                'Spaniard',
                'Sri Lankan',
                'St Lucian',
                'Sudanese',
                'Surinamese',
                'Swede',
                'Swiss',
                'Syriac',
                'Syrian',
                'São Tomé and Príncipe',
                'Taiwanese',
                'Tajik',
                'Tanzanian',
                'Thai',
                'Tibetan',
                'Tobagonian',
                'Trinidadian',
                'Tunisian',
                'Turk',
                'Turkish Cypriot',
                'Tuvaluan',
                'Ugandan',
                'Ukrainian',
                'United States',
                'Uruguayan',
                'Uzbek',
                'Vanuatuan',
                'Venezuelan',
                'Vietnamese',
                'Welsh',
                'Yemeni',
                'Zambian',
                'Zimbabwean',
              ],
            },
          ],
        },
        {
          id: 'life-assured-contact-details',
          type: 'list',
          readonly: false,
          label: 'Life Assured Contact Details',
          uid: 'f1353cff004c006f',
          content: [
            {
              id: 'cell-phone',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Cell Phone',
              uid: '8ae0199a11931a2f',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'tel',
              component: 'PhoneNumber',
            },
            {
              id: 'email',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Email',
              uid: '78dde224ba715fa8',
              content: '',
              publishChange: true,
              inputType: 'email',
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '469a7e000a6aef5d',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: '3b2a8d3623e57049',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '32b96602af30026b',
                  content: '<p>Bloom</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '4f47fbf4068328ba',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'f65cb7abef12d099',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Ladycare Enhanced Life Assured Details',
    uri: 'ladycare-plus/life-assured-details',
    template: 'ladycare-app-template',
    class: 'ladycare-enhanced-life-assured-details',
  },
  'spouse-details': {
    text: [],
    buttons: [
      {
        label: 'Recalculate',
        id: 'recalculate',
        uid: 'f7e7fcc76ead3671',
        control: false,
      },
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'spouse-details',
      type: 'list',
      readonly: false,
      label: 'Spouse Details',
      uid: '7c423853a24c2cde',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '5a642db174f50a66',
          content: '<h2>Spouse of life assured details</h2>\n',
        },
        {
          id: 'system-field-outcome',
          type: 'html',
          readonly: true,
          label: '',
          uid: '6d0d93ab1090eff9',
          content:
            '<p>Please provide us with your details as the spouse of the life assured</p>\n',
        },
        {
          id: 'system-field-outcome',
          type: 'html',
          readonly: true,
          label: '',
          uid: '311d3016b9ae714a',
          content: '<p>Please provide us with the details of your spouse</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: 'e55ea46b1a371db4',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'first-names',
          type: 'field',
          elementType: 'input',
          readonly: false,
          label: 'First Names',
          uid: '4aff2d9293a75912',
          content: '',
          publishChange: true,
          errors: ['*'],
          inputType: 'text',
        },
        {
          id: 'surname',
          type: 'field',
          elementType: 'input',
          readonly: false,
          label: 'Surname',
          uid: '9812039f751f1d17',
          content: '',
          publishChange: true,
          errors: ['*'],
          inputType: 'text',
        },
        {
          id: 'idpassport-number',
          type: 'field',
          elementType: 'input',
          readonly: false,
          label: 'ID/Passport Number',
          uid: '3c5844938854d6ef',
          content: '',
          publishChange: true,
          //errors: ['*'],
          inputType: 'text',
        },
        {
          id: 'date-of-birth',
          type: 'component',
          elementType: 'input',
          readonly: false,
          label: 'Date Of Birth',
          uid: '049aeb66ba8cd4f2',
          content: '',
          publishChange: true,
          errors: ['*', '*'],
          inputType: 'date',
          component: 'DateSelector',
          maxYear: thisYear,
        },
        {
          id: 'title',
          type: 'field',
          elementType: 'select',
          readonly: false,
          label: 'Title',
          uid: '68e81dd62bcb39c8',
          content: '',
          publishChange: true,
          errors: ['*'],
          options: ['', 'Adv', 'Dr', 'Miss', 'Mr', 'Mrs', 'Ms', 'Prof', 'Rev'],
        },
        {
          id: 'gender',
          type: 'field',
          elementType: 'input',
          readonly: true,
          label: 'Gender',
          uid: '748d00be5e69602d',
          content: 'Male',
          inputType: 'text',
        },
        {
          id: 'spouse-id-type-radio-group',
          type: 'list',
          readonly: false,
          label: 'Spouse ID Type Radio Group',
          uid: '01c3c58635214431',
          content: [
            {
              id: 'dvla',
              type: 'field',
              elementType: 'checkbox',
              readonly: false,
              label: 'Dvla',
              uid: '9d4da915a6f303ff',
              content: '',
              publishChange: true,
              options: ['Y', 'N'],
            },
            {
              id: 'passport',
              type: 'field',
              elementType: 'checkbox',
              readonly: false,
              label: 'Passport',
              uid: '416042d9ee0afb3f',
              content: '',
              publishChange: true,
              options: ['Y', 'N'],
            },
            {
              id: 'voter-id',
              type: 'field',
              elementType: 'checkbox',
              readonly: false,
              label: 'Voter ID',
              uid: 'bdbf9029d0e26f3a',
              content: '',
              publishChange: true,
              options: ['Y', 'N'],
            },
            {
              id: 'nhis',
              type: 'field',
              elementType: 'checkbox',
              readonly: false,
              label: 'Nhis',
              uid: '049879b2e74fd7de',
              content: '',
              publishChange: true,
              options: ['Y', 'N'],
            },
            {
              id: 'ssnit',
              type: 'field',
              elementType: 'checkbox',
              readonly: false,
              label: 'Ssnit',
              uid: 'e0d207de86ecbfa7',
              content: '',
              publishChange: true,
              options: ['Y', 'N'],
            },
            {
              id: 'nia-ghana-card',
              type: 'field',
              elementType: 'checkbox',
              readonly: false,
              label: 'Nia Ghana Card',
              uid: 'd5742458fa347c9b',
              content: '',
              publishChange: true,
              options: ['Y', 'N'],
            },
          ],
          //errors: ['*'],
        },
        {
          id: 'spouse-contact-details',
          type: 'list',
          readonly: false,
          label: 'Spouse Contact Details',
          uid: 'b68a97bfb67d8992',
          content: [
            {
              id: 'cell-phone',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Cell Phone',
              uid: '793b72cc789f651d',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'tel',
              component: 'PhoneNumber',
            },
            {
              id: 'email',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Email',
              uid: 'e8f887f0ae730004',
              content: '',
              publishChange: true,
              //errors: ['*'],
              inputType: 'email',
            },
          ],
        },
        {
          id: 'system-list',
          type: 'list',
          readonly: false,
          label: 'System List',
          uid: '46871537a0598450',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'd61017f456fc7100',
              content:
                '<p>Specify your spouse to be the trustee of the plan</p>\n',
            },
            {
              id: 'spouse-is-trustee',
              type: 'field',
              elementType: 'checkbox',
              readonly: false,
              label: 'Spouse Is Trustee',
              uid: '3fd21ab959b9109f',
              content: '',
              publishChange: true,
              options: ['Y', 'N'],
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: 'cfe474fcbaf0d783',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'fefe20b805454f74',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '9644362aa2c77d2d',
                  content: '<p>Bloom</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: 'd8d79789309b91c7',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'd566e72ceee045cb',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Ladycare Enhanced Spouse Details',
    uri: 'ladycare-plus/spouse-details',
    class: 'ladycare-enhanced-spouse-details',
  },
  'trustee-details': {
    text: [],
    buttons: [
      {
        label: 'Recalculate',
        id: 'recalculate',
        uid: 'f7e7fcc76ead3671',
        control: false,
      },
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'trustee-details',
      type: 'list',
      readonly: false,
      label: 'Trustee Details',
      uid: '123eb83e84fb7a0a',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'c57d8cad196453a3',
          content: '<h2>Trustee details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '53952a550bf734cc',
          content: '',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '8ac4d130f3be0edd',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'trustee-identification',
          type: 'list',
          readonly: false,
          label: 'Trustee Identification',
          uid: '719e3f69c02a43a8',
          content: [
            {
              id: 'first-names',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'First Names',
              uid: 'fffa2dcbe12ce9d3',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'surname',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Surname',
              uid: '939805a03a59ba9a',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'date-of-birth',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Date Of Birth',
              uid: '8c3344fe2f04f1c2',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'date',
              component: 'DateSelector',
              maxYear: thisYear,
            },
            {
              id: 'title',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Title',
              uid: '10e4727a0b4bd062',
              content: '',
              publishChange: true,
              errors: ['*'],
              tooltip: 'Title',
              options: [
                '',
                'Adv',
                'Dr',
                'Miss',
                'Mr',
                'Mrs',
                'Ms',
                'Prof',
                'Rev',
              ],
            },
            {
              id: 'relationship',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Relationship',
              uid: '14b853cd260d36ae',
              content: '',
              publishChange: true,
              errors: ['*'],
              tooltip: 'Relationship',
              options: [
                '',
                'Brother',
                'Daughter',
                'Estate',
                'Father',
                'Father-In-Law',
                'Grandfather',
                'Grandmother',
                'Mother',
                'Mother-In-Law',
                'Sister',
                'Son',
                'Spouse',
                'Testament',
                'Trust',
              ],
            },
            {
              id: 'cell-phone',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Cell Phone',
              uid: 'b5fe4f0fda749fc3',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'tel',
              component: 'PhoneNumber',
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: 'a88281b53692aec4',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'b45e1b58f17ea910',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '8242903d1e1ad75f',
                  content: '<p>Bloom</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '19759474a887a51d',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: '3aa22fa32e1f6ecd',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Ladycare Enhanced Trustee Details',
    uri: 'ladycare-plus/trustee-details',
    class: 'ladycare-enhanced-trustee-details',
  },
  'children-details': {
    text: [],
    buttons: [
      {
        label: 'Recalculate',
        id: 'recalculate',
        uid: 'f7e7fcc76ead3671',
        control: false,
      },
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'children-details',
      type: 'list',
      readonly: false,
      label: 'Children Details',
      uid: 'b0aeb090d69f501b',
      content: [],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Ladycare Enhanced Children Details',
    uri: 'ladycare-enhanced/children-details',
    class: 'ladycare-enhanced-children-details',
  },
  'beneficiary-details': {
    text: [],
    buttons: [
      {
        label: 'Add Trustee',
        id: 'add-trustee',
        uid: '1c40f26fba6a8711',
        control: false,
      },
      {
        label: 'Add children',
        id: 'add-children',
        uid: '5afb1b225f8ca593',
        control: false,
      },
      {
        label: 'Add Another Beneficiary',
        id: 'add-another-beneficiary',
        uid: 'cca8995092d126c2',
        control: false,
      },
      {
        label: 'Update Benefit Split Percentage',
        id: 'update-benefit-split-percentage',
        uid: '6ce12a7a32a8d69a',
        control: false,
      },
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'specify-beneficiaries',
      type: 'list',
      readonly: true,
      label: 'Specify Beneficiaries',
      uid: '5cc588e00646e21c',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'ccd1e945cd5c3045',
          content: '<h2>Beneficiary Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'f0d387b3ecd49ed5',
          content: '<p>Please specify your beneficiary details below</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: 'f46ff380717f1288',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'system-field-outcome',
          type: 'html',
          readonly: true,
          label: '',
          uid: '6c60b1c422ae8373',
          content:
            "<p><a href='#add-trustee'>Add Trustee as beneficiary</a></p>\n",
        },
        {
          id: 'system-field-outcome',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'bf6a79c7a7af53dc',
          content:
            "<p><a href='#add-children'>Add Child as beneficiary</a></p>\n",
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '145b199f80e0c8c3',
          content:
            "<p><a href='#add-another-beneficiary'>Add a different beneficiary</a></p>\n",
        },
        {
          id: 'beneficiary-details',
          type: 'table',
          readonly: true,
          label: 'Beneficiary Details',
          uid: 'c7e636ab2a55215f',
          triggers: ['DoubleClick'],
          content: [[]],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '857cc20a50cba61e',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: '84cbdfc77cf59c6b',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '60329740069394be',
                  content: '<p>Bloom</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '56fbca3413111385',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: '73d064eb1a0df579',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Ladycare Enhanced Beneficiary Details',
    uri: 'ladycare-plus/beneficiary-details',
    class: 'ladycare-enhanced-beneficiary-details',
  },
  'add-children-as-beneficiary': {
    modal: true,
    text: [],
    buttons: [],
    item: {
      id: 'message',
      type: 'text',
      readonly: true,
      label: 'Message',
      uid: '80145e8e8a03e9a3',
      content: ['Please select the child you want to add'],
    },
    title: 'Public Access \n Welcome to Elac',
  },
  'add-beneficiary': {
    modal: true,
    text: [],
    buttons: [
      {
        label: 'Recalculate',
        id: 'recalculate',
        uid: 'f7e7fcc76ead3671',
        control: false,
      },
      {
        label: 'Add',
        id: 'add',
        uid: '1413145eedf0be58',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
    ],
    item: {
      id: 'beneficiary-details',
      type: 'list',
      readonly: false,
      label: 'Beneficiary Details',
      uid: '72be27dcc17e771a',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '94e325bd80270712',
          content:
            '<p>Please provide the following information for the beneficiary you would like to add to the policy</p>\n',
        },
        {
          id: 'first-names',
          type: 'field',
          elementType: 'input',
          readonly: false,
          label: 'First Names',
          uid: 'f33cc0c8de4de1e0',
          content: '',
          publishChange: true,
          errors: ['*'],
          inputType: 'text',
        },
        {
          id: 'surname',
          type: 'field',
          elementType: 'input',
          readonly: false,
          label: 'Surname',
          uid: '9b46035697c729bc',
          content: '',
          publishChange: true,
          errors: ['*'],
          inputType: 'text',
        },
        {
          id: 'role',
          type: 'field',
          elementType: 'select',
          readonly: false,
          label: 'Role',
          uid: '8ca3d9f9ca35bf9f',
          content: '',
          publishChange: true,
          errors: ['*'],
          options: [
            '',
            'Brother',
            'Child',
            'Cousin',
            'Daughter',
            'Family',
            'Father',
            'Father-in-law',
            'Grandchild',
            'Grandfather',
            'Grandmother',
            'Main',
            'Mother',
            'Mother-in-law',
            'Nephew',
            'Niece',
            'Sister',
            'Son',
            'Spouse',
            'Step-Father',
            'Step-Mother',
          ],
        },
        {
          id: 'gender',
          type: 'field',
          elementType: 'radio',
          readonly: false,
          label: 'Gender',
          uid: '09f28932184006c8',
          content: '',
          publishChange: true,
          errors: ['*'],
          options: ['Female', 'Male'],
        },
        {
          id: 'date-of-birth',
          type: 'component',
          elementType: 'input',
          readonly: false,
          label: 'Date Of Birth',
          uid: '6b9a4f659b85294a',
          content: '',
          publishChange: true,
          errors: ['*'],
          inputType: 'date',
          component: 'DateSelector',
          maxYear: thisYear,
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Beneficiary Details Add',
    uri: 'application/beneficiary-details/add',
    class: 'beneficiary-details-add',
  },
  'edit-beneficiary': {
    modal: true,
    text: [],
    buttons: [
      {
        label: 'Recalculate',
        id: 'recalculate',
        uid: 'f7e7fcc76ead3671',
        control: false,
      },
      {
        label: 'Delete Beneficiary',
        id: 'delete-beneficiary',
        uid: '02308b457a7dc6a3',
        control: false,
      },
      {
        label: 'Update',
        id: 'update',
        uid: 'd8035e4553f65492',
        control: true,
      },
    ],
    item: {
      id: 'beneficiary-details',
      type: 'list',
      readonly: false,
      label: 'Beneficiary Details',
      uid: 'e86854b09d2374d4',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '7fa0e505ce6ab73a',
          content:
            "<p>Edit beneficiary information below or <a href='#delete-beneficiary'>click here to remove beneficiary</a>.</p>\n",
        },
        {
          id: 'first-names',
          type: 'field',
          elementType: 'input',
          readonly: false,
          label: 'First Names',
          uid: 'f33cc0c8de4de1e0',
          content: 'Mare',
          publishChange: true,
          inputType: 'text',
        },
        {
          id: 'surname',
          type: 'field',
          elementType: 'input',
          readonly: false,
          label: 'Surname',
          uid: '9b46035697c729bc',
          content: 'Hus',
          publishChange: true,
          inputType: 'text',
        },
        {
          id: 'role',
          type: 'field',
          elementType: 'select',
          readonly: false,
          label: 'Role',
          uid: '8ca3d9f9ca35bf9f',
          content: 'CESSIONARY',
          publishChange: true,
          options: [
            '',
            'Cessionary',
            'Brother',
            'Child',
            'Cousin',
            'Daughter',
            'Family',
            'Father',
            'Father-in-law',
            'Grandchild',
            'Grandfather',
            'Grandmother',
            'Main',
            'Mother',
            'Mother-in-law',
            'Nephew',
            'Niece',
            'Sister',
            'Son',
            'Spouse',
            'Step-Father',
            'Step-Mother',
          ],
        },
        {
          id: 'gender',
          type: 'field',
          elementType: 'select',
          readonly: false,
          label: 'Gender',
          uid: '09f28932184006c8',
          content: '',
          publishChange: true,
          errors: ['*'],
          options: ['', 'Female', 'Male'],
        },
        {
          id: 'date-of-birth',
          type: 'component',
          elementType: 'input',
          readonly: false,
          label: 'Date Of Birth',
          uid: '6b9a4f659b85294a',
          content: '19900101',
          publishChange: true,
          inputType: 'date',
          component: 'DateSelector',
          maxYear: thisYear,
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Beneficiary Details Edit',
    uri: 'application/beneficiary-details/edit',
    class: 'beneficiary-details-edit',
  },
  'update-beneficiary-split-percentage': {
    modal: true,
    text: [],
    buttons: [
      {
        label: 'Update',
        id: 'update',
        uid: 'd8035e4553f65492',
        control: true,
      },
    ],
    item: {
      id: 'update-benefit-split-percentage',
      type: 'list',
      readonly: false,
      label: 'Update Benefit Split Percentage',
      uid: 'e7fde73ab0f00ccf',
      content: [],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Beneficiary Details Split',
    uri: 'application/beneficiary-details/split',
    class: 'beneficiary-details-split',
  },
  'owner-details': {
    text: [],
    buttons: [
      {
        label: 'Recalculate',
        id: 'recalculate',
        uid: 'f7e7fcc76ead3671',
        control: false,
      },
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'owner-details',
      type: 'list',
      readonly: false,
      label: 'Owner Details',
      uid: '82cfca5b9990d20f',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'f33f6ed3d3db34ea',
          content: '<h2>Owner details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'c962a24c6d2955cc',
          content: '<p>Please provide us with your additional details</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '24145f343eb3c012',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'first-names',
          type: 'field',
          elementType: 'input',
          readonly: true,
          label: 'First Names',
          uid: '37c874e2caa2fe04',
          content: '',
          inputType: 'text',
        },
        {
          id: 'surname',
          type: 'field',
          elementType: 'input',
          readonly: true,
          label: 'Surname',
          uid: '475de50953dab2ed',
          content: '',
          inputType: 'text',
        },
        {
          id: 'idpassport-number',
          type: 'field',
          elementType: 'input',
          readonly: true,
          label: 'ID/Passport Number',
          uid: 'd732861353485589',
          content: '',
          inputType: 'text',
        },
        {
          id: 'date-of-birth',
          type: 'integer',
          elementType: 'input',
          readonly: true,
          label: 'Date Of Birth',
          uid: '5661c40436188e7a',
          content: '',
          inputType: 'number',
        },
        {
          id: 'title',
          type: 'field',
          elementType: 'input',
          readonly: true,
          label: 'Title',
          uid: '5f8fc71617f6f806',
          content: '',
          inputType: 'text',
        },
        {
          id: 'gender',
          type: 'field',
          elementType: 'input',
          readonly: true,
          label: 'Gender',
          uid: '0dac9d0a2e3d6422',
          content: '',
          inputType: 'text',
        },
        {
          id: 'owner-contact-details',
          type: 'list',
          readonly: true,
          label: 'Owner Contact Details',
          uid: '916a35571e2fd52e',
          content: [
            {
              id: 'cell-phone',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Cell Phone',
              uid: '1168c18c5cdf44ad',
              content: '',
              inputType: 'tel',
            },
            {
              id: 'email',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Email',
              uid: 'a58cd23221b51523',
              content: '',
              inputType: 'email',
            },
          ],
        },
        {
          id: 'owner-postal-address',
          type: 'list',
          readonly: false,
          label: 'Owner Postal Address',
          uid: '501b106a4fd82e19',
          content: [
            {
              id: 'addressee',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Addressee',
              uid: '43831bd9d21993f2',
              content: '',
              publishChange: true,
              inputType: 'text',
            },
            {
              id: 'town',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Town',
              uid: 'f3f1935ce828e327',
              content: '',
              publishChange: true,
              errors: ['*'],
              options: [
                '',
                'Abamasarefan',
                'Abandze',
                'Abaoba',
                'Abasa',
                'Abasa Ajumaku',
                'Abasi',
                'Abdulaikrom',
                'Abease',
                'Abenasi',
                'Abene',
                'Abesem',
                'Ablornu',
                'Aboabo No 2',
                'Abodom',
                'Abofoo',
                'Aboma',
                'Abomoso',
                'Abompe',
                'Aboo',
                'Abooso',
                'Abora',
                'Abora Oboasi',
                'Abore',
                'Abra',
                'Abrekum',
                'Abuakwa',
                'Abuom',
                'Abura Dunkwa',
                'Aburi',
                'Abutia - Kloe',
                'Accra',
                'Achawa Pt.',
                'Achiase',
                'Achimota',
                'Ada',
                'Adabokurom',
                'Adaiso',
                'Adansi',
                'Adawsu',
                'Adidakpavui',
                'Adidome',
                'Adidwan',
                'Adina',
                'Adjena',
                'Adobo',
                'Adonso',
                'Aduaben',
                'Aduamoa',
                'Adubea',
                'Adubiliyili',
                'Adukrom',
                'Adumadum',
                'Adwamadiem',
                'Adwufia',
                'Adwum',
                'Adzakoe',
                'Afegame',
                'Afiaso',
                'Afienya',
                'Aflao',
                'Afosu',
                'Aframso',
                'Afratwo',
                'Agogo',
                'Agona',
                'Agona Nkwanta',
                'Aguna',
                'Agyana',
                'Ahamasu',
                'Ahebensu',
                'Ahemakurom',
                'Ahenkro',
                'Ahobre',
                'Ahunda',
                'Ahwerewa',
                'Ahwiren',
                'Aiyiribi',
                'Ajemra',
                'Ajumako',
                'Ajumaku',
                'Akantansu',
                'Akanu',
                'Akatsi',
                'Akim Oda',
                'Akim Swedru',
                'Akim Tafo',
                'Akoasi',
                'Akontaanim',
                'Akontanim',
                'Akoroso',
                'Akosombo',
                'Akosombo Juapon',
                'Akpabanya',
                'Akra',
                'Akrofuom',
                'Akrokerri',
                'Akropon',
                'Akropong',
                'Akumadan',
                'Akuntuase',
                'Akuse',
                'Akwantonbra',
                'Akwidaa',
                'Akyekyere',
                'Akyemfo Gyomuro',
                'Alenda',
                'Amamsi',
                'Amankwakrom',
                'Amasaman',
                'Amasu',
                'Ambo',
                'Amedzofe',
                'Amenfi',
                'Amlakpo',
                'Amoama',
                'Amoma',
                'Amoya',
                'Ampeda',
                'Ampeyoo',
                'Anfoaga',
                'Anibil',
                'Ankaasi',
                'Ankaful',
                'Ankan',
                'Anloga',
                'Anomabo',
                'Antabia',
                'Anum',
                'Anyaboni',
                'Anyako',
                'Anyanui',
                'Anyinam',
                'Anyinasu',
                'Anyirawase',
                'Aobo Aduamoa',
                'Apam',
                'Apapasu',
                'Apataim',
                'Aperade',
                'Apesokubi',
                'Apinso',
                'Apowa',
                'Asaafa',
                'Asaam',
                'Asaaman',
                'Asafo',
                'Asakraka',
                'Asamankese',
                'Asankrangua',
                'Asantekrom',
                'Asasitre',
                'Asatowe',
                'Asawinso',
                'Asebu',
                'Asekore',
                'Asesewa',
                'Ashanti',
                'Asiakwa',
                'Asiekpe',
                'Asikuma',
                'Assin Breku',
                'Assin Manso',
                'Assin Nyankumase',
                'Assin Praso',
                'Asuboa',
                'Asuderi',
                'Asukawkaw',
                'Asumenya',
                'Asunafo',
                'Asuom',
                'Asuotiano',
                'Asutsuare',
                'Ataase',
                'Atebubu',
                'Atesa',
                'Atiavi',
                'Atieku',
                'Atimpoku',
                'Atobase',
                'Atuabo',
                'Atuna',
                'Ave-afiadenyiga',
                'Ave-dakpa',
                'Avenorpeme',
                'Aveyime',
                'Awatia',
                'Awisa',
                'Awisan',
                'Awonakrom',
                'Awurasa',
                'Awutu',
                'Axim',
                'Ayanfure',
                'Ayerede',
                'Ayiase',
                'Ayiem',
                'Ayikuma',
                'Ayinwafe',
                'Ayomfo',
                'Baabiaraneha',
                'Baaglo',
                'Baantama',
                'Babile',
                'Babopi',
                'Bagape',
                'Bagbiapi',
                'Bagmare',
                'Bagurugu',
                'Bagwiwu',
                'Baika',
                'Bakanta',
                'Bakau',
                'Bakoniaba',
                'Bale',
                'Bamboi',
                'Banaso',
                'Banda',
                'Banda - Nkwanta',
                'Bandae',
                'Bandiyili',
                'Bangwan',
                'Banko',
                'Bansang',
                'Banso',
                'Banu',
                'Barae No 2',
                'Barra',
                'Basa',
                'Basie',
                'Basse',
                'Battor',
                'Batume Junction',
                'Bau',
                'Bawdie',
                'Bawiesibal',
                'Bawjiase',
                'Bawka',
                'Bawku',
                'Bechem',
                'Bediakokurom',
                'Begoro',
                'Beku',
                'Bekwai',
                'Bende',
                'Benso',
                'Beposo',
                'Berekum',
                'Berekuso',
                'Besease',
                'Beyin',
                'Biadam',
                'Bibiani',
                'Bielikpang',
                'Billaw',
                'Bimbago',
                'Bimbagokpasenkpe',
                'Bimbagu',
                'Bimbila',
                'Binaba',
                'Binduri',
                'Bisa',
                'Biung',
                'Boanim',
                'Bodi',
                'Bodwesango',
                'Bofaso',
                'Bogdoo',
                'Bogorono',
                'Bogorop',
                'Bogoso',
                'Bole',
                'Bolgatanga',
                'Bombori',
                'Bomburi Fimbo',
                'Bomfa',
                'Bonakye',
                'Bongo',
                'Bonkrom',
                'Bonohoma',
                'Bonyere',
                'Booyem',
                'Bopa',
                'Boro',
                'Bortianor',
                'Bososo',
                'Bowiri',
                'Brakwa',
                'Branam',
                'Brenase',
                'Bresuanu',
                'Brewaniase',
                'Brikama',
                'Brikamaba',
                'Brofuyedru',
                'Brufut',
                'Brugbani',
                'Buachipe',
                'Buaka',
                'Bugri',
                'Bugu',
                'Buipe',
                'Bukanor',
                'Bulangsa',
                'Bulangsa Torsa',
                'Bulenga',
                'Bungeli',
                'Bunkpurugu',
                'Burai',
                'Busa',
                'Busie',
                'Busunu',
                'Butie',
                'Buya',
                'Cape Coast',
                'Cape St. Paul',
                'Cape Three Pts.',
                'Carnpaga Sakogu',
                'Chache',
                'Chaisa',
                'Chama',
                'Chamba',
                'Changbuni',
                'Chanyili',
                'Chase',
                'Chatali',
                'Chemfe',
                'Chepuri',
                'Cherepon',
                'Cheropon',
                'Chia',
                'Chiana-asuma',
                'Chichari',
                'Christiansborg',
                'Chuchiliga',
                'Dabala',
                'Daboase',
                'Dabori',
                'Dabova',
                'Daboya',
                'Dadeeso',
                'Dado',
                'Dadwen',
                'Dafiama',
                'Dafo',
                'Dafor',
                'Dagonkadi',
                'Dakpam',
                'Damanko',
                'Dambai',
                'Damongo',
                'Danko',
                'Dapa',
                'Dasanyi',
                'Datako-kurbor',
                'Datano',
                'Dawa',
                'Dawadawa',
                'Dawhenya',
                'Debiribi',
                'Debiso',
                'Dedeso Wireko',
                'Degbila',
                'Dego',
                'Demoh',
                'Dena',
                'Denkyira',
                'Densubon',
                'Denu',
                'Diabakurom',
                'Diari',
                'Diasempa',
                'Diaso',
                'Digma',
                'Digmamandari',
                'Disiga',
                'Dixcove',
                'Dodowa',
                'Dogokrom',
                'Domeabra',
                'Domenase',
                'Dominase',
                'Dompem',
                'Dompoase',
                'Doninga',
                'Donkponkwanta',
                'Doriman',
                'Dormaa-ahenk',
                'Doryum',
                'Drakofe',
                'Drobo',
                'Dromakese',
                'Duaburori',
                'Duadaso',
                'Duie',
                'Dukusen',
                'Dumienu',
                'Dunkwa',
                'Dunkwa On Offin',
                'Duu',
                'Dwija',
                'Dwokwa',
                'Dyayaw-nkwanta',
                'Dzana',
                'Dzita',
                'Dzodze',
                'Effiduase',
                'Eikwe',
                'Ejian',
                'Ejisu',
                'Ejura',
                'Ekumdipe',
                'Ekuropon',
                'Ekyiamenfurom',
                'Elmina',
                'Elubo',
                'Enchi',
                'Enyan',
                'Enyanmansu',
                'Enyinabrim',
                'Esaaman',
                'Esalikawu',
                'Essem',
                'Essiama',
                'Esuakrom',
                'Fajara',
                'Fanti',
                'Farafenni',
                'Farifari',
                'Fawamam',
                'Fenyi Yokoe',
                'Feo-nabisi',
                'Fete',
                'Fetenta',
                'Fian',
                'Fianko',
                'Fimbo',
                'Fomena',
                'Foso',
                'Frankadua',
                'Fuchmbluma',
                'Fufulsu',
                'Fufuo',
                'Fumbisi',
                'Fumsi',
                'Fumso',
                'Fuu',
                'Ga',
                'Gaa',
                'Gambia No 1',
                'Gambia No 2',
                'Gbal',
                'Gbalga',
                'Gbangdaa',
                'Gbantala',
                'Gbari',
                'Gbasinkpa',
                'Gbateto',
                'Gbedema',
                'Gbeini',
                'Gbemfo',
                'Gbeni',
                'Gbimsi',
                'Gbogu',
                'Gbulumpe',
                'Gbung',
                'Gida',
                'Gitase',
                'Gnani',
                'Goantala',
                'Goaso',
                'Goka',
                'Gokoron',
                'Golokuati',
                'Gonnokurom',
                'Gorgu',
                'Gpapga',
                'Grube',
                'Grupe',
                'Gulibikomonpa',
                'Guri',
                'Guru-natinga',
                'Gushie',
                'Gwallo',
                'Gwellukupulima',
                'Gwo',
                'Gwosi',
                'Gyapa',
                'Gyedua',
                'Gyekiti',
                'Gyema',
                'Gyenegyene',
                'Half Assini',
                'Hamale',
                'Harglakarpe',
                'Have Etoe',
                'Helu',
                'Heluivi',
                'Heman',
                'Hevi',
                'Hian',
                'Hiawoanwu',
                'Ho',
                'Hohoe',
                'Honuta',
                'Huhunya',
                'Hunt Valley',
                'Huntodo',
                'Hwidiem',
                'Imbraim',
                'Issa',
                'Jaba',
                'Jadima',
                'Jafor',
                'Jakai',
                'Jakobo',
                'Jamasi',
                'Jamra',
                'Jandra',
                'Jang',
                'Janjangbureh',
                'Jasikan',
                'Jato',
                'Jawani',
                'Jeffisi',
                'Jegbuni',
                'Jeinsusa',
                'Jema',
                'Jemile',
                'Jerigu',
                'Jeshwang',
                'Jewi Wharf',
                'Jeyiri',
                'Jimdabuo',
                'Jinfranukasuridabarshe',
                'Jinpasi',
                'Jirapa',
                'Jogboi',
                'Jombo',
                'Juaben',
                'Juabeso',
                'Juana',
                'Juapon',
                'Juaso',
                'Jumo',
                'Junle',
                'Juo',
                'Kaase',
                'Kabaka',
                'Kablima',
                'Kabonwele',
                'Kade',
                'Kadema',
                'Kadjebi',
                'Kafaba',
                'Kafodzidzi',
                'Kafuta',
                'Kakawere',
                'Kakorasua',
                'Kakum',
                'Kalagie',
                'Kalba',
                'Kaleo',
                'Kalini',
                'Kamsorio',
                'Kananta',
                'Kandige',
                'Kanga',
                'Kanifing',
                'Kanilie',
                'Kanjaga',
                'Kanseri',
                'Kantani',
                'Kanyaga',
                'Kapro',
                'Kapua',
                'Karaga',
                'Karamenga',
                'Karni',
                'Kasa',
                'Kasapen',
                'Kasoa',
                'Kasuridabarshe',
                'Kataijeli',
                'Katanga',
                'Katanka',
                'Katiu',
                'Kawga',
                'Kechebi',
                'Kedzi',
                'Kensere',
                'Kenyasi No 1',
                'Keta',
                'Kete Krache',
                'Kibi',
                'Kikam',
                'Kimabui',
                'Kintampo',
                'Kissi',
                'Klavw',
                'Klikor - Agbozume',
                'Kobresu',
                'Kodee',
                'Kofi Djan',
                'Kofiase',
                'Koforidua',
                'Kogota',
                'Kogyei',
                'Kokoben',
                'Kokofu',
                'Kokoso',
                'Kokuma',
                'Kologo',
                'Kololi',
                'Komampo',
                'Komenda',
                'Komonpa',
                'Konfogsi',
                'Kong',
                'Kongo',
                'Konkori',
                'Kononga',
                'Kopota',
                'Kotoko',
                'Kotu',
                'Kotua',
                'Koue',
                'Kpadui',
                'Kpagto',
                'Kpalbe',
                'Kpalbus',
                'Kpalguni',
                'Kpalisogu',
                'Kpandae',
                'Kpandu',
                'Kpanianba',
                'Kparekpare',
                'Kparigu',
                'Kpasa',
                'Kpasenk',
                'Kpatinga',
                'Kpedze',
                'Kpedzeglo',
                'Kpembe',
                'Kpetchu',
                'Kpetoe',
                'Kpeve',
                'Kpoglo',
                'Kpone',
                'Kpong',
                'Kpotsu',
                'Kptokuomtoas',
                'Kraboa Coaltar',
                'Krakurom',
                'Kroba',
                'Krobo',
                'Krokosue',
                'Krokrobite',
                'Ksauridabarshe',
                'Kubari',
                'Kudani',
                'Kugnani',
                'Kugnanidaboya',
                'Kugri Natinga',
                'Kuikpanga',
                'Kujopere',
                'Kukabila',
                'Kukuo',
                'Kukuom',
                'Kukurantumi',
                'Kulkpanga',
                'Kulmae',
                'Kulmasa',
                'Kulun',
                'Kulungugu',
                'Kulupene',
                'Kumasi',
                'Kumawu',
                'Kumbungu',
                'Kumfa',
                'Kunchoge Basirisan',
                'Kundang',
                'Kunkwa',
                'Kunso',
                'Kuntanse',
                'Kuntunso',
                'Kupullma',
                'Kusawgu',
                'Kusebi',
                'Kusinaba',
                'Kute',
                'Kutukrom',
                'Kwaben',
                'Kwabenadapaa',
                'Kwadwokurom',
                'Kwadwonkromkurom',
                'Kwahu Tafo',
                'Kwaihunu',
                'Kwakwanya',
                'Kwaman',
                'Kwame Danso',
                'Kwame Kwasi',
                'Kwamedwamenakurom',
                'Kwameseikurom',
                'Kwanyaku',
                'Kwawu',
                'Kwesiadai',
                'Kyekyewere',
                'Kyeraa',
                'Kyeremasu',
                'Kyinderi',
                'Labadi',
                'Labo',
                'Lambusie',
                'Lamin',
                'Lampel',
                'Lampurgo',
                'Langantre',
                'Langasi',
                'Langbinsi',
                'Lanja',
                'Larabanga',
                'Larekaga',
                'Larteh',
                'Laura',
                'Lawra',
                'Lepusi',
                'Lilikse Nankpawie',
                'Lobi',
                'Loggo',
                'Lolonya',
                'Longoro',
                'Lovi',
                'Luari',
                'Lungbunga',
                'Lungni',
                'Lziri',
                'Maasu',
                'Maknkuma',
                'Makongo',
                'Malume',
                'Mamfe',
                'Mampaten',
                'Mampon',
                'Mampong',
                'Mampoten',
                'Mandari',
                'Mankarigy',
                'Mankessim',
                'Mankpan',
                'Mankranso',
                'Mankuma',
                'Mankwadze',
                'Mansing',
                'Manso',
                'Manso Nkwanta',
                'Mantukwa',
                'Masaka',
                'Matse',
                'Mawuabammu',
                'Mengwe',
                'Mengyi',
                'Menusu',
                'Meriche',
                'Mim',
                'Mirigu-nabaanga',
                'Mishue',
                'Moglo',
                'Mogono',
                'Mojina',
                'Moree',
                'Moseaso',
                'Motigy',
                'Mpana',
                'Mpasaso',
                'Mpasem',
                'Mpataba',
                'Mpatoam',
                'Mpeam',
                'Mpohor',
                'Mpraeso',
                'Mrigu-nabara',
                'Mumford',
                'Muna',
                'Mungu',
                'Murugu',
                'Nabari',
                'Nabisi',
                'Nabogo',
                'Nabolo',
                'Nabori',
                'Nadiyili',
                'Nafkoliga',
                'Naga',
                'Naga Pwalugu',
                'Nagbo',
                'Nakong-atinia',
                'Nakpali',
                'Nakpayili',
                'Nakundugu',
                'Nakwa',
                'Nakwabi',
                'Nalerigu',
                'Namanso',
                'Namasua',
                'Nambiri',
                'Namvili',
                'Nandawli',
                'Nandom',
                'Nangodi',
                'Nangruma',
                'Nankanduri',
                'Nanton',
                'Naro',
                'Nasia',
                'Natinga',
                'Natog',
                'Nauli',
                'Navrongo',
                'Nawuni',
                'Nawuniyipala',
                'Nereso',
                'New Abirem',
                'New Debiso',
                'New Edubiase',
                'New Longoro',
                'New Ningo',
                'New Town',
                'New Worabon',
                'Nframa',
                'Nkasiem',
                'Nkawie',
                'Nkawkaw',
                'Nkenkasu',
                'Nketepa',
                'Nkoranza',
                'Nkroful',
                'Nkuntunso',
                'Nkwaben',
                'Nkwanta',
                'Nobekaw',
                'Nogokpo',
                'Npuasu',
                'Nsaba',
                'Nsawam',
                'Nsawkaw',
                'Nsinsin',
                'Nsuaem',
                'Nsuatre',
                'Nsuta',
                'Nteresa',
                'Ntereso',
                'Ntronan',
                'Nungua',
                'Nwereme',
                'Nyakrom',
                'Nyame Bekyere',
                'Nyamease',
                'Nyameyeadom',
                'Nyang',
                'Nyankpala',
                'Nyankumase',
                'Nyanyaano',
                'Nyensungi',
                'Nyinahin',
                'Nyive',
                'Nzema',
                'Obawale',
                'Obo',
                'Obogu',
                'Obomeng',
                'Obuase',
                'Obuasi',
                'Odahu',
                'Odami',
                'Odonkawkrom',
                'Odumase',
                'Odumasi',
                'Odumasua',
                'Oduponkpebe',
                'Ofaose',
                'Ofe',
                'Offinso',
                'Ofoase',
                'Oforikurom',
                'Ohiamankyene Kpetchu',
                'Ohyiayeanisa',
                'Ojobi',
                'Okomfookurom',
                'Old Edabo',
                'Old Ningo',
                'Oseekodwokurom',
                'Osenase',
                'Osino',
                'Osudoku',
                'Otekpolu',
                'Otrokpe',
                'Owusukuro',
                'Pabire',
                'Paga',
                'Palangasi',
                'Palari',
                'Pampawie',
                'Pankron',
                'Panyane',
                'Papase',
                'Patriensa',
                'Pawa',
                'Peblastre',
                'Pechi',
                'Peki',
                'Pelungo',
                'Pemenasi',
                'Perisi',
                'Pigu',
                'Pina',
                'Piong',
                'Pisie',
                'Pisigu',
                'Poano',
                'Poasi',
                'Pokoasi',
                'Polmakom',
                'Pomadze',
                'Pong-tamale',
                'Pramkese',
                'Prampram',
                'Prang',
                'Prestea',
                'Primase',
                "Prince's Town",
                'Pulo',
                'Pumpuni',
                'Pusiga',
                'Pusuga',
                'Pute',
                'Pwalugu',
                'Saani',
                'Sabari',
                'Saboba',
                'Sabonjida',
                'Sabuli',
                'Sabusa',
                'Sabzundi',
                'Sagadugu',
                'Sakai',
                'Sakala',
                'Sakode - Etae',
                'Sakomono',
                'Sakpa',
                'Salaga',
                'Salkpang',
                'Saltpond',
                'Samambow',
                'Samanhyia',
                'Sambo',
                'Sambreboe',
                'Sambrun',
                'Sambu',
                'Samila',
                'Samoa',
                'Sampa',
                'Sampemo',
                'Sampraso',
                'Sandema',
                'Sang',
                'Sangbaa',
                'Sankalaa',
                'Sankore',
                'Sankpala',
                'Sanujan',
                'Sanyang',
                'Sapiegu',
                'Saranouse',
                'Saripere',
                'Sarpere Ambo',
                'Sarri',
                'Saru',
                'Savelugu',
                'Sawla',
                'Seekwa',
                'Sefwi Anhwiaso',
                'Sefwi Bekwai',
                'Sefwi Wiawso',
                'Segbasi',
                'Sekasua',
                'Seketia',
                'Sekondi Takoradi',
                'Sekpe',
                'Sekyedumase',
                'Sekyerekurom',
                'Sema',
                'Senase',
                'Senchi',
                'Seneso',
                'Senfi',
                'Senkyiem',
                'Senya Bereku',
                'Seripe',
                'Serrekunda',
                'Sese',
                'Seseamam',
                'Shama',
                'Shi',
                'Shia',
                'Shiega',
                'Shieni',
                'Silibele',
                'Sinebaga',
                'Singa',
                'Siriminchu',
                'Sogakope',
                'Soma(mansakonko)',
                'Somanya',
                'Sombisi',
                'Soo',
                'Sovie',
                'Srogbae',
                'Subri',
                'Suggo',
                'Suhum',
                'Sukuta',
                'Sumiso',
                'Sumsei',
                'Sung',
                'Sunsan',
                'Sunyani',
                'Surukrom',
                'Swedru',
                'Taali',
                'Tachiman',
                'Tachimantia',
                'Tadieso',
                'Tadzevu',
                'Taenso',
                'Tahima',
                'Takoradi',
                'Takpo',
                'Tamale',
                'Tamale Port',
                'Tamaligu',
                'Tampion',
                'Tamso',
                'Tanaso',
                'Tangasia',
                'Tanina',
                'Tanji',
                'Tanoso',
                'Tantali',
                'Tarkwa',
                'Tarongo',
                'Tatale',
                'Teainano',
                'Techigu',
                'Teekyere',
                'Tefle',
                'Tema',
                'Tenfian',
                'Teselima',
                'Teshi',
                'Tetema',
                'Tetrem',
                'Tijo',
                'Tikobo No 1',
                'Tikobo No 2',
                'Tikpang',
                'Tilli',
                'Tinga',
                'Tolon',
                'Tongo',
                'Torsa',
                'Toyanyili',
                'Trede',
                'Trom',
                'Tromeso',
                'Tsito',
                'Tsrefe',
                'Tugu',
                'Tuluwe',
                'Tumfakura',
                'Tumu',
                'Tuna',
                'Tuobodom',
                'Turumi',
                'Tutukpene',
                'Tutumi',
                'Tuwuo',
                'Twenene',
                'Twifo Praso',
                'Twifo-mampon',
                'Ugando',
                'Vaggo',
                'Vakpo',
                'Vamboi',
                'Wa',
                'Waiasi',
                'Wakawaka',
                'Walembele',
                'Walewale',
                'Wam',
                'Wamanafo',
                'Wamfie',
                'Wangasi - Turu',
                'Waniada',
                'Wapuli',
                'Warinvaga',
                'Wasipe',
                'Waso',
                'Watoro',
                'Waya',
                'Wechiau',
                'Wegbe',
                'Weija',
                'Wenchi',
                'Wenchiki',
                'Wiaga-yisobso',
                'Wiamoase',
                'Wiasi',
                'Winisa',
                'Winkogo',
                'Winneba',
                'Wiosa',
                'Woe',
                'Worakese',
                'Worawora',
                'Wuinta',
                'Wulensi',
                'Wulensimpana',
                'Wumenu',
                'Wungu',
                'Wurnpigo',
                'Wuru',
                'Wute',
                'Yabraso',
                'Yabum',
                'Yagaba',
                'Yahaiyape',
                'Yakase',
                'Yala',
                'Yamatwa',
                'Yankoman',
                'Yankzia',
                'Yapei',
                'Yapessa',
                'Yawga',
                'Yazori',
                'Yendi',
                'Yepalsi',
                'Yezes',
                'Yikpabango',
                'Yipala',
                'Yundum',
                'Zabzugu',
                'Zanduli',
                'Zankum',
                'Zariboku',
                'Zebilla',
                'Zegbeli',
                'Zin',
                'Zion',
                'Zlope',
                'Zoggo',
                'Zoko',
                'Zongo-markyeri',
                'Zuarugu',
                'Zuro',
              ],
            },
            {
              id: 'region',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Region',
              uid: '4679d49464fb6c3d',
              content: '',
              publishChange: true,
              errors: ['*'],
              options: [
                '',
                'Ahafo',
                'Ashanti',
                'Bono East',
                'Brong Ahafo',
                'Central',
                'Eastern',
                'Greater Accra',
                'North East',
                'Northern',
                'Oti',
                'Savannah',
                'Upper East',
                'Upper West',
                'Volta',
                'Western',
                'Western North',
              ],
            },
            {
              id: 'po-box-or-private-bag',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'PO Box Or Private Bag',
              uid: '6345e8ecd831dbda',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
          ],
        },
        {
          id: 'owner-residential-address',
          type: 'list',
          readonly: false,
          label: 'Owner Residential Address',
          uid: '3268438e27711cbf',
          content: [
            {
              id: 'street',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Street',
              uid: '0a259164707dd213',
              content: '',
              publishChange: true,
              inputType: 'text',
            },
            {
              id: 'suburb',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Suburb',
              uid: '00df6bef27511c74',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
          ],
        },
        {
          id: 'owner-employment-details',
          type: 'list',
          readonly: false,
          label: 'Owner Employment Details',
          uid: 'fec97c4e5951d382',
          content: [
            {
              id: 'employer-organisation',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Employer Organisation',
              uid: '1d5c88faa36ac1d1',
              content: '',
              publishChange: true,
              options: [
                '',
                'Abokobi Area Rural Bankstaff',
                'Accra Metro Assembly',
                'Adansi Rural Bank',
                'Advans Ghana',
                'Advent Press',
                'African Regent Hotel',
                'Agave Rural Bank',
                'Agric Development Bank',
                'Ahafo Ano Premier Rural Bank',
                'Ahantaman Rural Bankâ ',
                'Akaa Security Services',
                'Akatakyiman Rural Bank',
                'Akim Bosome Rural Bank',
                'Akwapem Rural Bank',
                'Aluworks',
                'Ama Dansowaa Clinic',
                'Amanano Rural Bank',
                'Amansie West Rural Bank',
                'Amatin & Kasei Comm Bank',
                'Antrak Ghana Ltd',
                'Anum Rural Bank Ltd',
                'Apex Bank',
                'Ashante Akyem Rural Bank',
                'Asokore Rural Bank Ltd - Kumasi',
                'Asutifi Rural Bank Limited',
                'Atlantic Int. Holding Co',
                'Atwima Kwanwoma Rural Bank',
                'Atwima Rural Bank',
                'Auto Parts Limited',
                'Awutu Emasa Rural Bank',
                'Ayrton Drug Manufacturing Limited',
                'Bank of Ghana',
                'Baptist Medical Centre',
                'Barge Operators and Allied Services Ltd',
                'Benso Oil Palm Plantationâ ',
                'Bessfa Rural Bank',
                'Bible Society of Ghana',
                'Bonzali Rural Bank',
                'Bosomtwe Rb',
                'Bureau of National Communication',
                'Bureau of National Investigations',
                'Busua Beach Resortâ ',
                'Capital Rural Bank',
                'Carmeuse Lime Productâ ',
                'Cejose Wisdom Int. School',
                'Chemico Limited',
                'Chirano Gold Mines',
                'Christ Ebenezer',
                'Church Hill of God',
                'Cocoa Marketiing Company Ltd',
                'Cocoa Processing Comp',
                'Controller',
                'Cssvd Control Unit',
                'Dangme Rural Bank Ltd - Staff',
                'De Youngsters International School Ltd',
                'Deoke Foundation Schools',
                'Derma Area Rural Bank',
                'Dizengoff Ghana Ltd',
                'Dynamic Insurance Brokers',
                'Ebennezer Osei Brenya Enterprise',
                'Ejuraman Rural Bank',
                'Electricity Company of Ghana',
                'Elmina Beach Resort',
                'Englebert School',
                'Enterprise Funeral Services',
                'Enterprise Group Ltd',
                'Enterprise Insurance',
                'Enterprise Life Reps',
                'Enterprise Life Staff',
                'Enterprise Properties Ltd',
                'Enterprise Trustees Limited',
                'Epa',
                'Eskay Therapeutics Ltd',
                'Fiagya Rural Bank Ltd',
                'Fiaseman Rural Bankâ ',
                'Fiesta Royale Hotel',
                'First National Savings and Loansâ ',
                'Forces Pay Office',
                'Ga East Municipal Assembly',
                'Ga Rural Bank',
                'Ga Rural Customers',
                'Gafco',
                'Garden City - Multi Credit',
                'Gcb Bank Ltd Staff',
                'Ghana Airport Company Ltd.',
                'Ghana Bauxite Company Limted',
                'Ghana Cement',
                'Ghana Chamber of Mines',
                'Ghana Civil Aviation Authority',
                'Ghana Cocoa Board',
                'Ghana Grid Company',
                'Ghana Heavy Equipment Limited',
                'Ghana Link Network Services Ltd',
                'Ghana Maritime Authority',
                'Ghana Medical School',
                'Ghana Oil Co. Ltd',
                'Ghana Police Service',
                'Ghana Post',
                'Ghana Railway Co. Ltd',
                'Ghana Re Company Limited',
                'Ghana Revenue Authority',
                'Ghana Standard Board',
                'Ghana Union Conference of s.d.a.',
                'Gihoc Distilleries Company Limited',
                'Gimpa',
                'Globeserve Ministry Intâ ',
                'Golden Exotics Ltd',
                'Goldengate Services Ltd',
                'Gpha - Takoradi',
                'Gpha - Tema',
                'Grace Baptist School - Kumasi',
                'Guiness Ghana Ltd',
                'Gwcl - Accra East',
                'Gwcl - Accra West',
                'Gwcl - Ashanti North',
                'Gwcl - Ashanti Production',
                'Gwcl - Ashanti South',
                'Gwcl - Cape Coast',
                'Gwcl - Greater Accra Region Production',
                'Gwcl - Head Office',
                'Gwcl - Koforidua',
                'Gwcl - Sunyani',
                'Gwcl - Takoradi',
                'Gwcl - Tema',
                'Hobats Clinic',
                'Holiday Inn Accra',
                'Home Finance Company Bank Ltd',
                'House of Compassion Ministries',
                'Japan Motors Trading Company',
                'Juaben Rural Bank',
                'Jubilee Shipping Services Gh Ltd',
                'k.n.u.s.t',
                'Kaaseman Rural Bank Ltd',
                'Kessben',
                'Kingsgroup of Companies',
                'Kintampo Health Research Centre',
                'Koforidua Stop Order Walk In',
                'Korle Bu Teaching Hospital',
                'Krane Contsruction',
                'Krobo Danish Association',
                'Kuapa Kokoo',
                'Kumawuman Rural Bnk',
                'Kwamaman Rural Bank',
                'La Nkwantanang Madina Municipal Assembly',
                'Labadi Beach Hotel',
                'Living Star School',
                'Lordship Insurance Brokers',
                'Lower Pra Rural Bank',
                'Maxam Ghana Ltd',
                'Mechanical Lloyd',
                'Metromass',
                'Mojo Investment Ltd',
                'Mondial Veneer Gh. Ltd',
                'Mumuada Rural Bank',
                'Nafana Rural Bank Ltd',
                'National Security',
                'Nexans',
                'Nsoatreman Rural Bank',
                'Nthc Properties Ltd',
                'Nwabiagya Rural Bank',
                'Okomfo Anokye Rural Bank Staff',
                'Opportunity Int',
                'Parliament',
                'Pbc Ltd',
                'Pentecost Preparatory Schoolâ ',
                'Pentecost University College',
                'Phyto Riker',
                'Poly Products',
                'Presbyterian Womens Center - Abokobi',
                'Prince of Peace',
                'Quality Control Division (Cocobod)',
                'Regional Maritime Academy',
                'Ridge Church School',
                'Safebound Company Limited - Tema',
                'Sakworg Company Ltd',
                'Samartex Timber and Plywood Company',
                'Sandvik Mining and Construction Limited',
                'Scanbech Ghana Ltd',
                'Sdv Ghana',
                'Securities Discount Company Limited',
                'Sekyedumase Rural Bank',
                'Sekyere Rural Bank',
                'Services Intergrity Savings and Loans',
                'Sgs Laboratory Services',
                'Sg Ssb',
                'Silver Star Auto Ltd',
                'Sinapi Aba Trust',
                'Sofaamy Company Limited',
                'Sos Childrens Village Ghana',
                'South Birim Rural Bank',
                'South Central Conference of Sda',
                'Special Ice Company Ltd',
                'Ssnit',
                'St Ambrose College',
                'St Michaels Hospital Pramso',
                'Stellar Logistic',
                'Sunyani Cluster Icps',
                'Takoradi Flour Mill Ltd',
                'Takoradi Int. Co.',
                'Tct',
                'Tema Development Corp.',
                'Tema Parents Association School',
                'Tesano Baptist Church',
                'The Church of Pentecost',
                'Toende Rural Bank',
                'Trasacco',
                'Twifo Oil Palm Plantation',
                'Type Company Ltd',
                'Unilever',
                'University College of Education',
                'University for Development Studies',
                'University of Energy and Natural Resources',
                'University of Ghana - Legon',
                'Upper Amenfi Rural Bank',
                'Upper Manya Kro Rural Bank',
                'Utrak Savings and Loans',
                'Valley View',
                'Valley View University Basic School',
                'Vat Service',
                'Volta Hotel',
                'Volta River Authority',
                'Waec - Headquarters',
                'Waec - Main',
                'West Africa Mills Co. Ltd',
                'Weto Rural Bank',
                'Winners Chapel Ghana',
                'Yaakson Herbal Centre',
                'Yarsako',
              ],
            },
            {
              id: 'employee-number',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Employee Number',
              uid: 'faed2b4f7cee59df',
              content: '',
              publishChange: true,
              inputType: 'text',
            },
            {
              id: 'occupation',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Occupation',
              uid: 'c7b78b091bfad6ad',
              content: '',
              publishChange: true,
              errors: ['*'],
              options: [
                '',
                'Abattoir Worker',
                'Accountant',
                'Accounting Officer',
                'Actor',
                'Actress',
                'Actuary',
                'Admin Assistant',
                'Administrator',
                'Advertising Agent',
                'Advocate',
                'Affal Washer',
                'Agriculture Assistant',
                'Agriculture Officer',
                'Air Force',
                'Air Force Ground Crew',
                'Aircraft Engineer',
                'Airline Employee',
                'Airline Executive',
                'Airline Pilot',
                'Ambulance Attendant',
                'Ambulance Driver',
                'Announcer',
                'Architect',
                'Artisan',
                'Artist',
                'Assessor',
                'Auctioneer',
                'Auditor',
                'Author',
                'Auto Electrician',
                'Auxillary Worker',
                'Aviation',
                'Baker',
                'Bank Teller',
                'Bank-Manager',
                'Banker',
                'Bar Lady',
                'Bar Steward',
                'Barber',
                'Barmaid',
                'Barman',
                'Beautician',
                'Blacksmith',
                'Blockman',
                'Boilermaker',
                'Bookbinder',
                'Bookkeeper',
                'Bookmaker',
                'Boring Contractor',
                'Bottle Store Assistant',
                'Bottle Store Manager',
                'Boxer',
                'Bricklayer',
                'Broker',
                'Builder',
                'Building Contractor',
                'Building Foreman',
                'Building Inspector',
                'Bus Driver',
                'Butcher',
                'Buyer',
                'Cabinetmaker',
                'Cafe Owner',
                'Cameraman',
                'Cardiologist',
                'Caretaker',
                'Carpenter',
                'Carpet Layer',
                'Cashier',
                'Caterer',
                'Checker',
                'Chef',
                'Chief Officer',
                'Chiropodist',
                'Civil Defense Officer',
                'Cleaner',
                'Clergyman',
                'Clerk',
                'Cold Storage Worker',
                'Commercial Photographer',
                'Compositor-Electronic',
                'Compositor-Mechanical',
                'Computer Engineer',
                'Computer Operator',
                'Computer Programmer',
                'Computer Systems Analyst',
                'Computer Technician',
                'Conductor',
                'Constable',
                'Construction Worker',
                'Consultant',
                'Cook',
                'Copywriter',
                'Councillor',
                'Courier',
                'Cropduster',
                'Croupier',
                'Customs Official',
                'Dairy Worker',
                'Dancing Teacher',
                'Dean',
                'Demolition Worker',
                'Dental Assistant',
                'Dental Technician',
                'Dentist',
                'Detective',
                'Diamond Cutter',
                'Dietician',
                'Director',
                'Display Artist',
                'Diver',
                'Dockworker',
                'Doctor',
                'Domestic',
                'Draughtsman',
                'Dressmaker',
                'Driller',
                'Driver',
                'Dry Cleaner',
                'Economist',
                'Editor',
                'Education Inspector',
                'Educator',
                'Electrical Contractor',
                'Electrician',
                'Electronics Engineer',
                'Electroplater',
                'Employee',
                'Engineer',
                'Engineer-Qualified',
                'Engraver',
                'Entomologist',
                'Estate Agent',
                'Executive',
                'Explosives Worker',
                'Exterminator',
                'Farm Worker',
                'Farmer Foreman',
                'Farmer Manager',
                'Farmer Owner',
                'Fashion Designer',
                'Film Maker',
                'Fireman',
                'Fisherman',
                'Fitter And Turner',
                'Floor Surfacer',
                'Florist',
                'Foreman',
                'Forester',
                'Fortune Teller',
                'Foundry Manager',
                'Foundry Worker',
                'Freight Forwarder',
                'Fumigator',
                'Furnace Assistant',
                'Furnace Manager',
                'Furnace Supervisor',
                'Game Ranger',
                'Game Warden',
                'Garage Attendant',
                'Garage Owner',
                'Gardener',
                'General Assistant',
                'General Dealer',
                'General Worker',
                'Geologist',
                'Glassblower',
                'Glazier',
                'Goldsmith',
                'Grain Silo Operator',
                'Graphic Designer',
                'Greengrocer',
                'Groundsman',
                'Guard (Security)',
                'Gunsmith',
                'Hairdresser',
                'Hawker',
                'Head Of Department',
                'Headmaster',
                'Health Inspector',
                'Homeopath',
                'Horticulturist',
                'Hotel Manager',
                'Housewife',
                'Hr Assistant',
                'Inspector',
                'Insurance Agent',
                'Insurance Assessor',
                'Interior Decorator',
                'Interpreter',
                'Investigator',
                'Jeweller',
                'Jockey',
                'Joiner',
                'Journalist',
                'Labourer',
                'Lawyer',
                'Lecturer',
                'Librarian',
                'Lift Inspector',
                'Lift Operator',
                'Lift Technician',
                'Lighthouse Keeper',
                'Locksmith',
                'Machine Operator',
                'Machinist',
                'Magistrate',
                'Major',
                'Manager',
                'Manicurist',
                'Manufacturer',
                'Market Researcher',
                'Marketing Officer',
                'Martial Arts Instructor',
                'Mason',
                'Meat Inspector',
                'Mechanic',
                'Medical Representative',
                'Medical Technologist',
                'Medical-Practitioner',
                'Merchandiser',
                'Merchant Seaman',
                'Messenger',
                'Metallurgist',
                'Meter Reader',
                'Midwife',
                'Millwright',
                'Miner',
                'Minister Of Religion',
                'Model',
                'Motor Salesman',
                'Motor Spares Salesman',
                'Moulder',
                'Musician',
                'Naval Personnel',
                'Night Watchman',
                'Nurse',
                'Nurseryman',
                'Nursing Assistant',
                'Nursing Sister',
                'Occupational Therapist',
                'Officer',
                'Operator',
                'Ophthalmologist',
                'Optical Mechanic',
                'Orthopedic Orthopedist',
                'Packer',
                'Painter',
                'Painting Contractor',
                'Panelbeater',
                'Paramedic',
                'Pastor',
                'Pawnbroker',
                'Pensioner',
                'Permanent Way',
                'Personnel Officer',
                'Pest Exterminator',
                'Petrol Attendant',
                'Petroleum Refinery',
                'Pharmacist',
                'Photographer',
                'Physiotherapist',
                'Piano Tuner',
                'Pilot',
                'Plasterer',
                'Plumber',
                'Police Constable',
                'Police Woman',
                'Policeman',
                'Porter',
                'Postman',
                'Postmaster',
                'Principal',
                'Printer',
                'Prisons Personnel',
                'Private Investigator',
                'Producer',
                'Professor',
                'Programmer',
                'Property Appraiser',
                'Proprietor',
                'Public Prosecutor',
                'Public Relations Officer',
                'Quality Controller',
                'Quantity Surveyor',
                'Quarryman',
                'Racehorse Trainer',
                'Radiographer',
                'Radiologist',
                'Receptionist',
                'Religious Leader',
                'Repairman',
                'Representative',
                'Research Assistant',
                'Restaurant Owner',
                'Retired',
                'Rigger (Docks)',
                'Roadworker',
                'Sailor',
                'Sales Consultant',
                'Sales Lady',
                'Sales Support',
                'Sales Woman',
                'Salesman',
                'Seaman',
                'Seaman (Merchant)',
                'Seamstress',
                'Secretary',
                'Security Guard',
                'Self-Employed',
                'Sergeant',
                'Shedman',
                'Sheet Metal Worker',
                'Shipping Agent',
                'Shop Assistant',
                'Shop Manager',
                'Shopfitter',
                'Shunter-Foreman',
                'Signwriter',
                'Silversmith',
                'Singer',
                'Slaughterer',
                'Smelter',
                'Social Worker',
                'Soldier',
                'Sound Engineer',
                'Sportsman',
                'Sportswoman',
                'Spray Painter',
                'Sprayer',
                'Stationmaster',
                'Statistician',
                'Stevedore',
                'Steward',
                'Stock Broker',
                'Store Lady',
                'Storeman',
                'Student',
                'Supervisor',
                'Surgeon',
                'Sweeper',
                'Swimming Pool Attendant',
                'Switchboard Operator',
                'Systems Analyst',
                'Tailor',
                'Taxi Driver',
                'Teacher',
                'Technician',
                'Telegraphist',
                'Telephone Technician',
                'Telephonist',
                'Tiler',
                'Toolmaker',
                'Town Clerk',
                'Town Planner',
                'Trader',
                'Tradesman',
                'Traffic Officer',
                'Trainer',
                'Translator',
                'Travel Agent',
                'Typesetter',
                'Typist',
                'Undertaker',
                'Underwriter',
                'Unemployed',
                'Upholsterer',
                'Urologist',
                'Vetrinarian',
                'Vetrinary Surgeon',
                'Vulcaniser',
                'Waiter',
                'Waitress',
                'Warden',
                'Watch Maker',
                'Watchman',
                'Welder',
                'Well Sinker',
                'Window Cleaner',
                'Window Dresser',
                'Wood Cutter',
                'Worker',
                'Wrestler',
              ],
            },
            {
              id: 'basic-earnings',
              type: 'amount',
              elementType: 'input',
              readonly: false,
              label: 'Basic Earnings',
              uid: 'e332b06a8067e39e',
              content: '',
              publishChange: true,
              inputType: 'number',
            },
            {
              id: 'tin-number',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Tin Number',
              uid: '20c94cac97bfda6c',
              content: '',
              publishChange: true,
              inputType: 'text',
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '020c37c5318b80c2',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'c703952621f90bac',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '8d21de66da44be75',
                  content: '<p>Bloom</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: 'f812ed1a852a1ac2',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: '3936804ba35e8773',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Ladycare Enhanced Owner Details',
    uri: 'ladycare-plus/owner-details',
    class: 'ladycare-enhanced-owner-details',
  },
  'existing-coverage': {
    text: [],
    buttons: [
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'existing-policies',
      type: 'list',
      readonly: false,
      label: 'Existing Policies',
      uid: '356fcea65033f098',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'e2c5b035f1d1d961',
          content: '<h2>Existing insurance arrangements</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '6162dfa9508b7a86',
          content: '',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '844fbcf147fdfdba',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'existing-coverages',
          type: 'list',
          readonly: false,
          label: 'Existing Coverages',
          uid: '7cc12b2145a5f50c',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'd968197bc8ba287b',
              content:
                '<p>Do you have an existing, or are you presently applying (excluding this application) for life insurance with this or any insurance company?</p>\n',
            },
            {
              id: 'existing-coverage',
              type: 'field',
              elementType: 'checkbox',
              readonly: false,
              label: 'Existing Coverage',
              uid: 'bdafc0708798679d',
              content: '',
              publishChange: true,
              options: ['Y', 'N'],
            },
          ],
        },
        {
          id: 'replace-coverage',
          type: 'list',
          readonly: false,
          label: 'Replace Coverage',
          uid: 'feb660086d8a4d4f',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '8ac0a4fa34ce350c',
              content:
                '<p>Is this application to replace the whole or part of any application to this or any office?</p>\n',
            },
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'c554f2b6026d0695',
              content:
                '<p>Or to replace all or part of existing assurances with any office?</p>\n',
            },
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'd7c1e41cdfbe8101',
              content:
                '<p>(whether replacement is to occur immediately or to replace an insurance policy discontinued within the past six months or to be discontinued within the next six months)</p>\n',
            },
            {
              id: 'application-replaces-existing',
              type: 'field',
              elementType: 'checkbox',
              readonly: false,
              label: 'Application Replaces Existing',
              uid: '2e038ebc229ed92d',
              content: '',
              publishChange: true,
              options: ['Y', 'N'],
            },
          ],
        },
        {
          id: 'existing-policies-details',
          type: 'list',
          readonly: false,
          label: 'Existing Policies Details',
          uid: '427309bfc272eea5',
          content: [
            {
              id: 'existing-policy1',
              type: 'list',
              readonly: false,
              label: 'Existing Policy-1',
              uid: 'f8e771d63d741996',
              content: [
                {
                  id: 'company-name-1',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Company Name',
                  uid: 'fc4d77883a57ab48',
                  content: '',
                  publishChange: true,
                  inputType: 'text',
                },
                {
                  id: 'existing-contract-id-1',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Existing Contract ID',
                  uid: '52bb36b4c07f50a5',
                  content: '',
                  publishChange: true,
                  inputType: 'text',
                },
                {
                  id: 'sum-assured-1',
                  type: 'amount',
                  elementType: 'input',
                  readonly: false,
                  label: 'Sum Assured',
                  uid: 'ec4fbf1f63ab7896',
                  content: '',
                  publishChange: true,
                  inputType: 'number',
                },
              ],
            },
            {
              id: 'existing-policy2',
              type: 'list',
              readonly: false,
              label: 'Existing Policy-2',
              uid: 'f27100a9f359f6ee',
              content: [
                {
                  id: 'company-name-2',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Company Name',
                  uid: 'db627ad9150032a4',
                  content: '',
                  publishChange: true,
                  inputType: 'text',
                },
                {
                  id: 'existing-contract-id-2',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Existing Contract ID',
                  uid: '59d107ccd92a2ea1',
                  content: '',
                  publishChange: true,
                  inputType: 'text',
                },
                {
                  id: 'sum-assured-2',
                  type: 'amount',
                  elementType: 'input',
                  readonly: false,
                  label: 'Sum Assured',
                  uid: 'ca72fb7bb9dc7bde',
                  content: '',
                  publishChange: true,
                  inputType: 'number',
                },
              ],
            },
            {
              id: 'existing-policy3',
              type: 'list',
              readonly: false,
              label: 'Existing Policy-3',
              uid: '4ccea37b508e3a11',
              content: [
                {
                  id: 'company-name-3',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Company Name',
                  uid: 'a6db2c3f53484527',
                  content: '',
                  publishChange: true,
                  inputType: 'text',
                },
                {
                  id: 'existing-contract-id-3',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Existing Contract ID',
                  uid: 'adcf9a44040b8b51',
                  content: '',
                  publishChange: true,
                  inputType: 'text',
                },
                {
                  id: 'sum-assured-3',
                  type: 'amount',
                  elementType: 'input',
                  readonly: false,
                  label: 'Sum Assured',
                  uid: '3761da6a391a2146',
                  content: '',
                  publishChange: true,
                  inputType: 'number',
                },
              ],
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '58e89d4f55c43e46',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'bcc460964703236b',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '014631cdada3fa2e',
                  content: '<p>Bloom</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: 'ae7ea230a51e4d35',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'd11d4c897e80dc24',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'LADYCARE ENHANCED Spouse Details',
    uri: 'ladycare-enhanced/spouse-details',
    template: 'ladycare-enhanced-app-template',
    class: 'ladycare-enhanced-spouse-details',
  },
  'medical-underwriting': {
    text: [],
    buttons: [
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'general-occupation-activities-and-smoking-habits',
      type: 'list',
      readonly: false,
      label: 'General Occupation Activities And Smoking Habits',
      uid: 'f54d82f4a16a45e1',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '305332a95993c793',
          content: '<h2>Medical Underwriting</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '628a35e20bfcf58d',
          content: '',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '509234bf60e22682',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='done clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'inputs',
          type: 'list',
          readonly: false,
          label: 'Inputs',
          uid: '5a1c2ac4abfed6f4',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'f5953515522188db',
              content:
                '<p><em>Please note that all medical questions are related to the main life assuerd on this policy.</em></p>\n',
            },
            {
              id: 'question-one',
              type: 'list',
              readonly: false,
              label: 'Question One',
              uid: 'df803fd5532224c8',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'b69f9237a4c067e2',
                  content:
                    '<ol>\n<li>Are you presently negotiating or planning to negotiate for any other assurance on your life with this or any other assurer?</li>\n</ol>\n',
                },
                {
                  id: 'planning-other-insurance',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Planning Other Insurance',
                  uid: 'afa5b73efa5eef2c',
                  content: '',
                  publishChange: true,
                  options: ['Yes', 'No'],
                },
                {
                  id: 'planning-other-insurance-details',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Details',
                  uid: '1db4cc6cb136397e',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Reason',
                  inputType: 'text',
                },
              ],
            },
            {
              id: 'question-two',
              type: 'list',
              readonly: false,
              label: 'Question Two',
              uid: '6c86ef37e0ae5845',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '00f7ced091e89fd5',
                  content:
                    "<ol start='2'>\n<li>Apart from details supplied in answer to Question 1 above, has any other assurance on your life been effected during the past 12 months?</li>\n</ol>\n",
                },
                {
                  id: 'other-assurance-past12-months',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Other Assurance Past-12 Months',
                  uid: 'dee16f3be8dbd5e6',
                  content: '',
                  publishChange: true,
                  options: ['Yes', 'No'],
                },
                {
                  id: 'other-assurance-past12-months-details',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Details',
                  uid: '85bfbf86b41e8656',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Reason',
                  inputType: 'text',
                },
              ],
            },
            {
              id: 'question-three',
              type: 'list',
              readonly: false,
              label: 'Question Three',
              uid: 'a4de28cb26b02b5d',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '5c2fab94f400e917',
                  content:
                    "<ol start='3'>\n<li>Does the cover on your life under this and any simultaneous applications exceed GHc 100,000?</li>\n</ol>\n",
                },
                {
                  id: 'cover-exceeds-one-hundred-thousand',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Cover Exceeds One Hundred Thousand',
                  uid: 'ed52fcbe32fd1ab7',
                  content: 'Yes',
                  publishChange: true,
                  options: ['Yes', 'No'],
                },
                {
                  content: [
                    {
                      content: '<p>Average Monthly Gross Income</p>\n',
                      id: 'system-constant',
                      label: '',
                      readonly: true,
                      type: 'html',
                      uid: 'fe4c7dd9d24c2a9e',
                    },
                    {
                      content: '',
                      elementType: 'input',
                      errors: ['*'],
                      id: 'average-monthly-gross-income',
                      inputType: 'text',
                      label: 'Details',
                      publishChange: true,
                      readonly: false,
                      type: 'field',
                      uid: '31a3ecab4a74c98a',
                    },
                  ],
                  id: 'system-list',
                  label: 'System List',
                  readonly: false,
                  type: 'list',
                  uid: '5f8b25ed4415c897',
                },
                {
                  content: [
                    {
                      content:
                        '<p>Total Existing Assurance Cover in force on your life</p>\n',
                      id: 'system-constant',
                      label: '',
                      readonly: true,
                      type: 'html',
                      uid: 'ff1462e881f44c02',
                    },
                    {
                      content: '',
                      elementType: 'input',
                      id: 'total-existing-assurance-cover-in-force-on-your-life',
                      inputType: 'text',
                      label: 'Details',
                      publishChange: true,
                      readonly: false,
                      type: 'field',
                      uid: '31a3ecab4a74c98a',
                    },
                  ],
                  id: 'system-list',
                  label: 'System List',
                  readonly: false,
                  type: 'list',
                  uid: 'beaacad6ef6645ee',
                },
                {
                  content: [
                    {
                      content:
                        '<p>Full reasons for effecting this additional cover</p>\n',
                      id: 'system-constant',
                      label: '',
                      readonly: true,
                      type: 'html',
                      uid: '05a98ad847dcad34',
                    },
                    {
                      content: '',
                      elementType: 'input',
                      id: 'full-reasons-for-effecting-this-additional-cover',
                      inputType: 'text',
                      label: 'Details',
                      publishChange: true,
                      readonly: false,
                      type: 'field',
                      uid: '31a3ecab4a74c98a',
                    },
                  ],
                  id: 'system-list',
                  label: 'System List',
                  readonly: false,
                  type: 'list',
                  uid: '91930796f1d9da82',
                },
              ],
            },
            {
              id: 'question-four',
              type: 'list',
              readonly: false,
              label: 'Question Four',
              uid: '916e7801642da0e6',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'a95c89b874158f95',
                  content:
                    "<ol start='4'>\n<li>Have you in the past five years been engaged in or do you intend engaging in any hazardous occupation or pursuit, eg; mining, use of explosives, parachuting, hang-gliding, private flying, underwater diving, mountaineering?</li>\n</ol>\n",
                },
                {
                  id: 'risky-occupation-hobbies',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Risky Occupation Hobbies',
                  uid: '472f03f449a53db2',
                  content: '',
                  publishChange: true,
                  options: ['Yes', 'No'],
                },
                {
                  id: 'risky-occupation-hobbies-details',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Details',
                  uid: '48bb179f6b60ab40',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Reason',
                  inputType: 'text',
                },
              ],
            },
            {
              id: 'question-five',
              type: 'list',
              readonly: false,
              label: 'Question Five',
              uid: '4326797724586a8e',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '4415eda17ab12dbe',
                  content:
                    "<ol start='5'>\n<li>Has any application on your life ever been declined, postponed, withdrawn or accepted on special terms: If Yes, give details below</li>\n</ol>\n",
                },
                {
                  id: 'refused-application-or-increased-premium',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Refused Application Or Increased Premium',
                  uid: '96867d2850c5fc62',
                  content: '',
                  publishChange: true,
                  options: ['Yes', 'No'],
                },
                {
                  id: 'refused-application-or-increased-premium-details',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Details',
                  uid: '20ad0f6e4b733b27',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Reason',
                  inputType: 'text',
                },
              ],
            },
            {
              id: 'question-six',
              type: 'list',
              readonly: false,
              label: 'Question Six',
              uid: '99b7484fe7f5f5ed',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '38c54c48b2a748d3',
                  content:
                    "<ol start='6'>\n<li>Are your affairs currently subject to the control of a trustee or curator, due to insolvency or other reasons? If Yes, give details below</li>\n</ol>\n",
                },
                {
                  id: 'insolvency-issues',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Insolvency Issues',
                  uid: 'aa3968daf7ccece0',
                  content: 'Yes',
                  publishChange: true,
                  options: ['Yes', 'No'],
                },
                {
                  id: 'insolvency-issues-details',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Details',
                  uid: 'cd6edb73a6b53740',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Reason',
                  inputType: 'text',
                },
              ],
            },
            {
              id: 'question-seven',
              type: 'list',
              readonly: false,
              label: 'Question Seven',
              uid: '7345b2932559b891',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '130c3c9eb8edbc68',
                  content:
                    "<ol start='7'>\n<li>Do you in the course of your occupation perform duties that are not clerical or administrative?</li>\n</ol>\n",
                },
                {
                  id: 'occupation-not-clerical',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Occupation Not Clerical',
                  uid: '4a17700ed64ac83e',
                  content: '',
                  publishChange: true,
                  options: ['Yes', 'No'],
                },
                {
                  id: 'occupation-not-clerical-details',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Details',
                  uid: 'f278dd8861bfc0ef',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Reason',
                  inputType: 'text',
                },
              ],
            },
            {
              id: 'question-eight',
              type: 'list',
              readonly: false,
              label: 'Question Eight',
              uid: 'c2ff0534314e63e2',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'cfb0d9bf19450299',
                  content: "<ol start='8'>\n<li>Smoking habits</li>\n</ol>\n",
                },
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '43e493e7fca1e759',
                  content:
                    '<p>NB: For rating purposes, a non-smoker is a person who has not smoked tobacco in any form for the past two years,</p>\n',
                },
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'e729e1ef79c1e527',
                  content:
                    '<p>has no intention of smoking in the future and accepts that Enterprise Life Assurance Limited may require a urine test to check for nicotine traces.</p>\n',
                },
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '152dcc779b4abff0',
                  content: '<p>8.1.1 Current Status</p>\n',
                },
                {
                  id: 'smoker-options-radio-group',
                  type: 'list',
                  readonly: false,
                  label: 'Smoker Options Radio Group',
                  uid: '12a99cfcf9087946',
                  content: [
                    {
                      id: 'smoker',
                      type: 'field',
                      elementType: 'checkbox',
                      readonly: false,
                      label: 'Smoker',
                      uid: '4f6b0394d93e12cb',
                      content: '',
                      publishChange: true,
                      options: ['Y', 'N'],
                    },
                    {
                      id: 'non-smoker',
                      type: 'field',
                      elementType: 'checkbox',
                      readonly: false,
                      label: 'Non Smoker',
                      uid: 'c9e943aae7f9936a',
                      content: '',
                      publishChange: true,
                      errors: ['*'],
                      options: ['Y', 'N'],
                    },
                    {
                      id: 'never-smoked',
                      type: 'field',
                      elementType: 'checkbox',
                      readonly: false,
                      label: 'Never Smoked',
                      uid: '94e911ab05895fa3',
                      content: '',
                      publishChange: true,
                      errors: ['*'],
                      options: ['Y', 'N'],
                    },
                  ],
                },
                {
                  id: 'years-smoking',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Years Smoking',
                  uid: '154114de46ecb5c4',
                  content: '',
                  publishChange: true,
                  errors: ['*', '*'],
                  inputType: 'text',
                },
                {
                  content: '',
                  elementType: 'input',
                  errors: ['*'],
                  id: 'years-not-smoking',
                  inputType: 'text',
                  label: 'Years Not Smoking',
                  publishChange: true,
                  readonly: false,
                  type: 'field',
                  uid: '8efdf8d15d84c2f1',
                },
                {
                  id: 'smoking-details',
                  type: 'list',
                  readonly: false,
                  label: 'Smoking Details',
                  uid: '71763b9aeae14f09',
                  content: [
                    {
                      content: '<p>8.1.2 Average daily habit</p>\n',
                      id: 'system-constant',
                      label: '',
                      readonly: true,
                      type: 'html',
                      uid: '786e91281548c845',
                    },
                    {
                      content: '',
                      elementType: 'input',
                      errors: ['*'],
                      id: 'cigarettes-per-day',
                      inputType: 'number',
                      label: 'Cigarettes Per Day',
                      publishChange: true,
                      readonly: false,
                      type: 'real',
                      uid: 'f1b1ed403acc60e6',
                    },
                    {
                      content: '',
                      elementType: 'input',
                      errors: ['*'],
                      id: 'cigars-per-day',
                      inputType: 'number',
                      label: 'Cigars Per Day',
                      publishChange: true,
                      readonly: false,
                      type: 'real',
                      uid: '11486df8c6636515',
                    },
                    {
                      content: '',
                      elementType: 'input',
                      errors: ['*'],
                      id: 'pipe',
                      inputType: 'number',
                      label: 'Pipe',
                      publishChange: true,
                      readonly: false,
                      type: 'real',
                      uid: '541ee2719f6a1075',
                    },
                    {
                      content:
                        '<p>8.1.3 Have you ever stopped smoking on specific medical advice?</p>\n',
                      id: 'system-constant',
                      label: '',
                      readonly: true,
                      type: 'html',
                      uid: '88e8a048c3379d45',
                    },
                    {
                      content: '',
                      elementType: 'radio',
                      errors: ['*'],
                      id: 'medical-advice-stop-smoking',
                      label: 'Medical Advice Stop Smoking',
                      options: ['Yes', 'No'],
                      publishChange: true,
                      readonly: false,
                      type: 'field',
                      uid: 'f945d27cf89f14a0',
                    },
                  ],
                },
              ],
            },
            {
              id: 'question-nine',
              type: 'list',
              readonly: false,
              label: 'Question Nine',
              uid: 'a4515af1f9698a55',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'ae1ffb6a0dfde53f',
                  content: "<ol start='9'>\n<li>Alcohol Habits</li>\n</ol>\n",
                },
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'b25527ae6639be0d',
                  content:
                    '<p>Have you ever received medical advice to reduce/discontinue liquor consumption?</p>\n',
                },
                {
                  id: 'medical-advice-reduce-drinking',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Medical Advice Reduce Drinking',
                  uid: 'ce63aade7fe8e2a7',
                  content: '',
                  publishChange: true,
                  options: ['Yes', 'No'],
                },
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'cf39f62f8252a730',
                  content:
                    '<p>Do you on average consume more than three alcoholic drinks per day? (1 drink equals 1 tot of spirit or 1 pint of beer or 1 glass of wine)</p>\n',
                },
                {
                  id: 'excessive-drinking',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Excessive Drinking',
                  uid: 'fe6cb47bdbe1896f',
                  content: '',
                  publishChange: true,
                  options: ['Yes', 'No'],
                },
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '35f32b5c1c2a2472',
                  content: '<p>Did you ever drink more in the past?</p>\n',
                },
                {
                  id: 'excessive-drinking-past',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Excessive Drinking Past',
                  uid: 'e3477bbf4ff0d3f1',
                  content: '',
                  publishChange: true,
                  options: ['Yes', 'No'],
                },
              ],
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: 'bdeafdc680cc4cf9',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'd9d3a8422789a673',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '689e33acbd3b3c22',
                  content: '<p>Bloom</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: 'b541e8f16fbaf688',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'd836c41c4f3f51d4',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'LADYCARE ENHANCED Policyholder Habits',
    uri: 'ladycare-enhanced/policyholder-habits',
    template: 'ladycare-enhanced-app-template',
    class: 'ladycare-enhanced-policyholder-habits',
  },
  'medical-declaration': {
    text: [],
    buttons: [
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'medical-declaration',
      type: 'list',
      readonly: false,
      label: 'Medical Declaration',
      uid: '7e48db8235d14444',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'edeb9bb462e75465',
          content: '<h2>Medical Underwriting</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '8cb5b9f7f893ab25',
          content: '',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '7dd45a20ec98eb62',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='done clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'inputs',
          type: 'list',
          readonly: false,
          label: 'Inputs',
          uid: 'd77855fe77b73172',
          content: [
            {
              id: 'question-one',
              type: 'list',
              readonly: false,
              label: 'Question One',
              uid: '0d9656c3fc437931',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '75ce797fb8e56305',
                  content:
                    '<ol>\n<li>Have you during the past five years sought medical advice, and/or had surgical treatment?</li>\n</ol>\n',
                },
                {
                  id: 'surgery-last-five-years',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Surgery Last Five Years',
                  uid: '18b188d4f9f8e0b2',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: ['Yes', 'No'],
                },
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'a68b2b837851c2f0',
                  content:
                    '<p>Have you during, the past five years undergone any medical investigation of whatsoever nature such as X-ray, ECGs, blood test, etc?</p>\n',
                },
                {
                  id: 'medical-tests-last-five-years',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Medical Tests Last Five Years',
                  uid: 'eaf5bdf670297a80',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: ['Yes', 'No'],
                },
              ],
            },
            {
              id: 'question-two',
              type: 'list',
              readonly: false,
              label: 'Question Two',
              uid: '9cb48fdf823bdb6b',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '5cef10af8bee58a1',
                  content:
                    "<ol start='2'>\n<li>If not already recorded in answer to the previous question have you ever experienced any of the health problems listed below:</li>\n</ol>\n",
                },
                {
                  id: 'chest-pain',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label:
                    '2.1 Rheumatic fever, heart murmurs, chest pain, angina, coronary thrombosis.',
                  uid: '89c7b191d1133686',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'high-blood-pressure',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label:
                    '2.2 High blood pressure, impaired blood circulation, stroke.',
                  uid: '8b34197c5396c863',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'respiratory-condition',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label:
                    '2.3 Conditions of lungs or respiratory system eg. asthma, shortness of breath, persistent cough or tuberculosis.',
                  uid: 'aed20df7d8cf8005',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'digestive-condition',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label:
                    '2.4 Conditions of digestive system, gall bladder, pancrease or liver, eg: gastric or duodenal ulcer, recurrent indigestion, hiatus hernia or jaundice.',
                  uid: '0190aa2e13d5110d',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'urinary-condition',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label:
                    '2.5 Conditions of the urinary tract, eg. burning urine, nephritis kidney stones, congenital abnormalities.',
                  uid: 'c15e5945fe05a08d',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'anxiety-epilepsy',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label:
                    '2.6 Anxiety or depressive states, epilepsy or black outs',
                  uid: '13f3db61ead4e5ae',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'diabetes',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: '2.7 Diabetes, sugar in urine or glandular disorder',
                  uid: 'ea1d64de1f146aad',
                  content: 'N',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'cancer-or-tumors',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label:
                    '2.8 Cancer, tumors, lumps, swelling or blood disorders e.g. raised cholesterol',
                  uid: '1c4f7caee71fc9e4',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'arthritis-osteoporosis',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: '2.9 Rheumatoid Arthritis, Osteoporosis.',
                  uid: '08ada2b4de6c194a',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
              ],
            },
            {
              id: 'question-three',
              type: 'list',
              readonly: false,
              label: 'Question Three',
              uid: '16617e3f1a55f56f',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '32a5c5fe93e9171c',
                  content:
                    "<ol start='3'>\n<li>Have you ever been tested or received medical advice, counselling of treatment in connection with:</li>\n</ol>\n",
                },
                {
                  id: 'aids',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: '3.1 AIDS or infection by one of the AIDS viruses?',
                  uid: '8e0e5879b6eda8cc',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'sexually-transmitted-disease',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label:
                    '3.2 Any sexually transmitted disease, eg. hepatitis B, Gonorhea, Syphylis, Penile or Vaginal discharge?',
                  uid: '5eec406c620554d1',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
              ],
            },
            {
              id: 'question-four',
              type: 'list',
              readonly: false,
              label: 'Question Four',
              uid: 'eec8ea9e4d4dfbc4',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'ebff9930b45a1462',
                  content:
                    "<ol start='4'>\n<li>Are you currently taking any drugs or prescribed medicines?</li>\n</ol>\n",
                },
                {
                  id: 'taking-medication',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Taking Medication',
                  uid: 'f5358a4160b2062f',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: ['Yes', 'No'],
                },
              ],
            },
            {
              id: 'question-five',
              type: 'list',
              readonly: false,
              label: 'Question Five',
              uid: 'e19ee7feb56d908b',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '3c1d81ef9cf2c442',
                  content:
                    "<ol start='5'>\n<li>Do you have any form of disability, eg: loss of use of any limb, impaired sight or hearing</li>\n</ol>\n",
                },
                {
                  id: 'disability',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Disability',
                  uid: '8fa8d9d3c46c0c1f',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: ['Yes', 'No'],
                },
              ],
            },
            {
              id: 'question-six',
              type: 'list',
              readonly: false,
              label: 'Question Six',
              uid: 'a9e372de58df83b4',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '81503d816f4154e3',
                  content:
                    "<ol start='6'>\n<li>Are you aware of any other circumstances which may influence the risk of an assurance on your life, eg; persistent fever or skin disorders, unexplained weight loss, recurrent diarrhoea or bleeding from the bowels, night sweats?</li>\n</ol>\n",
                },
                {
                  id: 'assurance-risk',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Assurance Risk',
                  uid: '606253c0eb49f0cb',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: ['Yes', 'No'],
                },
              ],
            },
            {
              id: 'question-seven',
              type: 'list',
              readonly: false,
              label: 'Question Seven',
              uid: 'a311984390ff1a10',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '37d256f0922ba845',
                  content:
                    "<ol start='7'>\n<li>Are you or do you suspect that you could be pregnant? If so, when was your last menstrual period?</li>\n</ol>\n",
                },
                {
                  id: 'pregnant',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Pregnant',
                  uid: 'dc8406e52200a236',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: ['Yes', 'No'],
                },
              ],
            },
            {
              id: 'question-eight',
              type: 'list',
              readonly: false,
              label: 'Question Eight',
              uid: 'f74c4ec774257a96',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '51d68fb6149ff895',
                  content:
                    "<ol start='8'>\n<li>Family medical history</li>\n</ol>\n",
                },
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '6ec660a365141b38',
                  content:
                    '<p>8.1 Is there a history in your family of diabetes, raised cholesterol, heart disease, stroke, high blood pressure, nervous or mental disorder, cancer, retinitis pigmentosa, porphyria, haemophillia or any other hereditary disease?</p>\n',
                },
                {
                  id: 'family-history-of-illness',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Family History Of Illness',
                  uid: '3a44474cd2576c11',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: ['Yes', 'No'],
                },
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '35b6853f4faf1bef',
                  content:
                    '<p>8.2 Has your father, mother, or any of your brothers or sisters died under the age of 55?</p>\n',
                },
                {
                  id: 'close-family-early-death',
                  type: 'field',
                  elementType: 'radio',
                  readonly: false,
                  label: 'Close Family Early Death',
                  uid: '1fe6bf23b71f4f8c',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: ['Yes', 'No'],
                },
              ],
            },
            {
              id: 'question-nine',
              type: 'list',
              readonly: false,
              label: 'Question Nine',
              uid: '5c716160f8d2a934',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '98a42ab04293f154',
                  content:
                    "<ol start='9'>\n<li>Your measurements</li>\n</ol>\n",
                },
                {
                  id: 'height-in-cm',
                  type: 'real',
                  elementType: 'input',
                  readonly: false,
                  label: 'Height cm',
                  uid: 'c19e6e7c25bd76a2',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  inputType: 'number',
                },
                {
                  id: 'weight-in-kg',
                  type: 'real',
                  elementType: 'input',
                  readonly: false,
                  label: 'Mass (weight in kg)',
                  uid: '501c2e65b0823d4e',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  inputType: 'number',
                },
              ],
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: 'df59df36d4b57ac7',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'c309c3e79d26e823',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '03898e1675f93852',
                  content: '<p>Bloom</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '3428f9107b3e1281',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'd3b718fa91ff280e',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'LADYCARE ENHANCED Policyholder Medical Details ',
    uri: 'ladycare-enhanced/policyholder-medical-details',
    template: 'ladycare-enhanced-app-template',
    class: 'ladycare-enhanced-policyholder-medical-details-',
  },
  'health-descriptions': {
    text: [],
    buttons: [
      { label: 'Next', id: 'next', uid: '26ca340069ec84e5', control: true },
      { label: 'Back', id: 'back', uid: '1303e2b2da021d46', control: true },
      { label: 'Cancel', id: 'cancel', uid: 'e25c3188a733209e', control: true },
    ],
    item: {
      id: 'health-descriptions',
      type: 'list',
      readonly: false,
      label: 'Health Descriptions',
      uid: 'fed88f569f729c85',
      content: [],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'LADYCARE ENHANCED Health Details',
    uri: 'ladycare-enhanced/health-details',
    class: 'ladycare-enhanced-health-details',
  },
  'payment-details': {
    text: [],
    buttons: [
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'payment-details',
      type: 'list',
      readonly: false,
      label: 'Payment Details',
      uid: 'a80060c1fca756f7',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '53606e9c53fc5262',
          content: '<h2>Payment Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '493a034ea85c537a',
          content:
            '<p>Please complete your preferred payment method and payment details below.</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '373c5662bc08cf41',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#additional'>Additional</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='done clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='done clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'payment-method',
          type: 'list',
          readonly: false,
          label: 'Payment Method',
          uid: '935b4319fdcbab12',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'b3820d390c57590c',
              content: '<p>Choose a payment method</p>\n',
            },
            {
              id: 'payment-method-radio-group',
              type: 'list',
              readonly: false,
              label: 'Payment Method Radio Group',
              uid: '5f29ef713684dcdd',
              content: [
                {
                  id: 'debit-order',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Debit Order',
                  uid: '66026bce0175bd85',
                  content: '',
                  publishChange: true,
                  options: ['Y'],
                },
                {
                  id: 'stop-order',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Stop Order',
                  uid: 'addc4bc1f4c832eb',
                  content: '',
                  publishChange: true,
                  options: ['Y'],
                },
              ],
              errors: ['*'],
            },
          ],
        },
        {
          id: 'payment-commencement',
          type: 'list',
          readonly: false,
          label: 'Payment Commencement',
          uid: '37d93c65a94795a7',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'a50540585ca12c07',
              content:
                '<p>Choose the payment start date and your payment frequency</p>\n',
            },
            {
              id: 'payment-start-date',
              type: 'integer',
              elementType: 'select',
              readonly: false,
              label: 'Payment Start Date',
              uid: 'cd4537bfa3fb5f7d',
              content: '20220301',
              publishChange: true,
              options: ['', '20220301', '20220401', '20220501'],
            },
            {
              id: 'payment-frequency-radio-group',
              type: 'list',
              readonly: false,
              label: 'Payment Frequency Radio Group',
              uid: 'b57e2178f2c6665f',
              content: [
                {
                  id: 'monthly',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Monthly',
                  uid: '3f6c19ccd48cbeeb',
                  content: '',
                  publishChange: true,
                  options: ['Y'],
                },
                {
                  id: 'quarterly',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Quarterly',
                  uid: '3085ba131761cdaa',
                  content: '',
                  publishChange: true,
                  options: ['Y'],
                },
                {
                  id: 'annual',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Annual',
                  uid: 'a4ebf2837b1d7e08',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'bi-annual',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Bi Annual',
                  uid: 'b31610ed69249641',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
              ],
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '613cbb8ace176b7a',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'bef89980c6ae1234',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'c33afdaa5239870c',
                  content: '<p>Bloom</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: 'b25aa5e49e79acdf',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'fb3a74d8b4c60af2',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Ladycare Enhanced Payment Details',
    uri: 'ladycare-plus/quote',
    template: 'ladycare-enhanced-app-template',
    class: 'ladycare-enhanced-payment-details',
  },
  'debit-order-details': {
    text: [],
    buttons: [
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'payment-details',
      type: 'list',
      readonly: false,
      label: 'Payment Details',
      uid: 'd16f40ad13518816',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '53606e9c53fc5262',
          content: '<h2>Payment Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '493a034ea85c537a',
          content:
            '<p>Please complete your preferred payment method and payment details below.</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '373c5662bc08cf41',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#additional'>Additional</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='done clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='done clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'debit-order-details',
          type: 'list',
          readonly: false,
          label: 'Debit Order Details',
          uid: 'd3c9a331e021ed0b',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '82bc4d510e05f52c',
              content: '<p>Complete the following details</p>\n',
            },
            {
              id: 'new-account-details',
              type: 'list',
              readonly: false,
              label: 'New Account Details',
              uid: 'ab888ee5c456cdea',
              content: [
                {
                  id: 'account-holder-name',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Account Holder Name',
                  uid: '039eb80e4a10de79',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  inputType: 'text',
                },
                {
                  id: 'account-type',
                  type: 'field',
                  elementType: 'select',
                  readonly: false,
                  label: 'Account Type',
                  uid: 'fbdc797b84a0f751',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: ['', 'Current', 'Savings'],
                },
                {
                  id: 'account-entity-name',
                  type: 'field',
                  elementType: 'select',
                  readonly: false,
                  label: 'Account Entity Name',
                  uid: '41ac2dfe1beb4c8d',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: [
                    '',
                    'Absa (gh) Ltd',
                    'Access Bank Ghana Ltd',
                    'Agricultural Development Bank',
                    'Bank Of Africa',
                    'Cal Bank Ltd',
                    'Consolidated Bank Ghana',
                    'Ecobank Ghana Ltd',
                    'Fidelity Bank Ghana',
                    'First Atlantic Bank Ltd',
                    'First Bank Ghana',
                    'First Bank Nigeria',
                    'First National Bank',
                    'Gcb Bank Ltd',
                    'Guaranty Trust (gh) Ltd',
                    'National Investment Bank',
                    'Omni Bank Ghana Ltd',
                    'Prudential Bank Ltd',
                    'Republic Bank (gh) Ltd',
                    'Societe General Ghana Ltd',
                    'Stanbic Bank Ghana Ltd',
                    'Standard Chartered Bank',
                    'United Bank For Africa (gh) Ltd',
                    'Universal Merchant Bank (gh) Ltd',
                    'Zenith Bank',
                  ],
                },
                {
                  content: '',
                  elementType: 'select',
                  errors: ['*'],
                  id: 'account-branch-name',
                  label: 'Account Branch Name',
                  options: [
                    '',
                    '1ST LIGHT',
                    '31ST DECEMBER MARKET',
                    'A & C MALL',
                    'A & C SHOPPING MAIL',
                    'A AND C',
                    'A AND C MALL',
                    'A COMMUNITY BANK LTD-LA',
                    'A RURAL BANK LTD-AMASAMAN',
                    'A&C MALL',
                    'AA ASANTEWAA RURAL BANK LTD',
                    'AARA RURAL BANK LTD-PAGA',
                    'AASEMAN RURAL BANK LTD-KAASE',
                    'ABBOSEY OKAI',
                    'ABBOSEY OKAI BRANCH',
                    'ABEKA',
                    'ABEKA BRANCH',
                    'ABEKA LAPAZ',
                    'ABEKA LAPAZ BRANCH',
                    'ABEKALAPAZ',
                    'ABELENKPE',
                    'ABETIFI',
                    'ABETIFI BRANCH',
                    'ABII NATIONAL SAVINGS AND LOANS LTD',
                    'ABN-50129-TEMA COMMUNITY 9',
                    'ABOABO',
                    'ABOABO MARKET TAMALE',
                    'ABOKOBI RURAL BANK LTD-ABOKOBI',
                    'ABOR',
                    'ABORA',
                    'ABOSEY OKAI',
                    'ABOSSEY OKAI',
                    'ABOSSEY OKINE',
                    'ABREPO JUNCTION',
                    'ABREPO JUNCTION BRANCH',
                    'ABREPO MAIN',
                    'ABREPO MAIN BRANCH',
                    'ABUAKWA',
                    'ABUAKWA BRANCH',
                    'ABURA DUNKWA',
                    'ABURI',
                    'ABZUGU RURAL BANK LTD',
                    'ACCCRA NEWTOWN',
                    'ACCION',
                    'ACCRA',
                    'ACCRA & MAKOLA',
                    'ACCRA BRANCH',
                    'ACCRA CENTRAL',
                    'ACCRA CENTRAL POST',
                    'ACCRA CENTRAL POSTBANK',
                    'ACCRA CORPORATE SERVICE CENTRE',
                    'ACCRA MAIN',
                    'ACCRA MALL',
                    'ACCRA NEW TOWN',
                    'ACCRA SHOPPING MAIL',
                    'ACCRA SHOPPING MALL',
                    'ACHIASE',
                    'ACHIMOTA',
                    'ACHIMOTA BRANCH',
                    'ACHIMOTA MILE 7',
                    'ACTION CHAPEL',
                    'ADA FOAH',
                    'ADA RURAL BANK LTD-KASSEH',
                    'ADABOKROM',
                    'ADABRAKA',
                    'ADABRAKA BRANCH',
                    'ADANSI RURAL BANK LTD-FOMENA',
                    'ADAWSO',
                    'ADB HOUSE',
                    'ADB HOUSE BRANCH',
                    'ADEHYEMAN SAVINGS & LOAN',
                    'ADEHYEMAN SAVINGS AND LOANS',
                    'ADENTA',
                    'ADENTA BRANCH',
                    'ADENTA MARKET',
                    'ADENTAN',
                    'ADI HARBOUR',
                    'ADIAKIO WAYA',
                    'ADIDOME',
                    'ADJABENG',
                    'ADJIRINGANOR',
                    'ADONTEN COMMUNITY BANK LTD-NEW TAFO',
                    'ADUM',
                    'ADUM BRANCH',
                    'ADUM POST',
                    'ADUMAN RURAL BANK LTD-BADU',
                    'ADUM-KUMASI',
                    'AFANA RURAL BANK LTD-SAMPA',
                    'AFFUL NKWANTA',
                    'AFFUL NKWANTA BRANCH',
                    'AFLAO',
                    'AFRAM RURAL BANK LTD-TEASE',
                    'AFRANSIE',
                    'AGAVE RURAL BANK LTD-DABALE',
                    'AGBOBLOSHIE',
                    'AGBOGBLOSHIE',
                    'AGBOGBOLSHIE',
                    'AGBOZUME',
                    'AGOGO',
                    'AGONA ABREM',
                    'AGONA AHANTA',
                    'AGONA ASHANTI',
                    'AGONA NKWANTA',
                    'AGONA RURAL BANK LTD-KWANYAKU',
                    'AGONA SWEDRU',
                    'AHAFO ANO PREMIER RURAL BANK LTD-WIOSO',
                    'AHAFO COMMUNITY RURAL BANK LTD-KUKUOM',
                    'AHANTAMAN RURAL BANK LTD-AGONA NKWANTA',
                    'AHINSAN KUMASI',
                    'AHODWO',
                    'AHODWO BRANCH',
                    'AIRPORT',
                    'AIRPORT BRANCH',
                    'AIRPORT CITY',
                    'AIRPORT CITY BRANCH',
                    'AIRPORT EAST',
                    'AIYINASE',
                    'AJUMAKO',
                    'AKASTI',
                    'AKATAKYIMAN RURAL BANK LTD-KOMENDA',
                    'AKATSI',
                    'AKIM ABENASE',
                    'AKIM ADUASA',
                    'AKIM BOSOME RURAL BANK LTD-AKIM SWEDRU',
                    'AKIM ODA',
                    'AKIM SWEDRU',
                    'AKOFO HOUSE',
                    'AKONTOMBRA',
                    'AKOSOMBO',
                    'AKOSOMBO BRANCH',
                    'AKOTI RURAL BANK LTD-ASSIN AKROPONG',
                    'AKROFUOM AREA RURAL BANK LTD-AKROFUOM',
                    'AKROPONG',
                    'AKROPONG AKWAPIM',
                    'AKROSO',
                    'AKUAPEM RURAL BANK LTD-MAMFE',
                    'AKUM RURAL BANK LTD-ELMINA',
                    'AKUMADAN',
                    'AKUSE',
                    'AKWADUM',
                    'AKWATIA',
                    'AKWETEYMAN',
                    'AKYEM MANSA RURAL BANK LTD-AYIREBI',
                    'AKYEPIM RURAL BANK LTD-GOMOA-DAW',
                    'ALABAR',
                    'ALABAR BRANCH',
                    'ALPHA CAPITAL SAVING&L LTD',
                    'AMAKOM',
                    'AMAKOM BRANCH',
                    'AMANANO RURAL BANK LTD-NYINAHIM',
                    'AMANTEN',
                    'AMASAMAN',
                    'AMASIE WEST RURAL BANK LTD-ANTOAKROM',
                    'AMATIN AND KASEI COMMUNITY BANK LTD-KASEI',
                    'AMENFIMAN RURAL BANK LTD-WASSA AKROPONG',
                    'AMERICAN HOUSE BRANCH',
                    'AMFIE RURAL BANK LTD-WAMFIE',
                    'ANDOM RURAL BANK LTD-NANDOM',
                    'ANGBE RURAL BANK LTD-PRAMPRAM',
                    'ANKOBRA WEST (ESIAMA) RURAL BANK LTD-ESIAMA',
                    'ANLO RURAL BANK LTD-ANLOGA',
                    'ANLOGA',
                    'ANSOMAN RURAL BANK LTD-MANSO-AMENFI',
                    'ANTEAKWA RURAL BANK LTD-KOFORIDUA',
                    'ANUM APAPAM',
                    'ANUM RURAL BANK LTD-ANUM',
                    'ANYA KROBO RURAL BANK LTD-ODUMASE-KROBO',
                    'ANYAA',
                    'ANYAA MARKET BRANCH',
                    'ANYINAM',
                    'APAM',
                    'APENKWA',
                    'APENKWA BRANCH',
                    'APEX BANK - BOLGA CENTRE-BOLGATANGA',
                    'APEX BANK - CAPE COASTCAPE COAST',
                    'APEX BANK - TAMALE CENTRE-TAMALE',
                    'APEX BANK -HEAD OFFICE-SOUTH RIDGE ACCRA',
                    'APEX BANK -HOHOE CENTRE-HOHOE',
                    'APEX BANK KOFORIDUA CENTRE-KOFORIDUA',
                    'APEX BANK -SUNYANI CENTRE-SUNYANI',
                    'APEX BANK -WA CENTRE-WA',
                    'APEX BANKACCRA CENTRE-ACCRA',
                    'APEX BANK-HO CENTRE-HO',
                    'APEX BANK-KUMASIKUMASI',
                    'APEX BANK-TAKORADI CENTRE-TAKORADI',
                    'APEX LINK CENTRE-CEDI HOUSE',
                    'APITAL RURAL BANK LTD-ABESIM',
                    'APLAKU',
                    'APRA RURAL BANK LTD-PRANG',
                    'ARENA BRANCH',
                    'ASAFO',
                    'ASAFO BRANCH',
                    'ASAFO MARKET',
                    'ASAMANKESE',
                    'ASANKRAGUA',
                    'ASANKRAGWA',
                    'ASANTE AKYEM RURAL BANK LTD-JUANSA',
                    'ASAWINSO BRANCH',
                    'ASAWINSO RURAL BANK LTD-SEFWI-ASAWINSO',
                    'ASEBU',
                    'ASEMKROM',
                    'ASEMPANEYE',
                    'ASH TOWN',
                    'ASHAIMAN',
                    'ASHAIMAN BRANCH',
                    'ASHAIMAN LEBABNON',
                    'ASHAIMAN MAIN BRANCH',
                    'ASHAIMAN ROUND ABOUT BRANCH',
                    'ASHALLEY BOTWE BRANCH',
                    'ASHANTI BEKWAI',
                    'ASHANTI MAMPONG',
                    'ASHIAMAN',
                    'ASHIYEA BRANCH',
                    'ASHTOWN',
                    'ASHTOWN BRANCH',
                    'ASHTOWN EAST',
                    'ASHTOWN EAST BRANCH',
                    'ASIAKWA',
                    'ASIKUMA',
                    'ASOKORE RURAL BANK LTD-ASOKRE',
                    'ASOKWA',
                    'ASOKWA BRANCH',
                    'ASSIN FOSO',
                    'ASSIN FOSU',
                    'ASSIN FOSU POST',
                    'ASSINMAN RURAL BANK LTD-ASSIN MANSO',
                    'AST MANPRUSI COMMUNITY BABK LTD-GAMBAGA',
                    'ASTERN GOMOA ASSIN RURAL BANK LTD-GOMOA-DOMINASE',
                    'ASUBONTEN RURAL BANK LTD-WORAWORA',
                    'ASUOGYAMAN RURAL BANK LTD-ACCRA',
                    'ASUOPRA RURAL BANK LTD-AFOSU',
                    'ASUTIFI RURAL BANK LTD-ACERENSUA',
                    'ASUTUARE',
                    'ASYLUM DOWN',
                    'ATAABADZE',
                    'ATEBUBU',
                    'ATIWA RURAL BANK',
                    'ATIWA RURAL BANK LTD-KWABENG',
                    'ATOMIC BRANCH',
                    'ATOMIC JUNCTION BRANCH',
                    'ATONSU',
                    'ATONSU BRANCH',
                    'ATWEABAN RURAL BANK LTD-SUNYANI',
                    'ATWIMA KWANWOMA RURAL BANK LTD-PAKYI NO. 2',
                    'ATWIMA MPONUA RURAL BANK LTD-TOASE',
                    'ATWIMA RURAL BANK LTD-FOASE',
                    'AVENOR RURAL BANK LTD-AKATSI',
                    'AVENUE CENTRAL',
                    'AWASO',
                    'AWJIASE AREA RURAL BANK LTD-AWUTU BAWJIASE',
                    'AWRA RURAL BANK LTD-WA',
                    'AWUTU',
                    'AWUTU EMASA RURAL BANK LTD-AWUMASA',
                    'AXIM',
                    'AXIM ROAD BRANCH',
                    'AYANFURI',
                    'AYETEPA',
                    'AYIREBI',
                    'AYOMSO',
                    'BAATSONA',
                    'BAATSONA BRANCH',
                    'BADUKROM',
                    'BADUMAN RURAL BANK LTD-BADU',
                    'BAMAHU',
                    'BANDA NKWANTA',
                    'BANTAMA',
                    'BANTAMA 1',
                    'BANTAMA BRANCH',
                    'BANTAMA GNTC BRANCH',
                    'BASYONDE',
                    'BATSONA BRANCH',
                    'BAWALESHIE',
                    'BAWDJIASE',
                    'BAWJIASE AREA RURAL BANK LTD-AWUTU BAWJIASE',
                    'BAWKU',
                    'BAWKU BRANCH',
                    'BCM',
                    'BECHEM',
                    'BEGORO',
                    'BEIGE CAPITAL',
                    'BEKWAI',
                    'BEPOSO',
                    'BEREKUM',
                    'BESEASE',
                    'BESSFA RURAL BANK LTD-GARU',
                    'BESTPOINT SAVINGS AND LOANS',
                    'BEYIN',
                    'BI RURAL BANK LTD-HOHOE',
                    'BIA DEBISO',
                    'BIA-TORYA RURAL BANK LTD-BONSU-NKWANTA',
                    'BIBIANI',
                    'BIMBILLA',
                    'BINABA',
                    'BIRIWA',
                    'BOGOSO',
                    'BOGOSU',
                    'BOINSO',
                    'BOKOBI RURAL BANK LTD-ABOKOBI',
                    'BOLE',
                    'BOLE BRANCH',
                    'BOLGA COMMERCIAL ROAD BRANCH',
                    'BOLGA POLICE STATION ROAD BRANCH',
                    'BOLGA POST',
                    'BOLGA POSTBANK',
                    'BOLGATANGA',
                    'BOMAA AREA RURAL BANK LTD-BOMAA',
                    'BOMOSADU RURAL BANK LTD',
                    'BOND SAVINGS AND LOANS',
                    'BONGO',
                    'BONGO RURAL BANK LTD-BOLGATANGA',
                    'BONSO NKWANTA',
                    'BONSU NKWANTA',
                    'BONTRASE',
                    'BONZALI RURAL BANK LTD-KUMBUNGU',
                    'BORIMANGA RURAL BANK LTD-SAVELEGU',
                    'BOSOME FREHO RURAL BANK LTD-KUMASI',
                    'BOSOMTWI RURAL BANK LTD-KUNTANASE',
                    'BOUNDARY ROAD',
                    'BRAKWA BRAMAN RURAL BANK LTD-BRAKWA',
                    'BREEZE EAST LEGON',
                    'BREMAN ASIKUMA',
                    'BREMAN UGC',
                    'BUI',
                    'BUILSA COMMUNITY BANK LTD-SANDEMA',
                    'BUIPE',
                    'BUNKPRUGU',
                    'BURMA CAMP',
                    'BURMA CAMP BRANCH',
                    'BUSIE',
                    'BUSUNYA',
                    'BUTAWU RURAL BANK LTD-HO',
                    'BUWUULONSO RURAL BANK LTD-TAMALE',
                    'CAPE COAST',
                    'CAPE COAST BRANCH',
                    'CAPE COAST- MELCOM',
                    'CAPE COAST- MFANTSIPIM',
                    'CAPECOAST BRANCH',
                    'CAPITAL RURAL BANK LTD-ABESIM',
                    'CASTLE RD',
                    'CASTLE ROAD',
                    'CASTLE ROAD (HEAD OFFICE)',
                    'CASTLE ROAD BRANCH',
                    'CEDI HOUSE',
                    'CHAMBA',
                    'CHAPEL SQUARE',
                    'CHARIA',
                    'CHEREPONI',
                    'CHIRAA',
                    'CHORKOR',
                    'CIRCLE',
                    'CIRCLE BRANCH',
                    'CITIZEN RURAL BANK LTD-ACCRA',
                    'CLEARING UNIT',
                    'COLLINS AVENUE',
                    'COLLINS STREET',
                    'COMMUNITY 25',
                    'COMMUNITY 6',
                    'COMMUNITY1 BRANCH',
                    'CONSUMER FINANCE COMPANY (CFC) LTD',
                    'CORPORATE',
                    'CORPORATE SERVICE CENTRE',
                    'CUC MIOTSO',
                    'DA RURAL BANK LTD-KASSEH',
                    'DABALA',
                    'DABAN',
                    'DABOASE',
                    'DADIESO',
                    'DAMANG',
                    'DAMANGO',
                    'DAMBAI',
                    'DAMONGO',
                    'DANGBE RURAL BANK LTD-PRAMPRAM',
                    'DANICOM HOUSE(KOKOMLEMLE)',
                    'DANQUAH CIRCLE',
                    'DANSI RURAL BANK LTD-FOMENA',
                    'DANSOMAN',
                    'DANSOMAN EXHIBITION BRANCH',
                    'DANSOMAN ROUND-ABOUT BRANCH',
                    'DARKUMAN',
                    'DARKUMAN BRANCH',
                    'DAWA',
                    'DENKYIRAMAN RURAL BANK LTD-AYAMFURI',
                    'DENU',
                    'DERBY AVENUE',
                    'DERMA',
                    'DERMA RURAL BANK LTD-DERMA',
                    'DIRECT SALES',
                    'DODOWA',
                    'DOME',
                    'DOME BRANCH',
                    'DOME ST. JOHNS',
                    'DONKORKROM',
                    'DONTEN COMMUNITY BANK LTD-NEW TAFO',
                    'DORMAA AHENKRO',
                    'DOTOBRI RURAL BANK LTD-JACOBU',
                    'DROBO',
                    'DROBO COMMUNITY RURAL BANK LTD-DROBO',
                    'DRORWULU',
                    'DUADASO',
                    'DUAYAW NKANTA',
                    'DUAYAW NKWANTA',
                    'DUMPONG RURAL BANK LTD-OFRAMASE',
                    'DUNKWA',
                    'DUNKWA OFFIN',
                    'DUNKWA ON-OFFIN',
                    'DUNKWA-ON-OFFIN',
                    'DUNKWAW-ON-OFFIN BRANCH',
                    'DUPONGKPEHE RURAL BANK LTD-KASOA',
                    'DWEN-ANOMA RURAL BANK LTD-KWEEHWEE',
                    'DWORWULU WEST AIRPORT',
                    'DZEMENI',
                    'DZODZE',
                    'DZORWULU',
                    'DZORWULU BRANCH',
                    'DZORWULU MOTORWAY',
                    'DZWORWULU',
                    'EAST AIRPORT BRANCH',
                    'EAST CANTONMENT',
                    'EAST CANTONMENTS BRANCH',
                    'EAST LEGON',
                    'EAST LEGON 1',
                    'EAST LEGON 2',
                    'EAST LEGON BRANCH',
                    'EAST MANPRUSI COMMUNITY BABK LTD-GAMBAGA',
                    'EASTERN GOMOA ASSIN RURAL BANK LTD-GOMOA-DOMINASE',
                    'EBANKESE',
                    'ECOBANK BANTAMA GNTC',
                    'ECOBANK COMMUNITY 1',
                    'ECOBANK E PROCESS',
                    'ECOBANK EAST AIRPORT',
                    'ECOBANK EVANDY HOSTEL',
                    'ECOBANK GH TAMALE',
                    'ECOBANK GHANA',
                    'ECOBANK HIGH STREET',
                    'ECOBANK HOSPITAL ROAD',
                    'ECOBANK KANTAMANTO',
                    'ECOBANK MADINA CENTRAL',
                    'ECOBANK OKPONGLO',
                    'ECOBANK PENTAGON LEGON',
                    'ECOBANK SSNIT HOUSE',
                    'ECOBANK SUAME',
                    'EFFIDUASE',
                    'EFWIMAN RURAL BANK LTD-SEFWI-ASAW',
                    'EJISU',
                    'EJISU BRANCH',
                    'EJURA',
                    'EJURAMAN RURAL BANK LTD-KUMASI',
                    'EKUMFIMAN RURAL BANK LTD-ESSUEHYIA',
                    'EKYEDUMASI RURAL BANK LTD-SEKYEDUMASI',
                    'EKYERE RURAL BANK LTD-JAMASI',
                    'ELMINA',
                    'ELMINA - CHAPEL SQUARE',
                    'ELMINA -ESSUAKYIR',
                    'ELUBO',
                    'ELUBU',
                    'ENCHI',
                    'ENCHI BRANCH',
                    'ENCHI RURAL BANK LTD',
                    'ENKYIRAMAN RURAL BANK LTD-AYAMFURI',
                    'ENYAN DENKYIRA RURAL BANK LTD-ENYAN DENKYIRA',
                    'EPAMAN RURAL BANK LTD - TEPAMAN',
                    'EPE AREA RURAL BANK LTD-MEPE',
                    'ERMA RURAL BANK LTD-DERMA',
                    'ESIAMA',
                    'ESSAM',
                    'ESSFA RURAL BANK LTD-GARU',
                    'EST MANPRUSI COMMUNITY BANK LTD-WALEWALE',
                    'ESTERN RURAL BANK LTD-WASSA AKROPONG',
                    'ETO RURAL BANK LTD-KPEVE',
                    'EVANDY HOSTEL BRANCH',
                    'EZI SAVINGS AND LOANS LTD',
                    'FAANOFA',
                    'FAMAL',
                    'FANTEAKWA RURAL BANK LTD-KOFORIDUA',
                    'FANTSIMAN COMMUNITY RURAL BANK LTD-BIRIWA',
                    'FARRAR',
                    'FFINSO RURAL BANK LTD-KUMASI',
                    'FIAGYA RURAL BANK LTD-BUSUNYA',
                    'FIAPRE',
                    'FIASEMAN (BOGOSO AREA) RURAL BANK LTD-BOGOSO',
                    'FIRST AFRICAN SAVINGS AND LOANS',
                    'FIRST ALLIED SAVINGS & LOANS',
                    'FIRST ALLIED SAVINGS AND LOANS',
                    'FIRST GHANA BUILDING SOCIETY- ACCRA',
                    'FIRST GHANA BUILDING SOCIETY- KOFORIDUA',
                    'FIRST GHANA BUILDING SOCIETY- KUMASI AMAKOM',
                    'FIRST GHANA BUILDING SOCIETY- KUMASI SUAME',
                    'FIRST GHANA BUILDING SOCIETY- SUNYANI',
                    'FIRST GHANA BUILDING SOCIETY- TAKORADI',
                    'FIRST GHANA BUILDING SOCIETY-HEAD OFFICE',
                    'FIRST GHANA BUILDING SOCIETY-HOHOE',
                    'FIRST GHANA BUILDING SOCIETY-TAKORADI',
                    'FIRST GHANA BUILDING SOCIETY-TEMA',
                    'FIRST NATATIONAL S&L',
                    'FIRST NATIONAL SAVINGS & LOANS',
                    'FOASE',
                    'FOREIGN',
                    'FOREIGN OPERATIONS',
                    'FOREIGN OPERATIONS BRANCH',
                    'FRAM RURAL BANK LTD-TEASE',
                    'FULFOSO',
                    'FUMBISI',
                    'GA RURAL BANK LTD-AMASAMAN',
                    'GAMASHIE',
                    'GARU',
                    'GAVE RURAL BANK LTD-DABALE',
                    'GBI RURAL BANK LTD-HOHOE',
                    'GICEL',
                    'GIMPA',
                    'GIMPA BRANCH',
                    'GLOBAL ACCESS SAVINGS & LOANS CO. LTD',
                    'GNPC',
                    'GNPC TEMA',
                    'GOASO',
                    'GOLDEN TULIP KUMASI BRANCH',
                    'GOLOKWATI',
                    'GOMOA AJUMAKO RURAL BANK LTD-AFRANSI',
                    'GOMOA RURAL BANK LTD-APAM',
                    'GONA RURAL BANK LTD-KWANYAKU',
                    'GRAPHIC ROAD',
                    'GREL',
                    'GULF HOUSE',
                    'GUMANI',
                    'GUSHIEGU',
                    'GWB LAPAZ',
                    'HAATSO',
                    'HAATSOO',
                    'HAFO ANO PREMIER RURAL BANK LTD-WIOSO',
                    'HAFO COMMUNITY RURAL BANK LTD-KUKUOM',
                    'HAI RURAL BANK LTD-DODOWA',
                    'HALF ASSINI',
                    'HAMILE',
                    'HANTAMAN RURAL BANK LTD-AGONA NKWANTA',
                    'HAPER ROAD',
                    'HARBOUR AREA',
                    'HARPER ROAD',
                    'HARPER ROAD BRANCH',
                    'HE SEED SAVINGS AND LOANS',
                    'HEAD OFFICE',
                    'HEAD-OFFICE',
                    'HIGH STREET',
                    'HIGH STREET BRANCH',
                    'HIGH STREET TAKORADI',
                    'HIGH STREET-TAKORADI',
                    'HO',
                    'HO AGENCY',
                    'HO BRANCH',
                    'HO MARKET',
                    'HO POLYTECHNIC',
                    'HO POST',
                    'HO POSTBANK',
                    'HOEHOE',
                    'HOHOE',
                    'HOHOE POST',
                    'HOHOE POSTBANK',
                    'HOSPITAL ROAD BRANCH',
                    'HWEDIEM',
                    'HWIDIEM',
                    'HWIDIEM[ B/A]',
                    'IAGYA RURAL BANK LTD-BUSUNYA',
                    'IASEMAN (BOGOSO AREA) RURAL BANK LTD-BOGOSO',
                    'IA-TORYA RURAL BANK LTD-BONSU-NKWANTA',
                    'ICROFIN RURAL BANK LIMITED',
                    'INDEPENDENCE AVENUE',
                    'INDUSTRIAL AREA',
                    'INTAMPO RURAL BANK LTD-KINTAMPO',
                    'INTERNATIONAL BANKING',
                    'IPS',
                    'IPS BRANCH',
                    'IPS LEGON',
                    'IRST GHANA BUILDING SOCIETY- ACCRA',
                    'IRST GHANA BUILDING SOCIETY- KOFORIDUA',
                    'IRST GHANA BUILDING SOCIETY- KUMASI AMAKOM',
                    'IRST GHANA BUILDING SOCIETY- KUMASI SUAME',
                    'IRST GHANA BUILDING SOCIETY- SUNYANI',
                    'IRST GHANA BUILDING SOCIETY- TAKORADI',
                    'IRST GHANA BUILDING SOCIETY-HEAD OFFICE',
                    'IRST GHANA BUILDING SOCIETY-HOHOE',
                    'IRST GHANA BUILDING SOCIETY-TAKORADI',
                    'IRST GHANA BUILDING SOCIETY-TEMA',
                    'ISSALA RURAL BANK LTD-TUMA',
                    'ITIZEN RURAL BANK LTD-ACCRA',
                    'IZAA RURAL BANK LTD-TAMALE',
                    'JACOBU',
                    'JANYAGU',
                    'JAPEKROM',
                    'JAPEKROM/DROBO',
                    'JASIKAN',
                    'JEMA',
                    'JINIJIN',
                    'JIRAPA',
                    'JISONAYILI',
                    'JOMORO RURAL BANK LTD-TIKOBO NO. 1',
                    'JUABEN RURAL BANK LTD-JUABEN',
                    'JUABESO',
                    'JUAPONG',
                    'JUASO',
                    'JUBILEE HOUSE',
                    'JUBILEE HOUSE COCOBOD BUILDING',
                    'JUKWA',
                    'JUNCTION MALL',
                    'JUNCTION MALL BRANCH',
                    'JURAMAN RURAL BANK LTD-KUMASI',
                    'KAASE',
                    'KAASEMAN RURAL BANK LTD-KAASE',
                    'KADE',
                    'KADJEBI',
                    'KAJEBI',
                    'KAKUM RURAL BANK LTD-ELMINA',
                    'KALADAN',
                    'KANASHIE',
                    'KANESHIE',
                    'KANESHIE BRANCH',
                    'KANESHIE INDUSTRIAL AREA',
                    'KANESHIE MAIN',
                    'KANESHIE MARKET',
                    'KANESHIE POST OFFICE',
                    'KANESHIE POST OFFICE BRANCH',
                    'KANESSHIE',
                    'KANTAMANTO',
                    'KANTAMANTO AGENCY',
                    'KANTAMANTO BRANCH',
                    'KARAGA',
                    'KASAPIN',
                    'KASOA',
                    'KASOA BRANCH',
                    'KASOA MAIN',
                    'KASOA MAIN BRANCH',
                    'KASOA MARKET',
                    'KASOA MILLENIUM CITY',
                    'KASOA NEW MARKET',
                    'KATAKYIMAN RURAL BANK LTD-KOMENDA',
                    'KEJETIA',
                    'KEJETIA BRANCH',
                    'KEJETIA- KUMASI',
                    'KENYASE',
                    'KENYASI AGENCY',
                    'KETA',
                    'KETE KRACHI',
                    'KIBI',
                    'KIM BOSOME RURAL BANK LTD-AKIM SWEDRU',
                    'KINTAMPO',
                    'KINTAMPO RURAL BANK LTD-KINTAMPO',
                    'KISSEIMAN BRANCH',
                    'KISSI',
                    'KISSIEMAN',
                    'KNUST',
                    'KNUST BRANCH',
                    'KNUST CAMPUS',
                    'KNUST KUMASI',
                    'KNUTSFORD',
                    'KNUTSFORD AVENUE',
                    'KOFORIDUA',
                    'KOFORIDUA BRANCH',
                    'KOFORIDUA KAMA CENTRE',
                    'KOJO THOMPSON ROAD',
                    'KOKOMLEMLE BRANCH',
                    'KOMENDA',
                    'KOMFO ANOKYE RURAL BANK LTD-WIAMOASE',
                    'KOMLEMLE',
                    'KONGO',
                    'KONONGO',
                    'KORANMAN RURAL BANK LTD-SEIKWA',
                    'KORANZA KWABRE RURAL BANK LTD-AKUMA',
                    'KORKORDZOR',
                    'KORLE BU',
                    'KORLE DUDOR',
                    'KORLE DUDOR BRANCH',
                    'KORLE-BU',
                    'KORLE-BU BRANCH',
                    'KOTI RURAL BANK LTD-ASSIN AKROPONG',
                    'KOTOBABI',
                    'KPADIE',
                    'KPANDAI',
                    'KPANDO',
                    'KPANDU',
                    'KPASSA RURAL BANK LTD-HOHOE',
                    'KPEDZE',
                    'KPETOE',
                    'KPEVE',
                    'KPONE',
                    'KPONG',
                    'KRACHE NKWANTA',
                    'KRANKWANTA RURAL BANK LTD-SUNYANI',
                    'KROFOM',
                    'KROFROM',
                    'KROFUOM AREA RURAL BANK LTD-AKROFUOM',
                    'KRONUM BRANCH',
                    'KUAPEM RURAL BANK LTD-MAMFE',
                    'KUMASI',
                    'KUMASI (ALABAR)',
                    'KUMASI ADUM',
                    'KUMASI -ADUM',
                    'KUMASI AMAKOM',
                    'KUMASI ASAFO',
                    'KUMASI ASAFO BRANCH',
                    'KUMASI ASOKWA',
                    'KUMASI BRANCH',
                    'KUMASI CENT.',
                    'KUMASI CENTRAL',
                    'KUMASI CENTRAL MARKET',
                    'KUMASI HARPER ROAD',
                    'KUMASI MAIN',
                    'KUMASI PREMPEH 11 STREET',
                    'KUMASI PREMPEH STREET',
                    'KUMASI SUAME',
                    'KUMASI TANNOSO',
                    'KUMASI-LAKE  ROAD',
                    'KUMAWUMAN RURAL BANK LTD-KUMAWU',
                    'KUMFIMAN RURAL BANK LTD-ESSUEHYIA',
                    'KWABENYA',
                    'KWABENYA BRANCH',
                    'KWADASO',
                    'KWAEBIBIREM RURAL BANK LTD-ASUOM',
                    'KWAHU PRASO RURAL BANK LTD-KWAHU PRASO',
                    'KWAHU RURAL BANK LTD-KWAHU PEPEASE',
                    'KWAHUTAFO',
                    'KWAMANMAN RURAL BANK LTD-KWAMANG',
                    'KWAME DANSO BRANCH',
                    'KWAME NKRUMAH AVE',
                    'KWAME NKRUMAH CIRCLE',
                    'KWAPONG',
                    'KWASHIEMAN',
                    'KWASHIEMAN BRANCH',
                    'KYEKYEWERE',
                    'KYEM MANSA RURAL BANK LTD-AYIREBI',
                    'KYEPIM RURAL BANK LTD-GOMOA-DAW',
                    'LA',
                    'LA COMMUNITY BANK LTD-LA',
                    'LABONE',
                    'LABONE BRANCH',
                    'LAPAZ',
                    'LAPAZ BRANCH',
                    'LASHIBI',
                    'LASHIBI BRANCH',
                    'LAW COURT COMPLEX',
                    'LAW-COURT',
                    'LAWRA',
                    'LAWRA RURAL BANK LTD-WA',
                    'LEGON',
                    'LEGON MAIN',
                    'LIBERATION ROAD TAKORADI',
                    'LIBERATION ROAD TOKORADI',
                    'LIBERATION ROAD-TAKORADI',
                    'LIBERIA ROAD',
                    'LIBERTY HSE',
                    'LOTTERIES',
                    'LOWER PRA RURAL BANK LTD-SHAMA',
                    'MAAKRO BRANCH',
                    'MAAME KROBO',
                    'MAAMOBI',
                    'MACCARTHY HILL',
                    'MADINA',
                    'MADINA BRANCH',
                    'MADINA CENTRAL BRANCH',
                    'MADINA MAIN BRANCH',
                    'MADINA NEW ROAD BRANCH',
                    'MAKANGO',
                    'MAKOLA',
                    'MAKOLA BRANCH',
                    'MAKOLA SQUARE',
                    'MALLAM',
                    'MALLAM INTERCHANGE',
                    'MALLAM JUNCTION BRANCH',
                    'MAMFE AKUAPIM',
                    'MAMFE BRANCH',
                    'MAMOBI',
                    'MAMOBI BRANCH',
                    'MAMPONG',
                    'MAMPONG AKWAPIM',
                    'MAMPONG ASHANTI',
                    'MAMPROBI',
                    'MAMPROBI POST',
                    'MAMPROBI POSTBANK',
                    'MANANO RURAL BANK LTD-NYINAHIM',
                    'MANET TOWER 3 BRANCH',
                    'MANKESSIM',
                    'MANKESSIM OFFICE COMPLEX',
                    'MANKRASO',
                    'MANSO NKWANTA',
                    'MANSOMAN RURAL BANK LTD-MANSO-AMENFI',
                    'MANYA KROBO RURAL BANK LTD-ODUMASE-KROBO',
                    'MARKET CIRCLE BRANCH',
                    'MARKET CIRCLE TAKORADI',
                    'MASIE WEST RURAL BANK LTD-ANTOAKROM',
                    'MATAHEKO',
                    'MATIN AND KASEI COMMUNITY BANK LTD-KASEI',
                    'MAX MART',
                    'MCCARTHY HILL',
                    'MELCOM',
                    'MENFIMAN RURAL BANK LTD-WASSA AKROPONG',
                    'MEPE AREA RURAL BANK LTD-MEPE',
                    'MERIDIAN BRANCH',
                    'MFANTSIMAN COMMUNITY RURAL BANK LTD-BIRIWA',
                    'MFANTSIPIM',
                    'MICHEL CAMP',
                    'MICROFIN RURAL BANK LIMITED',
                    'MIDLAND SAVING AND LOANS',
                    'MIDLAND SAVINGS & LOANS LTD',
                    'MILE 7/TANTRA',
                    'MIM',
                    'MINISTRIES',
                    'MIOTSO',
                    'MOREE',
                    'MOTOR WAY ROUNDABOUT',
                    'MOTORWAY EXT',
                    'MOTORWAY EXTENSION',
                    'MOTORWAY ROUNDABOUT',
                    'MPATASIE',
                    'MPOHOR',
                    'MPONUA RURAL BANK LTD-AMUANA PRASO',
                    'MPRAESO',
                    'MULTI CREDIT SAVINGS AND LOANS - KUMASI',
                    'MULTICREDIT SAVINGS AND LOANS CO.',
                    'MUMFORD',
                    'MUMUADA RURAL BANK LTD-OSINO',
                    'NAARA RURAL BANK LTD-PAGA',
                    'NAFANA RURAL BANK LTD-SAMPA',
                    'NAGODE',
                    'NANDOM',
                    'NANDOM RURAL BANK LTD-NANDOM',
                    'NAVORONGO',
                    'NAVRONGO',
                    'NBFI-ADVANS GH',
                    'NCHIRAA',
                    'NCR',
                    'NEW ABEKA',
                    'NEW ABIREM',
                    'NEW ABIREM BRANCH',
                    'NEW ABRIEM',
                    'NEW ADUBIASE',
                    'NEW AMAKOM',
                    'NEW DORMAA KOTOKROM',
                    'NEW EDUBIASE',
                    'NEW NINGO',
                    'NEW OFFINSO',
                    'NEW SUAME MAGAZINE',
                    'NEW TAFO',
                    'NEW TOWN',
                    'NEWTOWN',
                    'NEWTOWN ACCRA',
                    'NHYIAESO BRANCH',
                    'NHYIEASO',
                    'NHYIESO',
                    'NIA',
                    'NIA BRANCH',
                    'NIMA',
                    'NIMA BRANCH',
                    'NIMA MAIN BRANCH',
                    'NINGO',
                    'NION RURAL BANK LTD-SENYA BREKU',
                    'NITY RURAL BANK LTD-ZIOPE',
                    'NKAWIE',
                    'NKAWKAW',
                    'NKOBRA WEST (ESIAMA) RURAL BANK LTD-ESIAMA',
                    'NKORANMAN RURAL BANK LTD-SEIKWA',
                    'NKORANSAH',
                    'NKORANZA',
                    'NKORANZA KWABRE RURAL BANK LTD-AKUMA',
                    'NKRANKWANTA',
                    'NKRANKWANTA RURAL BANK LTD-SUNYANI',
                    'NKWAKAW POST',
                    'NKWANTA',
                    'NLO RURAL BANK LTD-ANLOGA',
                    'NOBLE DREAM MICROFINANCE LTD',
                    'NORTH INDUSTRIAL',
                    'NORTH INDUSTRIAL AREA',
                    'NORTH INDUSTRIAL AREA BRANCH',
                    'NORTH KANESHIE',
                    'NORTH RIDGE',
                    'NORTH TONGU RURAL BANK LTD-ADIDOME',
                    'NORTH VOLTA RURAL BANK LTD-GUAMAN',
                    'NSAWAM',
                    'NSOATREMAN RURAL BANK LTD-NSOATRE',
                    'NSUATRE',
                    'NSUFA ASHANTI',
                    'NSUTAMAN RURAL BANK LTD-NSUTA',
                    'NTOROSO',
                    'NUM RURAL BANK LTD-ANUM',
                    'NUNGUA',
                    'NWABIAGYA RURAL BANK LTD-BAREKESE',
                    'NYAKROM RURAL BANK LTD-NYAKROM',
                    'NYAN DENKYIRA RURAL BANK LTD-ENYAN DENKYIRA',
                    'NYANKPALA',
                    'NYANKUMASE AHENKRO RURAL BANK LTD-FANTI NYANKUMASE',
                    'NYIAESO',
                    'NYIAESO AHODWO',
                    'NZEMA MANLE RURAL BANK LTD-AWIEBO',
                    'OBUASI',
                    'ODA',
                    'ODA NKWANTA',
                    'ODORKOR',
                    'ODOTOBRI RURAL BANK LTD-JACOBU',
                    'ODUPONGKPEHE RURAL BANK LTD-KASOA',
                    'ODWEN-ANOMA RURAL BANK LTD-KWEEHWEE',
                    'OENDE RURAL BANK LTD-ZIBILLA',
                    'OFFINSO',
                    'OFFINSO RURAL BANK LTD-KUMASI',
                    'OFFSHORE BANKING',
                    'OFFSHORE BANKING UNIT - GH',
                    'OKAISHIE',
                    'OKAISHIE BRANCH',
                    'OKOFO BRANCH',
                    'OKOMFO ANOKYE RURAL BANK LTD-WIAMOASE',
                    'OKPONGLO',
                    'OKPONGLO BRANCH',
                    'OLA',
                    'OLD NINGO',
                    'OLD SUAME MAGAZINE',
                    'OLD TAFO',
                    'OMAA AREA RURAL BANK LTD-BOMAA',
                    'OMOA AJUMAKO RURAL BANK LTD-AFRANSI',
                    'OMOA RURAL BANK LTD-APAM',
                    'OMORO RURAL BANK LTD-TIKOBO NO. 1',
                    'OMOSADU RURAL BANK LTD',
                    'ONGO RURAL BANK LTD-BOLGATANGA',
                    'ONZALI RURAL BANK LTD-KUMBUNGU',
                    'ONZELE RURAL BANK LTD-JIRAPA',
                    'OPEIBEA HOUSE',
                    'OPERA SQUARE',
                    'OPERA SQUARE BRANCH',
                    'OPPORTUNITY INT. SAVINGS AND LOAN',
                    'OPPORTUNITY INT. SAVINGS AND LOANS',
                    'OPPORTUNITY INTERNATIONAL',
                    'OREIGN',
                    'ORIMANGA RURAL BANK LTD-SAVELEGU',
                    'ORTH TONGU RURAL BANK LTD-ADIDOME',
                    'ORTH VOLTA RURAL BANK LTD-GUAMAN',
                    'OSEI KWADWO KROM',
                    'OSOME FREHO RURAL BANK LTD-KUMASI',
                    'OSOMTWI RURAL BANK LTD-KUNTANASE',
                    'OSU',
                    'OSU  OXFORD BRANCH',
                    'OSU - OXFORD STREET',
                    'OSU - WATSON STREET',
                    'OSU OXFORD ST.',
                    'OSU OXFORD STREET',
                    'OSU WATSON BRANCH',
                    'OTUASEKAN RURAL BANK LTD-KOFIASE',
                    'OUTH AKIM RURAL BANK LTD-NANKESE',
                    'OUTH BIRIM RURAL BANK LTD-ACHIASE',
                    'OWER PRA RURAL BANK LTD-SHAMA',
                    'OXFORD STREET BRANCH',
                    'OYIBI AREA RURAL BANK LIMITED',
                    'PACIFIC SAVINGS AND LOANS LTD',
                    'PAGA',
                    'PALM WINE JUNCTION',
                    'PALMWINE JUNCTION',
                    'PARLIAMENT HOUSE',
                    'PASSA RURAL BANK LTD-HOHOE',
                    'PATASE',
                    'PATRICE LUMUMBA ROAD',
                    'PEKI',
                    'PENTAGON LEGON BRANCH',
                    'PEX BANK - BOLGA CENTRE-BOLGATANGA',
                    'PEX BANK - CAPE COASTCAPE COAST',
                    'PEX BANK - TAMALE CENTRE-TAMALE',
                    'PEX BANK -HEAD OFFICE-SOUTH RIDGE ACCRA',
                    'PEX BANK -HOHOE CENTRE-HOHOE',
                    'PEX BANK KOFORIDUA CENTRE-KOFORIDUA',
                    'PEX BANK -SUNYANI CENTRE-SUNYANI',
                    'PEX BANK -WA CENTRE-WA',
                    'PEX BANKACCRA CENTRE-ACCRA',
                    'PEX BANK-HO CENTRE-HO',
                    'PEX BANK-KUMASIKUMASI',
                    'PEX BANK-TAKORADI CENTRE-TAKORADI',
                    'PEX LINK CENTRE-CEDI HOUSE',
                    'PIG FARM BRANCH',
                    'POKUASE',
                    'POKUASE BRANCH',
                    'PONUA RURAL BANK LTD-AMUANA PRASO',
                    'POST OFFICE SQUARE',
                    'POTSIN',
                    'PPER AMENFI RURAL BANK LTD-ANKWAWSO',
                    'PPER MANYA KRO RURAL BANK LTD-ASESEWA',
                    'PRAMPRAM',
                    'PRANG',
                    'PREMIER TOWERS',
                    'PREMPEH II STREET',
                    'PRESTEA',
                    'PRIVATE BANKING',
                    'PROCREDIT SAVINGS & LOANS',
                    'PUSIGA',
                    'RAKWA BRAMAN RURAL BANK LTD-BRAKWA',
                    'REINSURANCE HOUSE',
                    'REINSURANCE HOUSE BRANCH',
                    'REPUBLIC HOUSE',
                    'RIDGE',
                    'RIDGE BRANCH',
                    'RIDGE TOWERS',
                    'RING ROAD',
                    'RING ROAD BRANCH',
                    'RING ROAD CENTRAL',
                    'RING ROAD CENTRAL BRANCH',
                    'RING ROAD WEST',
                    'ROBO COMMUNITY RURAL BANK LTD-DROBO',
                    'ROMAN HILL',
                    'ROMAN HILL BRANCH',
                    'ROMAN HILL MARKET BRANCH',
                    'RRC',
                    'RRC REMITTANCE CENTRE',
                    'RUSSIA ROAD BRANCH',
                    'SABOBA',
                    'SAFE BOND',
                    'SAFE BOND JUBILEE',
                    'SAFE BOUND JUBILEE',
                    'SAFEBOND',
                    'SAKAMAN',
                    'SAKUMONO',
                    'SAKUMONO BRANCH',
                    'SALAGA',
                    'SALTPOND',
                    'SAMPA',
                    'SAMREBOI',
                    'SANDEMA',
                    'SANKORE',
                    'SANTA MARIA',
                    'SANTASI',
                    'SANTE AKYEM RURAL BANK LTD-JUANSA',
                    'SAVELUGU',
                    'SAWINSO RURAL BANK LTD-SEFWI-ASAWINSO',
                    'SAWLA',
                    'SEFWI BEKWAI',
                    'SEFWI BRANCH',
                    'SEFWI ESSAM',
                    'SEFWI WIAWO',
                    'SEFWI WIAWSO',
                    'SEFWIMAN RURAL BANK LTD-SEFWI-ASAW',
                    'SEFWI-WIASO',
                    'SEGE',
                    'SEKONDI',
                    'SEKYEDUMASI RURAL BANK LTD-SEKYEDUMASI',
                    'SEKYERE RURAL BANK LTD-JAMASI',
                    'SERVICE BRANCH',
                    'SHAI RURAL BANK LTD-DODOWA',
                    'SHIPPERS HOUSE BRANCH',
                    'SILVER STAR',
                    'SINAPI ABA SAVINGS & LOAN',
                    'SINAPI ABA SAVINGS & LOANS',
                    'SISSALA RURAL BANK LTD-TUMA',
                    'SME',
                    'SME CENTRE',
                    'SOATREMAN RURAL BANK LTD-NSOATRE',
                    'SOGAKOPE',
                    'SOKOBAN',
                    'SOKOBAN BRANCH',
                    'SOKORE RURAL BANK LTD-ASOKRE',
                    'SOMANYA',
                    'SONZELE RURAL BANK LTD-JIRAPA',
                    'SOUTH AKIM RURAL BANK LTD-NANKESE',
                    'SOUTH BIRIM RURAL BANK LTD-ACHIASE',
                    'SOUTH INDUSTRIAL AREA',
                    'SOUTH INDUSTRIAL AREA(SIA)',
                    'SOUTH INDUSTRIAL BRANCH',
                    'SOUTH LEGON BRANCH',
                    'SOWUTUOM',
                    'SPINTEX',
                    'SPINTEX BRANCH',
                    'SPINTEX MAIN',
                    'SPINTEX PRESTIGE',
                    'SPINTEX ROAD',
                    'SPINTEX ROAD BRANCH',
                    'SSINMAN RURAL BANK LTD-ASSIN MANSO',
                    'SSNIT HOUSE BRANCH',
                    'ST PETERS CO-OPERATIVE CREDIT UNION',
                    'STADIUM',
                    'STADIUM AMAKOM',
                    'STADIUM POST',
                    'STEWART AVENUE KUMASI',
                    'SUAME',
                    'SUAME BRANCH',
                    'SUAME MAAKRO',
                    'SUBONTEN RURAL BANK LTD-WORAWORA',
                    'SUHUM',
                    'SUHUM RURAL BANK',
                    'SUMA RURAL BANK LTD-SUMA AHENKRO',
                    'SUNYANI',
                    'SUNYANI CENTRAL',
                    'SUNYANI MAIN BRANCH',
                    'SUNYANI NIMPONG',
                    'SUNYANI ODUMASE',
                    'SUNYANI POST OFFICE BRANCH',
                    'SUNYANI POSTBANK',
                    'SUOGYAMAN RURAL BANK LTD-ACCRA',
                    'SUOPRA RURAL BANK LTD-AFOSU',
                    'SUTAMAN RURAL BANK LTD-NSUTA',
                    'SUTIFI RURAL BANK LTD-ACERENSUA',
                    'SWANMILL',
                    'SWEDRU',
                    'SWEDRU BRANCH',
                    'TAFO',
                    'TAFO BRANCH',
                    'TAIFA',
                    'TAKORADI',
                    'TAKORADI - KOKOMPE',
                    'TAKORADI BRANCH',
                    'TAKORADI EFFIEKUMA',
                    'TAKORADI HABOUR BRANCH',
                    'TAKORADI HARBOUR',
                    'TAKORADI HARBOUR ROAD',
                    'TAKORADI KOKOMPE',
                    'TAKORADI MAIN',
                    'TAKORADI MARKET CIRCLE',
                    'TAKORADI MKT CIRCLE',
                    'TAKORADI POST',
                    'TAKORADI POSTBANK',
                    'TAMALE',
                    'TAMALE ABOABO',
                    'TAMALE ABOABO BRANCH',
                    'TAMALE BRANCH',
                    'TAMALE CENTRAL',
                    'TAMALE HOSP ROAD',
                    'TAMALE HOSPITAL ROAD',
                    'TAMALE HOSPITAL ROAD BRANCH',
                    'TAMALE LAMESHEGU',
                    'TAMALE MAIN BRANCH',
                    'TAMALE MARKET',
                    'TANOKROM',
                    'TANOSO',
                    'TANTRA',
                    'TARKORADI MARKET',
                    'TARKWA',
                    'TARKWA BRANCH',
                    'TARKWA MINES',
                    'TEASE',
                    'TECH JUNCTION',
                    'TECHIMAN',
                    'TECHIMAN BRANCH',
                    'TECHIMAN MARKET',
                    'TECHIMAN MARKET BRANCH',
                    'TECHIMAN NORTH BRANCH',
                    'TECHIMAN TIA BRANCH',
                    'TECHIMAN VALLEY VIEW BRANCH',
                    'TECHIMAN WENCHI ROAD BRANCH',
                    'TEMA',
                    'TEMA BRANCH',
                    'TEMA COMM 1',
                    'TEMA COMM 2',
                    'TEMA COMM 4',
                    'TEMA COMM. 25',
                    'TEMA COMM. 6',
                    'TEMA COMMUNITY 1',
                    'TEMA COMMUNITY 1 BRANCH',
                    'TEMA COMMUNITY 2 BRANCH',
                    'TEMA COMMUNITY 25',
                    'TEMA COMMUNITY 25 BRANCH',
                    'TEMA COMMUNITY 6',
                    'TEMA COMMUNITY 9',
                    'TEMA COMMUNITY ONE',
                    'TEMA COMMUNITY TWO',
                    'TEMA DRYDOCK',
                    'TEMA EAST',
                    'TEMA FISHING HABOUR',
                    'TEMA FISHING HARBOUR',
                    'TEMA HABOUR',
                    'TEMA HARBOUR',
                    'TEMA INDUSTRIAL AREA',
                    'TEMA LONG ROOM',
                    'TEMA MAIN',
                    'TEMA MAIN BRANCH',
                    'TEMA MARKET',
                    'TEMA METRO BRANCH',
                    'TEMA OIL REFINERY',
                    'TEMA SAFEBOND',
                    'TEMA SHOPPING MAIL',
                    'TEMA SHOPPING MALL',
                    'TEMPANE BRANCH',
                    'TEPA',
                    'TEPAMAN RURAL BANK LTD - TEPAMAN',
                    'TESANO',
                    'TESANO BRANCH',
                    'TESHIE',
                    'TESHIE BRANCH',
                    'TESHIE NUNGUA',
                    'TETTEH QUARSHIE',
                    'THE SEED SAVINGS AND LOANS',
                    'TIA BRANCH',
                    'TIWA RURAL BANK LTD-KWABENG',
                    'TIZAA RURAL BANK LTD-TAMALE',
                    'TOENDE RURAL BANK LTD-ZIBILLA',
                    'TOLON',
                    'TONGU',
                    'TOR',
                    'TRADE FAIR',
                    'TRADE FAIR BRANCH',
                    'TREASURY',
                    'TREDE',
                    'TRUST TOWERS',
                    'TRUST TOWERS BRANCH',
                    'TSITO',
                    'TSOPOLI',
                    'TSUI BLEOO',
                    'TUASEKAN RURAL BANK LTD-KOFIASE',
                    'TUDU',
                    'TUDU BRANCH',
                    'TUMJU',
                    'TUMU',
                    'TUOBODOM',
                    'TUTU BRANCH',
                    'TWEABAN RURAL BANK LTD-SUNYANI',
                    'TWIFO PRASO',
                    'TWIFO RURAL BANK LTD-TWIFO AGONA',
                    'TWIMA KWANWOMA RURAL BANK LTD-PAKYI NO. 2',
                    'TWIMA MPONUA RURAL BANK LTD-TOASE',
                    'TWIMA RURAL BANK LTD-FOASE',
                    'UABEN RURAL BANK LTD-JUABEN',
                    'UCC',
                    'UEW BRANCH',
                    'UHUM RURAL BANK',
                    'UILSA COMMUNITY BANK LTD-SANDEMA',
                    'UMA RURAL BANK LTD-SUMA AHENKRO',
                    'UMAWUMAN RURAL BANK LTD-KUMAWU',
                    'UMPONG RURAL BANK LTD-OFRAMASE',
                    'UMUADA RURAL BANK LTD-OSINO',
                    'UNDP',
                    'UNION RURAL BANK LTD-SENYA BREKU',
                    'UNION SAVINGS & LOANS',
                    'UNION SAVINGS AND LOANS',
                    'UNION SAVINGS AND LOANS LIMITED',
                    'UNITY RURAL BANK LTD-ZIOPE',
                    'UNIV. OF CAPE COAST BRANCH',
                    'UNIVERSITY OF CAPE COAST',
                    'UNIVERSITY OF CAPE COAST BRANCH',
                    'UNIVERSITY OF GHANA BRANCH',
                    'UPPER AMENFI RURAL BANK LTD-ANKWAWSO',
                    'UPPER MANYA KRO RURAL BANK LTD-ASESEWA',
                    'UTAWU RURAL BANK LTD-HO',
                    'UTRAK SAVINGS AND LOANS',
                    'UWUULONSO RURAL BANK LTD-TAMALE',
                    'VAKPO',
                    'VALLEY VIEW',
                    'VALLEY VIEW UNIVERSITY- TECHIMAN',
                    'VENOR RURAL BANK LTD-AKATSI',
                    'WA',
                    'WA BRANCH',
                    'WABIAGYA RURAL BANK LTD-BAREKESE',
                    'WAEBIBIREM RURAL BANK LTD-ASUOM',
                    'WAHU PRASO RURAL BANK LTD-KWAHU PRASO',
                    'WAHU RURAL BANK LTD-KWAHU PEPEASE',
                    'WALEWALE',
                    'WAMANMAN RURAL BANK LTD-KWAMANG',
                    'WAMFIE',
                    'WAMFIE RURAL BANK LTD-WAMFIE',
                    'WASSA MANSO',
                    'WECHIAU',
                    'WEIJA',
                    'WEIJA BRANCH',
                    'WENCHI',
                    'WENCHI RURAL BANK LTD',
                    'WEST HILLS MALL',
                    'WEST LANDS',
                    'WEST MANPRUSI COMMUNITY BANK LTD-WALEWALE',
                    'WESTERN HILL',
                    'WESTERN RURAL BANK LTD-WASSA AKROPONG',
                    'WESTLANDS',
                    'WETO RURAL BANK LTD-KPEVE',
                    'WIDANA',
                    'WIFO RURAL BANK LTD-TWIFO AGONA',
                    'WINNEBA',
                    'WINNEBA BRANCH',
                    'WINNEBA RD',
                    'WINNEBA ROAD',
                    'WISCONSIN',
                    'WISCONSIN BRANCH',
                    'WOMANS WORLD BANKING',
                    'WOMENS WORLD BANK GHANA SAVINGS AND LOANS',
                    'WOMENS WORLD BANKING',
                    'WULENSI',
                    'WURIYENGA',
                    'WUTU EMASA RURAL BANK LTD-AWUMASA',
                    'YAA ASANTEWAA RURAL BANK LTD',
                    'YAKROM RURAL BANK LTD-NYAKROM',
                    'YANKUMASE AHENKRO RURAL BANK LTD-FANTI NYANKUMASE',
                    'YAPRA RURAL BANK LTD-PRANG',
                    'YEJI',
                    'YENDI',
                    'YESU NKWA',
                    'YIBI AREA RURAL BANK LIMITED',
                    'YUNYOO',
                    'ZABZUGU RURAL BANK LTD',
                    'ZEBILLA',
                    'ZEMA MANLE RURAL BANK LTD-AWIEBO',
                    'ZENITH BANK (GH) LTD-SUNYANI',
                    'ZENU',
                    'ZENU BRANCH',
                    'ZONGO JUNCTION',
                  ],
                  publishChange: true,
                  readonly: false,
                  tooltip: 'Account Branch Name',
                  type: 'field',
                  uid: '503a71583f1182e2',
                },
                {
                  id: 'account-number',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Account Number',
                  uid: '495c881bcf57de23',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  inputType: 'text',
                },
              ],
            },
          ],
        },
        {
          id: 'system-list',
          type: 'list',
          readonly: true,
          label: 'System List',
          uid: 'd1ac4ed6d65c6c5b',
          content: [],
        },
        {
          id: 'signature',
          type: 'list',
          readonly: false,
          label: 'Signature',
          uid: '1848a6126f8f1403',
          content: [
            {
              id: 'interactive-canvas-html',
              type: 'component',
              component: 'InteractiveCanvas',
              readonly: false,
              label: 'Interactive Canvas',
              uid: 'b25a984636d42a56',
              content:
                '<h2>Sign in the area below</h2>\n<p>By signing in the allocated space below, you indicate that you confirm that the information above is correct and that you accept the Terms and Conditions</p>\n<div class=`interactive-canvas` data-message=`Please sign in the area below`></div>',
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '613cbb8ace176b7a',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'bef89980c6ae1234',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'c33afdaa5239870c',
                  content: '<p>Bloom</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: 'b25aa5e49e79acdf',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'fb3a74d8b4c60af2',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Ladycare Enhanced Payment Details',
    uri: 'ladycare-plus/quote',
    template: 'ladycare-enhanced-app-template',
    class: 'ladycare-enhanced-payment-details',
  },
  'stop-order-details': {
    text: [],
    buttons: [
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'payment-details',
      type: 'list',
      readonly: false,
      label: 'Payment Details',
      uid: 'e4fdab73d12db02a',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '53606e9c53fc5262',
          content: '<h2>Payment Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '493a034ea85c537a',
          content:
            '<p>Please complete your preferred payment method and payment details below.</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '373c5662bc08cf41',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#additional'>Additional</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='done clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='done clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'stop-order-details',
          type: 'list',
          readonly: false,
          label: 'Stop Order Details',
          uid: '6bd977fde75cac31',
          content: [
            {
              id: 'employer-organisation',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Employer Organisation',
              uid: '583c1096a7303045',
              content: '',
              publishChange: true,
              errors: ['*'],
              options: [
                '',
                'Abokobi Area Rural Bankstaff',
                'Accra Metro Assembly',
                'Adansi Rural Bank',
                'Advans Ghana',
                'Advent Press',
                'African Regent Hotel',
                'Agave Rural Bank',
                'Agric Development Bank',
                'Ahafo Ano Premier Rural Bank',
                'Ahantaman Rural Bankâ ',
                'Akaa Security Services',
                'Akatakyiman Rural Bank',
                'Akim Bosome Rural Bank',
                'Akwapem Rural Bank',
                'Aluworks',
                'Ama Dansowaa Clinic',
                'Amanano Rural Bank',
                'Amansie West Rural Bank',
                'Amatin & Kasei Comm Bank',
                'Antrak Ghana Ltd',
                'Anum Rural Bank Ltd',
                'Apex Bank',
                'Ashante Akyem Rural Bank',
                'Asokore Rural Bank Ltd - Kumasi',
                'Asutifi Rural Bank Limited',
                'Atlantic Int. Holding Co',
                'Atwima Kwanwoma Rural Bank',
                'Atwima Rural Bank',
                'Auto Parts Limited',
                'Awutu Emasa Rural Bank',
                'Ayrton Drug Manufacturing Limited',
                'Bank of Ghana',
                'Baptist Medical Centre',
                'Barge Operators and Allied Services Ltd',
                'Benso Oil Palm Plantationâ ',
                'Bessfa Rural Bank',
                'Bible Society of Ghana',
                'Bonzali Rural Bank',
                'Bosomtwe Rb',
                'Bureau of National Communication',
                'Bureau of National Investigations',
                'Busua Beach Resortâ ',
                'Capital Rural Bank',
                'Carmeuse Lime Productâ ',
                'Cejose Wisdom Int. School',
                'Chemico Limited',
                'Chirano Gold Mines',
                'Christ Ebenezer',
                'Church Hill of God',
                'Cocoa Marketiing Company Ltd',
                'Cocoa Processing Comp',
                'Controller',
                'Cssvd Control Unit',
                'Dangme Rural Bank Ltd - Staff',
                'De Youngsters International School Ltd',
                'Deoke Foundation Schools',
                'Derma Area Rural Bank',
                'Dizengoff Ghana Ltd',
                'Dynamic Insurance Brokers',
                'Ebennezer Osei Brenya Enterprise',
                'Ejuraman Rural Bank',
                'Electricity Company of Ghana',
                'Elmina Beach Resort',
                'Englebert School',
                'Enterprise Funeral Services',
                'Enterprise Group Ltd',
                'Enterprise Insurance',
                'Enterprise Life Reps',
                'Enterprise Life Staff',
                'Enterprise Properties Ltd',
                'Enterprise Trustees Limited',
                'Epa',
                'Eskay Therapeutics Ltd',
                'Fiagya Rural Bank Ltd',
                'Fiaseman Rural Bankâ ',
                'Fiesta Royale Hotel',
                'First National Savings and Loansâ ',
                'Forces Pay Office',
                'Ga East Municipal Assembly',
                'Ga Rural Bank',
                'Ga Rural Customers',
                'Gafco',
                'Garden City - Multi Credit',
                'Gcb Bank Ltd Staff',
                'Ghana Airport Company Ltd.',
                'Ghana Bauxite Company Limted',
                'Ghana Cement',
                'Ghana Chamber of Mines',
                'Ghana Civil Aviation Authority',
                'Ghana Cocoa Board',
                'Ghana Grid Company',
                'Ghana Heavy Equipment Limited',
                'Ghana Link Network Services Ltd',
                'Ghana Maritime Authority',
                'Ghana Medical School',
                'Ghana Oil Co. Ltd',
                'Ghana Police Service',
                'Ghana Post',
                'Ghana Railway Co. Ltd',
                'Ghana Re Company Limited',
                'Ghana Revenue Authority',
                'Ghana Standard Board',
                'Ghana Union Conference of s.d.a.',
                'Gihoc Distilleries Company Limited',
                'Gimpa',
                'Globeserve Ministry Intâ ',
                'Golden Exotics Ltd',
                'Goldengate Services Ltd',
                'Gpha - Takoradi',
                'Gpha - Tema',
                'Grace Baptist School - Kumasi',
                'Guiness Ghana Ltd',
                'Gwcl - Accra East',
                'Gwcl - Accra West',
                'Gwcl - Ashanti North',
                'Gwcl - Ashanti Production',
                'Gwcl - Ashanti South',
                'Gwcl - Cape Coast',
                'Gwcl - Greater Accra Region Production',
                'Gwcl - Head Office',
                'Gwcl - Koforidua',
                'Gwcl - Sunyani',
                'Gwcl - Takoradi',
                'Gwcl - Tema',
                'Hobats Clinic',
                'Holiday Inn Accra',
                'Home Finance Company Bank Ltd',
                'House of Compassion Ministries',
                'Japan Motors Trading Company',
                'Juaben Rural Bank',
                'Jubilee Shipping Services Gh Ltd',
                'k.n.u.s.t',
                'Kaaseman Rural Bank Ltd',
                'Kessben',
                'Kingsgroup of Companies',
                'Kintampo Health Research Centre',
                'Koforidua Stop Order Walk In',
                'Korle Bu Teaching Hospital',
                'Krane Contsruction',
                'Krobo Danish Association',
                'Kuapa Kokoo',
                'Kumawuman Rural Bnk',
                'Kwamaman Rural Bank',
                'La Nkwantanang Madina Municipal Assembly',
                'Labadi Beach Hotel',
                'Life Healthcare Medical Dental and Optical Clinic',
                'Living Star School',
                'Lordship Insurance Brokers',
                'Lower Pra Rural Bank',
                'Maxam Ghana Ltd',
                'Mechanical Lloyd',
                'Metromass',
                'Mojo Investment Ltd',
                'Mondial Veneer Gh. Ltd',
                'Mumuada Rural Bank',
                'Nafana Rural Bank Ltd',
                'National Security',
                'Nexans',
                'Nsoatreman Rural Bank',
                'Nthc Properties Ltd',
                'Nwabiagya Rural Bank',
                'Okomfo Anokye Rural Bank Staff',
                'Opportunity Int',
                'Parliament',
                'Pbc Ltd',
                'Pentecost Preparatory Schoolâ ',
                'Pentecost University College',
                'Phyto Riker',
                'Poly Products',
                'Presbyterian Womens Center - Abokobi',
                'Prince of Peace',
                'Quality Control Division (Cocobod)',
                'Regional Maritime Academy',
                'Ridge Church School',
                'Safebound Company Limited - Tema',
                'Sakworg Company Ltd',
                'Samartex Timber and Plywood Company',
                'Sandvik Mining and Construction Limited',
                'Scanbech Ghana Ltd',
                'Sdv Ghana',
                'Securities Discount Company Limited',
                'Sekyedumase Rural Bank',
                'Sekyere Rural Bank',
                'Services Intergrity Savings and Loans',
                'Sgs Laboratory Services',
                'Sg Ssb',
                'Silver Star Auto Ltd',
                'Sinapi Aba Trust',
                'Sofaamy Company Limited',
                'Sos Childrens Village Ghana',
                'South Birim Rural Bank',
                'South Central Conference of Sda',
                'Special Ice Company Ltd',
                'Ssnit',
                'St Ambrose College',
                'St Michaels Hospital Pramso',
                'Stellar Logistic',
                'Sunyani Cluster Icps',
                'Takoradi Flour Mill Ltd',
                'Takoradi Int. Co.',
                'Tct',
                'Tema Development Corp.',
                'Tema Parents Association School',
                'Tesano Baptist Church',
                'The Church of Pentecost',
                'Toende Rural Bank',
                'Trasacco',
                'Twifo Oil Palm Plantation',
                'Type Company Ltd',
                'Unilever',
                'University College of Education',
                'University for Development Studies',
                'University of Energy and Natural Resources',
                'University of Ghana - Legon',
                'Upper Amenfi Rural Bank',
                'Upper Manya Kro Rural Bank',
                'Utrak Savings and Loans',
                'Valley View',
                'Valley View University Basic School',
                'Vat Service',
                'Volta Hotel',
                'Volta River Authority',
                'Waec - Headquarters',
                'Waec - Main',
                'West Africa Mills Co. Ltd',
                'Weto Rural Bank',
                'Winners Chapel Ghana',
                'Yaakson Herbal Centre',
                'Yarsako',
              ],
            },
            {
              id: 'employee-number',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Employee Number',
              uid: '17ff314b6165c883',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
          ],
        },
        {
          id: 'system-list',
          type: 'list',
          readonly: true,
          label: 'System List',
          uid: 'd1ac4ed6d65c6c5b',
          content: [],
        },
        {
          id: 'signature',
          type: 'list',
          readonly: false,
          label: 'Signature',
          uid: '1848a6126f8f1403',
          content: [
            {
              id: 'interactive-canvas-html',
              type: 'component',
              component: 'InteractiveCanvas',
              readonly: false,
              label: 'Interactive Canvas',
              uid: 'b25a984636d42a56',
              content:
                '<h2>Sign in the area below</h2>\n<p>By signing in the allocated space below, you indicate that you confirm that the information above is correct and that you accept the Terms and Conditions</p>\n<div class=`interactive-canvas` data-message=`Please sign in the area below`></div>',
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '613cbb8ace176b7a',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'bef89980c6ae1234',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'c33afdaa5239870c',
                  content: '<p>Bloom</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: 'b25aa5e49e79acdf',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'fb3a74d8b4c60af2',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Ladycare Enhanced Payment Details',
    uri: 'ladycare-plus/quote',
    template: 'ladycare-enhanced-app-template',
    class: 'ladycare-enhanced-payment-details',
  },
  'mobile-wallet-details': {
    text: [],
    buttons: [
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'payment-details',
      type: 'list',
      readonly: false,
      label: 'Payment Details',
      uid: 'a5e937d73149f923',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '53606e9c53fc5262',
          content: '<h2>Payment Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '493a034ea85c537a',
          content:
            '<p>Please complete your preferred payment method and payment details below.</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '373c5662bc08cf41',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#additional'>Additional</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='done clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='done clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'system-list',
          type: 'list',
          readonly: false,
          label: 'System List',
          uid: '51ec63fbc00239ee',
          content: [
            {
              id: 'mobile-wallet-details',
              type: 'list',
              readonly: false,
              label: 'Mobile Wallet Details',
              uid: '2d34ee1c0b75f4a2',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '7577327f9a279ee2',
                  content: '<p>Please provide your mobile wallet details</p>\n',
                },
                {
                  id: 'mobile-wallet-network-provider',
                  type: 'field',
                  elementType: 'select',
                  readonly: false,
                  label: 'Mobile Wallet Network Provider',
                  uid: '3a6d7817942bbe73',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Mobile Wallet Network Provider',
                  options: [
                    '',
                    'Vodafone',
                    'Mtn',
                    'Tigo',
                    'Airtel',
                    'Expresso',
                    'Glo Mobile',
                  ],
                },
                {
                  id: 'mobile-wallet-number',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Mobile Wallet Number',
                  uid: '165034a17f3ef9dd',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Mobile Wallet Number',
                  inputType: 'text',
                },
              ],
            },
          ],
        },
        {
          id: 'signature',
          type: 'list',
          readonly: false,
          label: 'Signature',
          uid: '1848a6126f8f1403',
          content: [
            {
              id: 'interactive-canvas-html',
              type: 'component',
              component: 'InteractiveCanvas',
              readonly: false,
              label: 'Interactive Canvas',
              uid: 'b25a984636d42a56',
              content:
                '<h2>Sign in the area below</h2>\n<p>By signing in the allocated space below, you indicate that you confirm that the information above is correct and that you accept the Terms and Conditions</p>\n<div class=`interactive-canvas` data-message=`Please sign in the area below`></div>',
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '613cbb8ace176b7a',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'bef89980c6ae1234',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'c33afdaa5239870c',
                  content: '<p>Bloom</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: 'b25aa5e49e79acdf',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'fb3a74d8b4c60af2',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Ladycare Enhanced Payment Details',
    uri: 'ladycare-plus/quote',
    template: 'ladycare-enhanced-app-template',
    class: 'ladycare-enhanced-payment-details',
  },
  'upload-documents': {
    text: [],
    buttons: [
      {
        label: 'Upload ID document',
        id: 'upload-id-document',
        uid: '69a53b6758f4ff80',
        control: false,
      },
      {
        label: 'Upload Service Certificate Document',
        id: 'upload-service-certificate-document',
        uid: 'bloom-svc-cert-btn',
        control: false,
        invisible: true,
      },
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'upload-documents',
      type: 'list',
      readonly: true,
      label: 'Upload Documents',
      uid: 'ea1e25c0056417ac',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '2dd71fd55a00cef9',
          content: '<h2>Upload Documents</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'f4179312612d1ce4',
          content:
            '<p>Please upload the necessary documentation or proceed to the next page if you would like to provide it later.</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: 'e567849ef903ec0e',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#additional'>Additional</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='done clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='done clickable'><a href='#payment'>Payment</a></li>\n<li class='done clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'documents-list',
          type: 'list',
          readonly: true,
          label: 'Documents List',
          uid: '8a30a43b57bb332b',
          content: [
            {
              id: 'system-field-outcome',
              type: 'html',
              readonly: true,
              label: '',
              uid: '7721dd56ec3e43de',
              content:
                "<p><a href='#upload-id-document' class=''>ID Document <span>Re Upload</span></a></p>\n",
            },
            {
              content:
                '<p><a class="button" href="#upload-service-certificate-document" >Upload Service Certificate Document</a></p>\n',
              id: 'system-field-outcome',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'bloom-svc-cert-link',
              invisible: true,
            },
            {
              content:
                '<p class="error-message" style="color: red; margin-top: 5px;">Service Certificate Document is required</p>\n',
              id: 'service-certificate-error',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'bloom-svc-cert-error',
              invisible: true,
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '9ffc13515f446e28',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: '75bfd2d66118bda2',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'd55c7f32a8411d73',
                  content: '<p>Bloom</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '568f821040a6fa07',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'e8d4b11a9bdd5075',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Ladycare Enhanced Upload Documents',
    uri: 'ladycare-plus/upload-documents',
    template: 'ladycare-enhanced-app-template',
    class: 'ladycare-enhanced-upload-documents',
  },
  'upload-document-pages': {
    modal: true,
    buttons: [
      {
        control: false,
        id: 'add-page',
        label: 'Add Page',
        uid: '1a5450d98db152d6',
      },
      {
        control: true,
        id: 'abort',
        label: 'Abort',
        uid: 'e11279c7f15a77ea',
      },
      {
        control: true,
        id: 'continue',
        label: 'Continue',
        uid: '0d54090d869303f6',
      },
    ],
    item: {
      content: [
        {
          content:
            '<p>Please upload your document below. If it consists of multiple pages, please upload all of them together.</p>\n',
          id: 'system-field-outcome',
          label: '',
          readonly: true,
          type: 'html',
          uid: '8872705861783d2d',
        },
        {
          content: [],
          id: 'uploads',
          label: 'Uploads',
          readonly: false,
          type: 'table',
          uid: '2d999fbaaefb947c',
        },
        {
          content:
            '<p><a class="button add-page-button" href="#add-page">Add Page</a></p>\n',
          id: 'system-constant',
          label: '',
          readonly: true,
          type: 'html',
          uid: 'a47ce0e3f28e09c5',
        },
      ],
      id: 'upload-section',
      label: 'Upload Section',
      readonly: false,
      type: 'list',
      uid: '74b77d523e9f9b6d',
    },
    class: 'upload-layout',
    context: 'Upload Layout',
    template: '',
    text: [],
    title: 'Public Access \n Welcome to Elac',
    uri: 'upload-document/file/new',
  },
  'acceptance-screen': {
    text: [],
    buttons: [
      {
        label: 'Submit',
        id: 'submit',
        uid: 'ef8243ce592928b2',
        control: false,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'acceptance',
      type: 'list',
      readonly: false,
      label: 'Acceptance',
      uid: 'ae0cf013b18ef95c',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '981d430846482fe8',
          content: '<h2>Summary</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '8b470d282f194b34',
          content: '<p>Please review the information below</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '65dbe261db324f63',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='done clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='done clickable'><a href='#payment'>Payment</a></li>\n<li class='done clickable'><a href='#uploads'>Uploads</a></li>\n<li class='done clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'summary',
          type: 'list',
          readonly: true,
          label: 'Summary',
          uid: '318ea427b694ba67',
          content: [
            {
              id: 'contract-id',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Application Reference Number',
              uid: '0d3a5727942b5c07',
              content: '',
              inputType: 'text',
            },
            {
              id: 'life-assured-identification',
              type: 'list',
              readonly: true,
              label: 'Life Assured Identification',
              uid: '021bb45dc16b615c',
              content: [
                {
                  id: 'first-names',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'First Names',
                  uid: '19db8e2701c35020',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'surname',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Surname',
                  uid: 'a013262d8a696028',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'date-of-birth',
                  type: 'integer',
                  elementType: 'input',
                  readonly: true,
                  label: 'Date Of Birth',
                  uid: '4fbcb5f5033fa4a4',
                  content: '',
                  inputType: 'number',
                },
                {
                  id: 'marital-status',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Marital Status',
                  uid: '3ec2074800e0e60c',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'gender',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Gender',
                  uid: '25970a93188b88d4',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'title',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Title',
                  uid: 'edfc4291772f81bf',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'ghanaian',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Ghanaian',
                  uid: '9456d02f16087d0e',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'idpassport-number',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'ID Number',
                  uid: '8fa4cdcb279c6d77',
                  content: '',
                  inputType: 'text',
                },
              ],
            },
            {
              id: 'life-assured-contact-details',
              type: 'list',
              readonly: true,
              label: 'Life Assured Contact Details',
              uid: 'da102af90d28eb63',
              content: [
                {
                  id: 'cell-phone',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Cell Phone',
                  uid: '463cf8166edfdf3e',
                  content: '',
                  inputType: 'tel',
                },
                {
                  id: 'email',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Email',
                  uid: 'c58170cdbb730541',
                  content: '',
                  inputType: 'email',
                },
              ],
            },
            {
              id: 'trustee-identification',
              type: 'list',
              readonly: true,
              label: 'Trustee Identification',
              uid: '7e368fad7707f08a',
              content: [
                {
                  id: 'first-names',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'First Names',
                  uid: '77e332eda7f5bf95',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'surname',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Surname',
                  uid: '0482fb968df91585',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'date-of-birth',
                  type: 'integer',
                  elementType: 'input',
                  readonly: true,
                  label: 'Date Of Birth',
                  uid: '890da04c904445a0',
                  content: '',
                  inputType: 'number',
                },
                {
                  id: 'title',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Title',
                  uid: '4b45321ef80dd7f9',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'relationship',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Relationship',
                  uid: '2dbd3a6d1c1ade2b',
                  content: '',
                  inputType: 'text',
                },
              ],
            },
            {
              id: 'trustee-contact-details',
              type: 'list',
              readonly: true,
              label: 'Trustee Contact Details',
              uid: 'c691bb424fec40d3',
              content: [
                {
                  id: 'cell-phone',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Cell Phone',
                  uid: '1204756395d2077f',
                  content: '',
                  inputType: 'tel',
                },
              ],
            },
            {
              id: 'children-details',
              type: 'table',
              readonly: true,
              label: 'Children Details',
              uid: '09c4ae50c6c19e2c',
              content: [],
            },
            {
              id: 'beneficiary-details',
              type: 'table',
              readonly: true,
              label: 'Beneficiary Details',
              uid: '2fd547f1b742feac',
              content: [],
            },
            {
              id: 'owner-identification',
              type: 'list',
              readonly: true,
              label: 'Owner Identification',
              uid: 'af455230c829e2c0',
              content: [
                {
                  id: 'first-names',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'First Names',
                  uid: '0c848483d1f5ecb2',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'surname',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Surname',
                  uid: 'f335234993837700',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'date-of-birth',
                  type: 'integer',
                  elementType: 'input',
                  readonly: true,
                  label: 'Date Of Birth',
                  uid: '1d962bcc3e03bb64',
                  content: '',
                  inputType: 'number',
                },
                {
                  id: 'marital-status',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Marital Status',
                  uid: 'c8e7509a1766f298',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'gender',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Gender',
                  uid: '4679a7cb28d97fbb',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'title',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Title',
                  uid: 'ea57d6e05576876b',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'ghanaian',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Ghanaian',
                  uid: 'd4859a26e9f5895f',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'idpassport-number',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'ID Number',
                  uid: '81ea53cae2a931b5',
                  content: '',
                  inputType: 'text',
                },
              ],
            },
            {
              id: 'contract-id',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Application Reference Number',
              uid: 'c8ea38a34a11a142',
              content: '',
              inputType: 'text',
            },
          ],
        },
        {
          id: 'interactive-canvas-html',
          type: 'component',
          component: 'InteractiveCanvas',
          readonly: false,
          label: 'Interactive Canvas',
          uid: '1fcad0e41194c3d1',
          content:
            '<h2>Sign in the area below</h2>\n<p>By signing in the allocated space below, you indicate that you confirm that the information above is correct and that you accept the Terms and Conditions</p>\n<div class=`interactive-canvas` data-message=`Please sign in the area below`></div>',
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '0068104b331e59b4',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: '875ec5a1a4288439',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'a23069595dec23ce',
                  content: '<p>Bloom</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: 'd39549556da24b71',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: '48f061e288e60d8b',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Ladycare Enhanced Acceptance Screen',
    uri: 'ladycare-plus/acceptance',
    template: 'ladycare-enhanced-acceptance-screen',
    class: 'ladycare-enhanced-acceptance-screen',
  },
  'forces-pay-office-additional-information': {
    text: [],
    buttons: [
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
    ],
    item: {
      id: 'forces-pay-office-details',
      type: 'list',
      readonly: false,
      label: 'Forces Pay Office Details',
      uid: 'bloom-fpo-details',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'bloom-fpo-header',
          content: '<h2>Forces Pay Office Additional Information</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'bloom-fpo-subheader',
          content: '<p>Please complete the additional information below.</p>\n',
        },
        {
          id: 'personnel-information',
          type: 'list',
          readonly: false,
          label: 'Personnel Information',
          uid: 'bloom-personnel-info',
          content: [
            {
              id: 'first-names',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'First Names',
              uid: 'bloom-first-names',
              content: '',
              inputType: 'text',
            },
            {
              id: 'surname',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Surname',
              uid: 'bloom-surname',
              content: '',
              inputType: 'text',
            },
            {
              id: 'svc-number',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Svc Number',
              uid: 'bloom-svc-number',
              content: '',
              inputType: 'text',
            },
            {
              id: 'armed-forces-rank',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Armed Forces Rank',
              uid: 'bloom-armed-forces-rank',
              content: '',
              publishChange: true,
              markers: [],
              errors: ['*'],
              options: [
                '',
                'Senior Civilian',
                'Junior Civilian',
                'Soldier',
                'Officer',
              ],
            },
            {
              id: 'unit',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Unit',
              uid: 'bloom-unit',
              content: '',
              publishChange: true,
              markers: [],
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'ecowas-id-number',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'ECOWAS ID Number',
              uid: 'bloom-ecowas-id-number',
              content: '',
              publishChange: true,
              markers: [],
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'cell-phone',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Cell Phone',
              uid: 'bloom-cell-phone',
              content: '',
              inputType: 'tel',
            },
            {
              id: 'date',
              type: 'integer',
              elementType: 'input',
              readonly: true,
              label: 'Date',
              uid: 'bloom-personnel-date',
              content: '',
              inputType: 'number',
            },
          ],
        },
        {
          id: 'insurance-details',
          type: 'list',
          readonly: true,
          label: 'Insurance Details',
          uid: 'bloom-insurance-details',
          content: [
            {
              id: 'policy-name',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Policy Name',
              uid: 'bloom-policy-name',
              content: 'Bloom',
              inputType: 'text',
            },
            {
              id: 'frequency',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Frequency',
              uid: 'bloom-frequency',
              content: '',
              inputType: 'text',
            },
            {
              id: 'date-of-first-deduction',
              type: 'integer',
              elementType: 'input',
              readonly: true,
              label: 'Date Of First Deduction',
              uid: 'bloom-first-deduction',
              content: '',
              inputType: 'number',
            },
          ],
        },
        {
          id: 'company-details',
          type: 'list',
          readonly: true,
          label: 'Company Details',
          uid: 'bloom-company-details',
          content: [
            {
              id: 'company-name',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Company Name',
              uid: 'bloom-company-name',
              content: 'Enterprise Life Assurance Co Ltd',
              inputType: 'text',
            },
            {
              id: 'branch-name',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Branch Name',
              uid: 'bloom-branch-name',
              content: 'High Street',
              inputType: 'text',
            },
            {
              id: 'date',
              type: 'integer',
              elementType: 'input',
              readonly: true,
              label: 'Date',
              uid: 'bloom-company-date',
              content: '',
              inputType: 'number',
            },
            {
              id: 'representative-name',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Representative Name',
              uid: 'bloom-representative-name',
              content: 'Justice Asenso Buabeng',
              inputType: 'text',
            },
            {
              id: 'telephone-number',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Telephone Number',
              uid: 'bloom-telephone-number',
              content: '0307084444',
              inputType: 'tel',
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Forces Pay Office Additional Information',
    uri: 'bloom/forces-pay-office-additional-information',
    class: 'forces-pay-office-additional-information',
  },
  'payment-details-verification': {
    text: [],
    buttons: [
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
    ],
    item: {
      id: 'payment-details-verification',
      type: 'list',
      readonly: false,
      label: 'Payment Details Verification',
      uid: 'bloom-pdv-main',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'bloom-pdv-header',
          content: '<h2>Payment Details Verification</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'bloom-pdv-subheader',
          content:
            '<p>Please verify the details below and sign to confirm.</p>\n',
        },
        {
          id: 'payer-employment-details',
          type: 'list',
          readonly: true,
          label: 'Payer Employment Details',
          uid: 'bloom-pdv-employment',
          content: [
            {
              id: 'employer-organisation',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Employer Organisation',
              uid: 'bloom-pdv-employer',
              content: '',
              inputType: 'text',
            },
            {
              id: 'employee-number',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Employee Number',
              uid: 'bloom-pdv-employee-num',
              content: '',
              inputType: 'text',
            },
            {
              id: 'paypoint-contract-id',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Paypoint Contract ID',
              uid: 'bloom-pdv-paypoint',
              content: 'GH1P0000330',
              inputType: 'text',
            },
          ],
        },
        {
          id: 'forces-pay-office-details',
          type: 'list',
          readonly: true,
          label: 'Forces Pay Office Details',
          uid: 'bloom-pdv-fpo',
          content: [
            {
              id: 'cell-phone',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Cell Phone',
              uid: 'bloom-pdv-cell',
              content: '',
              inputType: 'tel',
            },
            {
              id: 'date',
              type: 'integer',
              elementType: 'input',
              readonly: true,
              label: 'Date',
              uid: 'bloom-pdv-date',
              content: '',
              inputType: 'number',
            },
            {
              id: 'first-names',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'First Names',
              uid: 'bloom-pdv-first-names',
              content: '',
              inputType: 'text',
            },
            {
              id: 'surname',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Surname',
              uid: 'bloom-pdv-surname',
              content: '',
              inputType: 'text',
            },
            {
              id: 'premium-amount',
              type: 'amount',
              elementType: 'input',
              readonly: true,
              label: 'Premium Amount',
              uid: 'bloom-pdv-premium',
              content: '',
              inputType: 'number',
            },
            {
              id: 'frequency',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Frequency',
              uid: 'bloom-pdv-frequency',
              content: '',
              inputType: 'text',
            },
            {
              id: 'date-of-first-deduction',
              type: 'integer',
              elementType: 'input',
              readonly: true,
              label: 'Date Of First Deduction',
              uid: 'bloom-pdv-first-deduction',
              content: '',
              inputType: 'number',
            },
            {
              id: 'company-name',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Company Name',
              uid: 'bloom-pdv-company',
              content: '',
              inputType: 'text',
            },
            {
              id: 'branch-name',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Branch Name',
              uid: 'bloom-pdv-branch',
              content: '',
              inputType: 'text',
            },
            {
              id: 'company-date',
              type: 'integer',
              elementType: 'input',
              readonly: true,
              label: 'Company Date',
              uid: 'bloom-pdv-company-date',
              content: '',
              inputType: 'number',
            },
            {
              id: 'representative-name',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Representative Name',
              uid: 'bloom-pdv-rep-name',
              content: '',
              inputType: 'text',
            },
            {
              id: 'telephone-number',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Telephone Number',
              uid: 'bloom-pdv-telephone',
              content: '',
              inputType: 'tel',
            },
            {
              id: 'company-signed-date',
              type: 'integer',
              elementType: 'input',
              readonly: true,
              label: 'Company Signed Date',
              uid: 'bloom-pdv-company-signed',
              content: '',
              inputType: 'number',
            },
            {
              id: 'signed-date',
              type: 'integer',
              elementType: 'input',
              readonly: true,
              label: 'Signed Date',
              uid: 'bloom-pdv-signed-date',
              content: '',
              inputType: 'number',
            },
            {
              id: 'svc-number',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Svc Number',
              uid: 'bloom-pdv-svc',
              content: '',
              inputType: 'text',
            },
            {
              id: 'armed-forces-rank',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Armed Forces Rank',
              uid: 'bloom-pdv-rank',
              content: '',
              inputType: 'text',
            },
            {
              id: 'unit',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Unit',
              uid: 'bloom-pdv-unit',
              content: '',
              inputType: 'text',
            },
          ],
        },
        {
          id: 'signature-section',
          type: 'list',
          readonly: false,
          label: 'Authorization And Declaration',
          uid: 'bloom-pdv-sig-section',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'bloom-pdv-sig-text',
              content:
                '<p>I hereby authorize my employer to deduct the premium from my salary and pay it to Enterprise Life Assurance Company Limited.</p>\n',
            },
            {
              id: 'interactive-canvas-html',
              type: 'component',
              component: 'InteractiveCanvas',
              readonly: false,
              label: 'Interactive Canvas Html',
              uid: 'bloom-pdv-sig-canvas',
              content:
                '<p><h2>Sign in the area below</h2></p>\n<p><p>By signing in the allocated space below, you indicate that you confirm that the information above is correct and that you accept the Terms and Conditions</p></p>\n<div class=`interactive-canvas` data-message=`Please sign in the area below`></div>',
              markers: [],
              errors: ['*'],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Payment Details Verification',
    uri: 'bloom/payment-details-verification',
    class: 'payment-details-verification',
  },
}

export const beneficiaryItem = (b, counter) => [
  {
    id: 'first-names',
    type: 'field',
    elementType: 'input',
    readonly: true,
    label: 'First Names',
    uid: `98e1d3dffb9e3b2b-${counter}`,
    content: b['first-names'] || '',
    inputType: 'text',
  },
  {
    id: 'surname',
    type: 'field',
    elementType: 'input',
    readonly: true,
    label: 'Surname',
    uid: `beba3163e260400e-${counter}`,
    content: b.surname || '',
    inputType: 'text',
  },
  {
    id: 'date-of-birth',
    type: 'integer',
    elementType: 'input',
    readonly: true,
    label: 'Date Of Birth',
    uid: `6de2cb4355eea214-${counter}`,
    content: b['date-of-birth'] || '',
    inputType: 'number',
  },
  {
    id: 'role',
    type: 'field',
    elementType: 'input',
    readonly: true,
    label: 'Role',
    uid: `018cc8560c18865d-${counter}`,
    content: b.role || '',
    inputType: 'text',
  },
  {
    id: 'gender',
    type: 'field',
    elementType: 'input',
    readonly: true,
    label: 'Gender',
    uid: `a23be93ff313e82f-${counter}`,
    content: b.gender || '',
    inputType: 'text',
  },
  {
    id: 'beneficiary-role',
    type: 'field',
    elementType: 'input',
    readonly: true,
    label: 'Beneficiary Role',
    uid: `ef581bcff27d766e-${counter}`,
    content: `Beneficiary-${counter + 1}`,
    inputType: 'text',
  },
  {
    id: 'benefit-split',
    type: 'real',
    elementType: 'input',
    readonly: true,
    label: 'Benefit Split',
    uid: `eac9af9f270f00ac-${counter}`,
    content: b['benefit-split'] || '',
    inputType: 'number',
  },
]

export const healthDetailsPrefix = [
  {
    id: 'system-constant',
    type: 'html',
    readonly: true,
    label: '',
    uid: '25e8ba914ed925d9',
    content: '<h2 id="health-description">Health description</h2>\n',
  },
  {
    id: 'system-constant',
    type: 'html',
    readonly: true,
    label: '',
    uid: '4798836a7c99c3c0',
    content:
      '<p>If the answer is &quot;Yes&quot; to questions 2-6 on the previous page please provide details below.</p>\n',
  },
  {
    id: 'output-html',
    type: 'html',
    readonly: true,
    label: 'Output Html',
    uid: '065a26e9f05f3475',
    content:
      '<ol class="progress-indicator">\n<li class="done clickable"><a href="#cover">Cover</a></li>\n<li class="done clickable"><a href="#details">Details</a></li>\n<li class="done clickable"><a href="#underwriting">Underwriting</a></li>\n<li class="clickable"><a href="#payment">Payment</a></li>\n<li class="clickable"><a href="#uploads">Uploads</a></li>\n<li class="clickable"><a href="#summary">Summary</a></li>\n</ol>',
  },
]

function range(start, end) {
  return new Array(end - start + 1).fill(undefined).map((_, i) => i + start)
}

export const healthDetailsItem = (count) =>
  range(1, count).map((counter) => ({
    id: `health-concern-${counter}`,
    type: 'list',
    readonly: false,
    label: `Health Concern ${counter}`,
    uid: `39858c9af82649b5-${counter}`,
    content: [
      {
        id: `complaints-${counter}`,
        type: 'field',
        elementType: 'select',
        readonly: false,
        label: 'Complaints',
        uid: `8faa00483cc51798-${counter}`,
        content: '',
        publishChange: true,
        errors: ['*'],
        tooltip: 'Complaints',
        options: [
          '',
          'Alcohol-Past-Consumption',
          'Arthritis',
          'Cancer',
          'Chest-Or-Respiratory-Disorder',
          'Declined-Or-Loaded',
          'Diabetes',
          'Good-Health',
          'Hazardous-Pursuits',
          'Heart-Problems',
          'Hereditary-Diseases',
          'High-Blood-Pressure',
          'Hiv-Positive',
          'Kidney-Problems',
          'Medical-Examination',
          'Mental-Illness',
          'Nervous-System-Problems',
          'Other-Disorders',
          'Prescribed-Medication',
          'Previous-Regular-Treatment',
          'Previous-Surgery',
          'Respiratory-Problems',
          'Sexually-Transmitted-Diseases',
          'Skeletal-Problems',
          'Stable-Weight',
          'Stomach-Problems',
        ],
      },
      {
        id: `complaint-description-${counter}`,
        type: 'field',
        elementType: 'input',
        readonly: false,
        label: 'Complaint Description',
        uid: `26a740e28b18766f-${counter}`,
        content: '',
        publishChange: true,
        errors: ['*'],
        inputType: 'text',
      },
      {
        id: `medical-condition-date-${counter}`,
        type: 'component',
        elementType: 'input',
        readonly: false,
        label: 'Medical Condition Date',
        uid: `f5ec4cc32a4803e5-${counter}`,
        content: '',
        publishChange: true,
        errors: [
          'Please ensure the medical condition date is not selected in the future.',
        ],
        inputType: 'date',
        component: 'DateSelector',
        maxYear: thisYear,
      },
      {
        id: `health-results-${counter}`,
        type: 'field',
        elementType: 'input',
        readonly: false,
        label: 'Health Results',
        uid: `8f07c239d4715901-${counter}`,
        content: '',
        publishChange: true,
        errors: ['*'],
        inputType: 'text',
      },
    ],
  }))

export const quotationPanel = {
  id: 'quotation-panel',
  type: 'list',
  readonly: true,
  label: 'Quotation Panel',
  uid: 'f92bebf5c8e3799e',
  content: [
    {
      id: 'quotation-information',
      type: 'list',
      readonly: true,
      label: 'Quotation Information',
      uid: '874801c29a27d8e3',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '9a9da8b55542d233',
          content: '<p>Bloom</p>\n',
        },
        {
          id: 'benefit-rate',
          type: 'amount',
          elementType: 'input',
          readonly: true,
          label: 'Benefit Rate',
          uid: '234f9a4cc9b1210c',
          content: '0.00',
          inputType: 'number',
        },
        {
          id: 'premium',
          type: 'amount',
          elementType: 'input',
          readonly: true,
          label: 'Premium',
          uid: 'd3b718fa91ff280e',
          content: '0.00',
          inputType: 'number',
        },
      ],
    },
  ],
}

export const benefitSplitItem = (b, counter) => ({
  id: `beneficiary-${counter + 1}`,
  type: 'list',
  readonly: false,
  label: `Beneficiary-${counter + 1}`,
  uid: `8dca6eb49ac65bcc-${counter}`,
  content: [
    {
      id: 'system-constant',
      type: 'html',
      readonly: true,
      label: '',
      uid: `7259b360e6ec1490-${counter}`,
      content: `<p>${b['first-names']}</p>\n`,
    },
    {
      id: `beneficiary-split-${counter + 1}`,
      type: 'field',
      elementType: 'input',
      readonly: false,
      label: 'Beneficiary Split',
      uid: `8644e07220d3617d-${counter}`,
      content: b['benefit-split'] || '',
      publishChange: true,
      inputType: 'text',
    },
  ],
})

const findOccurance = (life, position, lives) => {
  let occuranceString = ''
  let occurance = 1
  for (let i = position - 1; i >= 0; i--) {
    if (lives[i].relationship === life.relationship) {
      occurance += 1
    }
  }
  occuranceString = ` ${occurance}`
  return occuranceString
}

export const additionalLife = (life, position, lives) => {
  const lifeRelationship = `${life.relationship}${findOccurance(
    life,
    position,
    lives
  )}`
  return [
    createItem('Relationship', {
      content: lifeRelationship,
      elementType: 'input',
      inputType: 'text',
      readonly: true,
      type: 'field',
    }),
    createItem('Age Of Child', {
      content: life['age-of-child'],
      elementType: 'input',
      inputType: 'number',
      readonly: true,
      type: 'integer',
    }),
    createItem('system-field-outcome', {
      content: `<p><a class="remove" href="#remove-child#${slugify(
        lifeRelationship
      )}">Remove</a><a class="edit" href="#edit-child#${slugify(
        lifeRelationship
      )}">Edit</a></p>\n`,
      label: '',
      readonly: true,
      type: 'html',
    }),
  ]
}

export const buttonFromLifeAssured = (life, position, lives) =>
  createButton(`${life.relationship}${findOccurance(life, position, lives)}`)

export const idFromLifeAssured = (life, position, lives) =>
  slugify(`${life.relationship}${findOccurance(life, position, lives)}`)

let ageRange = () => {
  const cached = {}
  return (start, end) => {
    if (start > end) {
      start = end
    }
    const k = `[${start}-${end}]`
    if (k in cached) {
      return cached[k]
    }
    const range = ['', `${start}`]
    for (let val = start + 1; val <= end; val++) {
      range.push(`${val}`)
    }
    cached[k] = range
    return range
  }
}
ageRange = ageRange()

export const familyMemberOptions = (age) => ({
  'Unborn Baby': {
    options: ageRange(0, 0),
  },
  Son: {
    options: ageRange(0, 21),
  },
  Daughter: {
    options: ageRange(0, 21),
  },
})
export const familyMemberLabels = Object.keys(familyMemberOptions(0))

export const createFamilyMember = (
  relationship,
  ageofchild,
  freechildcover,
  babycarebenefit
) => ({
  relationship,
  'age-of-child': ageofchild,
  'free-child-cover': freechildcover,
  'babycare-benefit': babycarebenefit,
  'first-names': null,
  surname: null,
  'date-of-birth': null,
  gender: null,
})

export const childTablePrefix = [
  {
    id: 'system-constant',
    type: 'html',
    readonly: true,
    label: '',
    uid: '8d7094b0e1a70f8d',
    content: '<h2>Children Details</h2>\n',
  },
  {
    id: 'system-constant',
    type: 'html',
    readonly: true,
    label: '',
    uid: '55af6ce2f56c315e',
    content: '<p>Please complete the details for your children below</p>\n',
  },
  {
    id: 'output-html',
    type: 'html',
    readonly: true,
    label: 'Output',
    uid: 'cef89aedd9f2b15f',
    content:
      "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#additional'>Additional</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
  },
  {
    id: 'system-outcome',
    type: 'html',
    readonly: true,
    label: 'Unborn Baby',
    uid: 'dc2796ed00e65f1e',
    content:
      "<p>Please note that you will be required to update your baby's details when it is born.</p>\n",
  },
]

export const childItem = (f, counter) => ({
  id: `child-${counter}`,
  type: 'list',
  readonly: false,
  label: f.relationship,
  uid: 'aacdc55c71cad068',
  content: [
    {
      id: 'system-field-outcome',
      type: 'html',
      readonly: true,
      label: '',
      uid: 'e74f06fa8830df68',
      content: `<p>Please provide the following information for your <strong>${f.relationship}</strong> aged <strong>${f['age-of-child']}</strong>.</p>\n`,
    },
    {
      id: `first-names-${counter}`,
      type: 'field',
      elementType: 'input',
      readonly: false,
      label: 'First Names',
      uid: 'c610fcbf2c51efe8',
      content: f['first-names'] || '',
      publishChange: true,
      errors: f['first-names'] ? [] : ['*'],
      inputType: 'text',
    },
    {
      id: `surname-${counter}`,
      type: 'field',
      elementType: 'input',
      readonly: false,
      label: 'Surname',
      uid: '374cd5be82a19a5e',
      content: f.surname || '',
      publishChange: true,
      errors: f.surname ? [] : ['*'],
      inputType: 'text',
    },
    {
      id: `date-of-birth-${counter}`,
      type: 'component',
      elementType: 'input',
      readonly: false,
      label: 'Date Of Birth',
      uid: '2fa465707e70aa81',
      content: f['date-of-birth'] || '',
      publishChange: true,
      inputType: 'date',
      component: 'DateSelector',
      maxYear: thisYear,
      errors: f['date-of-birth'] ? [] : ['*'],
    },
    {
      id: `gender-${counter}`,
      type: 'field',
      elementType: 'input',
      readonly: true,
      label: 'Gender',
      uid: 'd1bc4b74ede5f67d',
      content: f.gender || '',
      options: ['', 'Female', 'Male'],
    },
    {
      id: 'quotation-panel',
      type: 'list',
      readonly: true,
      label: 'Quotation Panel',
      uid: 'f9eeefae7148d048',
      content: [
        {
          id: 'quotation-information',
          type: 'list',
          readonly: true,
          label: 'Quotation Information',
          uid: '0c10f9551eb83db0',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '91c74d267c25e337',
              content: '<p>Bloom</p>\n',
            },
            {
              id: 'benefit-rate',
              type: 'amount',
              elementType: 'input',
              readonly: true,
              label: 'Benefit Rate',
              uid: 'e519bf55acdaa262',
              content: '0.00',
              inputType: 'number',
            },
            {
              id: 'premium',
              type: 'amount',
              elementType: 'input',
              readonly: true,
              label: 'Premium',
              uid: '8cc614e26f0ab3de',
              content: '0.00',
              inputType: 'number',
            },
          ],
        },
      ],
    },
  ],
})
